import { defineComponent as ke, openBlock as $, createElementBlock as Z, createElementVNode as ne, toDisplayString as Oe, createCommentVNode as se, normalizeClass as pe, renderSlot as ve, createBlock as we, unref as j, createVNode as Re, mergeProps as Ce, shallowRef as Sn, computed as W, toValue as nt, watch as He, reactive as ri, h as qs, getCurrentInstance as ii, inject as Wn, resolveComponent as Na, createPropsRestProxy as ga, resolveDynamicComponent as Nt, withCtx as _e, ref as ge, onMounted as kt, Transition as xn, normalizeProps as $t, guardReactiveProps as Rt, createTextVNode as Tt, toRef as Hi, normalizeStyle as Et, Teleport as ba, useSlots as cn, onUpdated as fo, onUnmounted as Ln, withModifiers as sa, Fragment as at, renderList as yt, useModel as Xa, mergeModels as _n, effectScope as js, useTemplateRef as ft, nextTick as Ya, createSlots as Ga, isRef as Ui, onBeforeUnmount as li, provide as oi, withDirectives as Qt, withKeys as si, vModelCheckbox as ho, vModelDynamic as qi, readonly as vo, vShow as ci, createStaticVNode as Zs, TransitionGroup as Ws, getCurrentScope as Xs, onScopeDispose as Ys, shallowReadonly as On, version as Gs, vModelRadio as Ks, toRefs as Ea, onServerPrefetch as Js, onBeforeMount as Qs, vModelText as ec } from "vue";
import { toArray as tc, unrefElement as mo, tryOnScopeDispose as go, refDebounced as nc, useTransition as ac, TransitionPresets as rc, useScrollLock as bo, onClickOutside as Ka, onKeyStroke as po, useEventListener as qt, useMediaQuery as ic, usePreferredReducedMotion as yo, useVibrate as wo, useTimeoutFn as ta, useIntervalFn as xo, useDebounceFn as lc, useElementSize as qr, useResizeObserver as oc, usePointerSwipe as sc } from "@vueuse/core";
import { isNotNestedPath as cc, cleanupNonNestedPath as uc, useForm as dc, useField as fc } from "vee-validate";
const hc = {
  key: 0,
  class: "lc-count-bubble"
}, jr = /* @__PURE__ */ ke({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), Z("div", hc, [
      ne("span", null, Oe(Math.min(e.count, 99)), 1)
    ])) : se("", !0);
  }
}), vc = "medium", gg = ["large", "medium", "small"], et = /* @__PURE__ */ ke({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: () => vc }
  },
  setup(e) {
    return (t, n) => ($(), Z("i", {
      "aria-hidden": "true",
      class: pe(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), bg = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clear",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "connection-slow",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "wifi-off",
  "winning",
  "winning-correction",
  "zoom"
], mc = { class: "lc-badge" }, pg = /* @__PURE__ */ ke({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", mc, [
      ve(t.$slots, "icon", {}, () => [
        e.icon ? ($(), we(j(et), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : se("", !0)
      ]),
      Re(j(jr), Ce({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      ve(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gc = (e) => e != null;
var ko = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Pa = /* @__PURE__ */ ko.join(","), So = typeof Element > "u", En = So ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ba = !So && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, za = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : za(t.parentNode));
  return a;
}, bc = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, _o = function(t, n, r) {
  if (za(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Pa));
  return n && En.call(t, Pa) && o.unshift(t), o = o.filter(r), o;
}, Va = function(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!za(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, h = Va(l, !0, r);
        r.flatten ? o.push.apply(o, h) : o.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = En.call(a, Pa);
        v && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !za(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (u && f) {
          var m = Va(u === !0 ? a.children : u.children, !0, r);
          r.flatten ? o.push.apply(o, m) : o.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, Eo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, yn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || bc(t)) && !Eo(t) ? 0 : t.tabIndex;
}, pc = function(t, n) {
  var r = yn(t);
  return r < 0 && n && !Eo(t) ? 0 : r;
}, yc = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Co = function(t) {
  return t.tagName === "INPUT";
}, wc = function(t) {
  return Co(t) && t.type === "hidden";
}, xc = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, kc = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Sc = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Ba(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = kc(o, t.form);
  return !i || i === t;
}, _c = function(t) {
  return Co(t) && t.type === "radio";
}, Ec = function(t) {
  return _c(t) && !Sc(t);
}, Cc = function(t) {
  var n, r = t && Ba(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var h, v, u;
      r = Ba(o), o = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = o) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(o));
    }
  }
  return i;
}, ji = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Tc = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), s = a.visibility;
  if (s === "hidden" || s === "collapse")
    return !0;
  var l = En.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (En.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = Ba(t);
        if (u && !u.shadowRoot && o(u) === !0)
          return ji(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if (Cc(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return ji(t);
  return !1;
}, Ac = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return En.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ha = function(t, n) {
  return !(n.disabled || wc(n) || Tc(n, t) || // For a details element with a summary, the summary element gets the focus
  xc(n) || Ac(n));
}, Zr = function(t, n) {
  return !(Ec(n) || yn(n) < 0 || !Ha(t, n));
}, Lc = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, To = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = pc(s, a), h = a ? To(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, h) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: h
    });
  }), r.sort(yc).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, $c = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Zr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Lc
  }) : r = _o(t, n.includeContainer, Zr.bind(null, n)), To(r);
}, Ic = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ha.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = _o(t, n.includeContainer, Ha.bind(null, n)), r;
}, Mn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return En.call(t, Pa) === !1 ? !1 : Zr(n, t);
}, Dc = /* @__PURE__ */ ko.concat("iframe:not([inert]):not([inert] *)").join(","), yr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return En.call(t, Dc) === !1 ? !1 : Ha(n, t);
};
function Wr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Oc(e) {
  if (Array.isArray(e)) return Wr(e);
}
function Zi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Ao(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Mc(e, t, n) {
  return (t = Bc(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Rc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Fc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wi(Object(n), !0).forEach(function(r) {
      Mc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nc(e) {
  return Oc(e) || Rc(e) || Ao(e) || Fc();
}
function Pc(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bc(e) {
  var t = Pc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ao(e, t) {
  if (e) {
    if (typeof e == "string") return Wr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Wr(e, t) : void 0;
  }
}
var Kt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Kt.getActiveTrap(t);
    n !== r && Kt.pauseTrap(t);
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Kt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, zc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Vc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ra = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Hc = function(t) {
  return ra(t) && !t.shiftKey;
}, Uc = function(t) {
  return ra(t) && t.shiftKey;
}, Yi = function(t) {
  return setTimeout(t, 0);
}, Gn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ca = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, qc = [], jc = function(t, n) {
  var r = n?.document || document, o = n?.trapStack || qc, i = Xi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Hc,
    isKeyBackward: Uc
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(_, E, M) {
    return _ && _[E] !== void 0 ? _[E] : i[M || E];
  }, h = function(_, E) {
    var M = typeof E?.composedPath == "function" ? E.composedPath() : void 0;
    return a.containerGroups.findIndex(function(z) {
      var q = z.container, X = z.tabbableNodes;
      return q.contains(_) || M?.includes(q) || X.find(function(U) {
        return U === _;
      });
    });
  }, v = function(_) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, M = E.hasFallback, z = M === void 0 ? !1 : M, q = E.params, X = q === void 0 ? [] : q, U = i[_];
    if (typeof U == "function" && (U = U.apply(void 0, Nc(X))), U === !0 && (U = void 0), !U) {
      if (U === void 0 || U === !1)
        return U;
      throw new Error("`".concat(_, "` was specified but was not a node, or did not return a node"));
    }
    var oe = U;
    if (typeof U == "string") {
      try {
        oe = r.querySelector(U);
      } catch (re) {
        throw new Error("`".concat(_, '` appears to be an invalid selector; error="').concat(re.message, '"'), {
          cause: re
        });
      }
      if (!oe && !z)
        throw new Error("`".concat(_, "` as selector refers to no known node"));
    }
    return oe;
  }, u = function(_) {
    var E = _.activeElement;
    return E ? E.shadowRoot && E.shadowRoot.activeElement !== null ? u(E.shadowRoot) : E : null;
  }, f = function() {
    var _ = v("initialFocus", {
      hasFallback: !0
    });
    if (_ === !1)
      return !1;
    if (_ === void 0 || _ && !yr(_, i.tabbableOptions)) {
      var E = u(r);
      if (h(E) >= 0)
        _ = E;
      else {
        var M = a.tabbableGroups[0], z = M && M.firstTabbableNode;
        _ = z || v("fallbackFocus");
      }
    } else _ === null && (_ = v("fallbackFocus"));
    if (!_)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return _;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(_) {
      var E = $c(_, i.tabbableOptions), M = Ic(_, i.tabbableOptions), z = E.length > 0 ? E[0] : void 0, q = E.length > 0 ? E[E.length - 1] : void 0, X = M.find(function(re) {
        return Mn(re);
      }), U = M.slice().reverse().find(function(re) {
        return Mn(re);
      }), oe = !!E.find(function(re) {
        return yn(re) > 0;
      });
      return {
        container: _,
        tabbableNodes: E,
        focusableNodes: M,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: oe,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: z,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: X,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: U,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(fe) {
          var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Se = E.indexOf(fe);
          return Se < 0 ? be ? M.slice(M.indexOf(fe) + 1).find(function(de) {
            return Mn(de);
          }) : M.slice(0, M.indexOf(fe)).reverse().find(function(de) {
            return Mn(de);
          }) : E[Se + (be ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(_) {
      return _.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(_) {
      return _.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(_) {
    if (_ !== !1) {
      if (_ === u(r)) {
        a.mostRecentlyFocusedNode = _;
        return;
      }
      if (!_ || !_.focus) {
        c(f());
        return;
      }
      _.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = _, zc(_) && _.select();
    }
  }, p = function(_) {
    var E = v("setReturnFocus", {
      params: [_]
    });
    return E || (E === !1 ? !1 : _);
  }, x = function(_) {
    var E = _.target, M = _.event, z = _.isBackward, q = z === void 0 ? !1 : z;
    E = E || Ca(M), m();
    var X = null;
    if (a.tabbableGroups.length > 0) {
      var U = h(E, M), oe = U >= 0 ? a.containerGroups[U] : void 0;
      if (U < 0)
        q ? X = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : X = a.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var re = a.tabbableGroups.findIndex(function(Ae) {
          var De = Ae.firstTabbableNode;
          return E === De;
        });
        if (re < 0 && (oe.container === E || yr(E, i.tabbableOptions) && !Mn(E, i.tabbableOptions) && !oe.nextTabbableNode(E, !1)) && (re = U), re >= 0) {
          var fe = re === 0 ? a.tabbableGroups.length - 1 : re - 1, be = a.tabbableGroups[fe];
          X = yn(E) >= 0 ? be.lastTabbableNode : be.lastDomTabbableNode;
        } else ra(M) || (X = oe.nextTabbableNode(E, !1));
      } else {
        var Se = a.tabbableGroups.findIndex(function(Ae) {
          var De = Ae.lastTabbableNode;
          return E === De;
        });
        if (Se < 0 && (oe.container === E || yr(E, i.tabbableOptions) && !Mn(E, i.tabbableOptions) && !oe.nextTabbableNode(E)) && (Se = U), Se >= 0) {
          var de = Se === a.tabbableGroups.length - 1 ? 0 : Se + 1, ye = a.tabbableGroups[de];
          X = yn(E) >= 0 ? ye.firstTabbableNode : ye.firstDomTabbableNode;
        } else ra(M) || (X = oe.nextTabbableNode(E));
      }
    } else
      X = v("fallbackFocus");
    return X;
  }, g = function(_) {
    var E = Ca(_);
    if (!(h(E, _) >= 0)) {
      if (Gn(i.clickOutsideDeactivates, _)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Gn(i.allowOutsideClick, _) || _.preventDefault();
    }
  }, b = function(_) {
    var E = Ca(_), M = h(E, _) >= 0;
    if (M || E instanceof Document)
      M && (a.mostRecentlyFocusedNode = E);
    else {
      _.stopImmediatePropagation();
      var z, q = !0;
      if (a.mostRecentlyFocusedNode)
        if (yn(a.mostRecentlyFocusedNode) > 0) {
          var X = h(a.mostRecentlyFocusedNode), U = a.containerGroups[X].tabbableNodes;
          if (U.length > 0) {
            var oe = U.findIndex(function(re) {
              return re === a.mostRecentlyFocusedNode;
            });
            oe >= 0 && (i.isKeyForward(a.recentNavEvent) ? oe + 1 < U.length && (z = U[oe + 1], q = !1) : oe - 1 >= 0 && (z = U[oe - 1], q = !1));
          }
        } else
          a.containerGroups.some(function(re) {
            return re.tabbableNodes.some(function(fe) {
              return yn(fe) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (z = x({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), c(z || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, C = function(_) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = _;
    var M = x({
      event: _,
      isBackward: E
    });
    M && (ra(_) && _.preventDefault(), c(M));
  }, A = function(_) {
    (i.isKeyForward(_) || i.isKeyBackward(_)) && C(_, i.isKeyBackward(_));
  }, I = function(_) {
    Vc(_) && Gn(i.escapeDeactivates, _) !== !1 && (_.preventDefault(), s.deactivate());
  }, L = function(_) {
    var E = Ca(_);
    h(E, _) >= 0 || Gn(i.clickOutsideDeactivates, _) || Gn(i.allowOutsideClick, _) || (_.preventDefault(), _.stopImmediatePropagation());
  }, T = function() {
    if (a.active) {
      Kt.activateTrap(o, s);
      var _;
      return i.delayInitialFocus ? _ = new Promise(function(E) {
        a.delayInitialFocusTimer = Yi(function() {
          c(f()), E();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", A, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), _;
    }
  }, P = function(_) {
    a.active && !a.paused && s._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var E = /* @__PURE__ */ new Set(), M = /* @__PURE__ */ new Set(), z = Zi(_), q;
    try {
      for (z.s(); !(q = z.n()).done; ) {
        var X = q.value;
        E.add(X);
        for (var U = typeof ShadowRoot < "u" && X.getRootNode() instanceof ShadowRoot, oe = X; oe; ) {
          E.add(oe);
          var re = oe.parentElement, fe = [];
          re ? fe = re.children : !re && U && (fe = oe.getRootNode().children, re = oe.getRootNode().host, U = typeof ShadowRoot < "u" && re.getRootNode() instanceof ShadowRoot);
          var be = Zi(fe), Se;
          try {
            for (be.s(); !(Se = be.n()).done; ) {
              var de = Se.value;
              M.add(de);
            }
          } catch (ye) {
            be.e(ye);
          } finally {
            be.f();
          }
          oe = re;
        }
      }
    } catch (ye) {
      z.e(ye);
    } finally {
      z.f();
    }
    E.forEach(function(ye) {
      M.delete(ye);
    }), a.adjacentElements = M;
  }, H = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", A, !0), r.removeEventListener("keydown", I), s;
  }, Q = function(_) {
    var E = a.mostRecentlyFocusedNode;
    if (E) {
      var M = _.some(function(q) {
        var X = Array.from(q.removedNodes);
        return X.some(function(U) {
          return U === E || typeof U.contains == "function" && U.contains(E);
        });
      });
      if (M && a.containers.some(function(q) {
        return q?.isConnected;
      })) {
        m();
        var z = f();
        c(z);
      }
    }
  }, N = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Q) : void 0, G = function() {
    N && (N.disconnect(), a.active && !a.paused && a.containers.map(function(_) {
      N.observe(_, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(_) {
      if (a.active)
        return this;
      var E = l(_, "onActivate"), M = l(_, "onPostActivate"), z = l(_, "checkCanFocusTrap"), q = Kt.getActiveTrap(o), X = !1;
      if (q && !q.paused) {
        var U;
        (U = q._setSubtreeIsolation) === null || U === void 0 || U.call(q, !1), X = !0;
      }
      try {
        z || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = u(r), E?.({
          trap: s
        });
        var oe = function() {
          z && m();
          var be = function() {
            s._setSubtreeIsolation(!0), G(), M?.({
              trap: s
            });
          }, Se = T();
          Se ? Se.then(be) : be();
        };
        if (z)
          return z(a.containers.concat()).then(oe, oe), this;
        oe();
      } catch (fe) {
        if (q === Kt.getActiveTrap(o) && X) {
          var re;
          (re = q._setSubtreeIsolation) === null || re === void 0 || re.call(q, !0);
        }
        throw fe;
      }
      return this;
    },
    deactivate: function(_) {
      if (!a.active)
        return this;
      var E = Xi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, _);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || s._setSubtreeIsolation(!1), a.alreadySilent.clear(), H(), a.active = !1, a.paused = !1, G(), Kt.deactivateTrap(o, s);
      var M = l(E, "onDeactivate"), z = l(E, "onPostDeactivate"), q = l(E, "checkCanReturnFocus"), X = l(E, "delayReturnFocus"), U = l(E, "returnFocus", "returnFocusOnDeactivate");
      M?.({
        trap: s
      });
      var oe = function() {
        U && c(p(a.nodeFocusedBeforeActivation)), z?.({
          trap: s
        });
      }, re = function() {
        X && U ? Yi(oe) : oe();
      };
      return U && q ? (q(p(a.nodeFocusedBeforeActivation)).then(re, re), this) : (re(), this);
    },
    pause: function(_) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, _)) : this;
    },
    unpause: function(_) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, _)) : this;
    },
    updateContainerElements: function(_) {
      var E = [].concat(_).filter(Boolean);
      return a.containers = E.map(function(M) {
        return typeof M == "string" ? r.querySelector(M) : M;
      }), i.isolateSubtrees && P(a.containers), a.active && (m(), a.paused || s._setSubtreeIsolation(!0)), G(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(_, E) {
        if (a.paused === _)
          return this;
        if (a.paused = _, _) {
          var M = l(E, "onPause"), z = l(E, "onPostPause");
          M?.({
            trap: s
          }), H(), s._setSubtreeIsolation(!1), G(), z?.({
            trap: s
          });
        } else {
          var q = l(E, "onUnpause"), X = l(E, "onPostUnpause");
          q?.({
            trap: s
          });
          var U = function() {
            m();
            var re = function() {
              s._setSubtreeIsolation(!0), G(), X?.({
                trap: s
              });
            }, fe = T();
            fe ? fe.then(re) : re();
          };
          U();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(_) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(E) {
          var M;
          _ ? i.isolateSubtrees === "aria-hidden" ? ((E.ariaHidden === "true" || ((M = E.getAttribute("aria-hidden")) === null || M === void 0 ? void 0 : M.toLowerCase()) === "true") && a.alreadySilent.add(E), E.setAttribute("aria-hidden", "true")) : ((E.inert || E.hasAttribute("inert")) && a.alreadySilent.add(E), E.setAttribute("inert", !0)) : a.alreadySilent.has(E) || (i.isolateSubtrees === "aria-hidden" ? E.removeAttribute("aria-hidden") : E.removeAttribute("inert"));
        });
      }
    }
  }), s.updateContainerElements(t), s;
};
function Zc(e, t = {}) {
  let n;
  const { immediate: r, ...o } = t, i = Sn(!1), a = Sn(!1), s = (f) => n && n.activate(f), l = (f) => n && n.deactivate(f), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  }, u = W(() => {
    const f = nt(e);
    return tc(f).map((m) => {
      const c = nt(m);
      return typeof c == "string" ? c : mo(c);
    }).filter(gc);
  });
  return He(u, (f) => {
    if (f.length)
      if (!n)
        n = jc(f, {
          ...o,
          onActivate(m) {
            i.value = !0, t.onActivate && t.onActivate(m);
          },
          onDeactivate(m) {
            i.value = !1, t.onDeactivate && t.onDeactivate(m);
          }
        }), r && s();
      else {
        const m = n?.active;
        n?.updateContainerElements(f), !m && r && s();
      }
  }, { flush: "post" }), go(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const Lo = /* @__PURE__ */ ke((e, { slots: t }) => {
  const n = Sn(), r = ri(Zc(n, e.options));
  return () => {
    if (t.default) return qs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Wc = 864e5, Xc = 6e4, Yc = 36e5, Gi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function qn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Gi in e ? e[Gi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Ft(e, t) {
  return qn(e, e);
}
function Gc(e, t, n) {
  const r = Ft(e);
  return isNaN(t) ? qn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Kc(e, t, n) {
  const r = Ft(e);
  if (isNaN(t)) return qn(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = qn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
function Kn(e, t, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: i = 0,
    days: a = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Ft(e), u = o || r ? Kc(v, o + r * 12) : v, f = a || i ? Gc(u, a + i * 7) : u, m = l + s * 60, p = (h + m * 60) * 1e3;
  return qn(e, +f + p);
}
function Ki(e) {
  const t = Ft(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function un(e, ...t) {
  const n = qn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ji(e, t) {
  const n = Ft(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Jc(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Ji(r), a = Ji(o), s = +i - Ki(i), l = +a - Ki(a);
  return Math.round((s - l) / Wc);
}
function ia(e, t) {
  const n = +Ft(e) - +Ft(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Qc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ua(e) {
  return !(!Qc(e) && typeof e != "number" || isNaN(+Ft(e)));
}
function eu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function tu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - o.getFullYear();
}
function nu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Qi(r, o), a = Math.abs(
    Jc(r, o)
  );
  r.setDate(r.getDate() - i * a);
  const s = +(Qi(r, o) === -i), l = i * (a - s);
  return l === 0 ? 0 : l;
}
function Qi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function ui(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function au(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = (+r - +o) / Yc;
  return ui(n?.roundingMethod)(i);
}
function $o(e, t) {
  return +Ft(e) - +Ft(t);
}
function ru(e, t, n) {
  const r = $o(e, t) / Xc;
  return ui(n?.roundingMethod)(r);
}
function iu(e, t) {
  const n = Ft(e);
  return n.setHours(23, 59, 59, 999), n;
}
function lu(e, t) {
  const n = Ft(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function ou(e, t) {
  const n = Ft(e);
  return +iu(n) == +lu(n);
}
function su(e, t, n) {
  const [r, o, i] = un(
    n?.in,
    e,
    e,
    t
  ), a = ia(o, i), s = Math.abs(
    eu(o, i)
  );
  if (s < 1) return 0;
  o.getMonth() === 1 && o.getDate() > 27 && o.setDate(30), o.setMonth(o.getMonth() - a * s);
  let l = ia(o, i) === -a;
  ou(r) && s === 1 && ia(r, i) === 1 && (l = !1);
  const h = a * (s - +l);
  return h === 0 ? 0 : h;
}
function cu(e, t, n) {
  const r = $o(e, t) / 1e3;
  return ui(n?.roundingMethod)(r);
}
function uu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = ia(r, o), a = Math.abs(tu(r, o));
  r.setFullYear(1584), o.setFullYear(1584);
  const s = ia(r, o) === -i, l = i * (a - +s);
  return l === 0 ? 0 : l;
}
function du(e, t) {
  const [n, r] = un(e, t.start, t.end);
  return { start: n, end: r };
}
function fu(e, t) {
  const { start: n, end: r } = du(t?.in, e), o = {}, i = uu(r, n);
  i && (o.years = i);
  const a = Kn(n, { years: o.years }), s = su(r, a);
  s && (o.months = s);
  const l = Kn(a, { months: o.months }), h = nu(r, l);
  h && (o.days = h);
  const v = Kn(l, { days: o.days }), u = au(r, v);
  u && (o.hours = u);
  const f = Kn(v, { hours: o.hours }), m = ru(r, f);
  m && (o.minutes = m);
  const c = Kn(f, { minutes: o.minutes }), p = cu(r, c);
  return p && (o.seconds = p), o;
}
function hu(e) {
  return +Ft(e) < Date.now();
}
function vu(e, t, n) {
  let r = (o) => e(o, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function Ja(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return vu(e, t, n);
  throw Error("Wrong number of arguments");
}
function el(...e) {
  return Ja(mu, e);
}
const mu = (e, t) => e.length >= t;
function Lt(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function tl(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function gu(...e) {
  return Ja(Io, e);
}
function Io(e, t) {
  let n = { ...e, ...t };
  for (let r in t) Object.hasOwn(e, r) && tl(e[r]) && tl(t[r]) && (n[r] = Io(e[r], t[r]));
  return n;
}
function en(...e) {
  return Ja(bu, e);
}
function bu(e, t) {
  if (!el(t, 1)) return { ...e };
  if (!el(t, 2)) {
    let { [t[0]]: r, ...o } = e;
    return o;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function pu(...e) {
  return Ja(yu, e);
}
function yu(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const Do = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcCarousel: {
    autoPlayDelayInSeconds: 5,
    nextSlideAriaLabel: "Next slide",
    pauseAriaLabel: "Pause slideshow",
    playAriaLabel: "Play slideshow",
    prevSlideAriaLabel: "Previous slide",
    slideAriaLabel: "Slide {slide}"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    removeAriaLabel: "Remove play",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, je = ri(Do), yg = (e) => {
  Object.assign(je, gu(Do, e));
}, wu = /* @__PURE__ */ Symbol(), pa = () => {
  const e = ii();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Wn(wu) : null;
}, xu = () => pa() ? Na("NuxtTime") : "time", Oo = /* @__PURE__ */ ke({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => je.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), n = xu(), r = W(() => o.value ? i.value?.toISOString() : void 0), o = W(() => i.value ? Ua(i.value) : !1), i = W(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, s) => o.value ? ($(), we(Nt(j(n)), Ce({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: _e(() => [
        ve(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : se("", !0);
  }
}), Xn = (e) => {
  const t = ii(), n = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Na("NuxtLink") : Na("RouterLink");
}, di = /* @__PURE__ */ ke({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Xn(e.to);
    return (n, r) => ($(), we(Nt(j(t)), Ce(n.$attrs, n.$props), {
      default: _e(() => [
        ve(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ca = /* @__PURE__ */ ke({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = ge(!1), n = nc(t, 1);
    return kt(() => {
      t.value = !0;
    }), (r, o) => ($(), we(xn, $t(Rt({ name: e.name, mode: e.mode })), {
      default: _e(() => [
        j(n) ? ve(r.$slots, "default", {}, void 0, void 0, 0) : se("", !0)
      ]),
      _: 3
    }, 16));
  }
}), ku = {
  key: 0,
  class: "lc-feedback-message__content"
}, $n = /* @__PURE__ */ ke({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = W(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), Z("div", {
      class: pe(t.value),
      role: "alert"
    }, [
      Re(j(ca), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: _e(() => [
          e.content ? ($(), Z("p", ku, [
            e.variant === "error" ? ($(), we(j(et), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : se("", !0),
            Tt(" " + Oe(e.content), 1)
          ])) : se("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), Mo = "--vc-auto-duration", Su = `height var(${Mo}) cubic-bezier(0.33, 1, 0.68, 1)`, Ta = { padding: 0 }, _u = 300, Eu = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function nl(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function al(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: Su } : { transition: t };
}
function rl(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function Cu(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const Tu = /* @__PURE__ */ ke({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Hi(n, "when"), i = Hi(n, "baseHeight"), a = W(() => ({ overflow: "hidden", height: `${i.value}px` })), s = W(() => ({
      ...Ta,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = ge(null), h = ge(o.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function u() {
      return o.value ? Ta : i.value === 0 ? Eu : s.value;
    }
    const f = Sn(u()), m = (L) => f.value = L, c = (L) => m({ ...f.value, ...L }), p = ge(_u), x = (L) => p.value = L, g = W(() => ({ [Mo]: `${p.value}ms` }));
    let b = NaN;
    function C() {
      m(Ta), v("expanded"), r("expanded");
    }
    function A() {
      m(s.value), v("collapsed"), r("collapsed");
    }
    kt(() => {
      if (!l.value) return;
      const L = Cu(l.value.scrollHeight - i.value);
      L > 0 && x(L), !o.value && i.value === 0 && m(s.value);
    }), He(o, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (rl(l)) return C();
          v("expanding"), r("expand"), m({
            ...Ta,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return C();
              b = l.value.scrollHeight, c({
                ...al(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (rl(l) || (v("collapsing"), r("collapse"), c({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return A();
          requestAnimationFrame(() => {
            l.value && c({
              ...a.value,
              ...al(l),
              willChange: "height"
            });
          });
        }
    }), He(i, (L) => {
      o.value || (L > 0 ? c({ display: void 0, height: `${L}px` }) : c({ display: "none" }));
    });
    function I(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (o.value ? Math.abs(l.value.scrollHeight - nl(l)) < 1 ? C() : b < l.value.scrollHeight && c({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - nl(l)) < 1 && A());
    }
    return (L, T) => ($(), we(Nt(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Et(f.value),
      onTransitionend: I,
      "data-collapse": h.value
    }, {
      default: _e(() => [
        ve(L.$slots, "default", $t(Rt({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), Ro = /* @__PURE__ */ ke({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), we(j(Tu), Ce({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: _e(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), we(Nt(e.as), { key: 1 }, {
      default: _e(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Au = /* @__PURE__ */ ke({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), we(ba, {
      key: 0,
      to: e.to
    }, [
      ve(t.$slots, "default")
    ], 8, ["to"])) : ve(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), Lu = ["height", "width"], $u = ["r", "stroke-width"], Iu = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], Fo = /* @__PURE__ */ ke({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = W(() => Math.min(100, Math.max(0, e.progress))), n = W(() => e.radius - e.strokeWidth), r = W(() => 2 * Math.PI * n.value), o = W(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), Z("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ne("circle", {
        class: pe(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, $u),
      ne("circle", {
        class: pe(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": o.value,
        "stroke-width": e.strokeWidth
      }, null, 10, Iu)
    ], 8, Lu));
  }
}), Du = { class: "lc-timer-circle" }, Ou = ["aria-valuenow"], Mu = { class: "lc-timer-circle__content" }, Ru = /* @__PURE__ */ ke({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = ge(0), n = ac(t, {
      duration: e.durationInMs,
      transition: rc.linear
    });
    return kt(() => {
      t.value = 100;
    }), (r, o) => ($(), Z("div", Du, [
      ne("div", {
        "aria-valuenow": j(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Re(j(Fo), Ce({ progress: j(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, Ou),
      ne("div", Mu, [
        ve(r.$slots, "default")
      ])
    ]));
  }
}), Fu = (e, t) => e in t, tn = (e, t) => typeof e == "string" && Object.values(t).includes(e), Nu = "left", Pu = "large", Bu = "primary", wg = ["left", "right"], xg = ["large", "medium", "small"], kg = ["button", "reset", "submit"], Sg = ["click", "long-press"], _g = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Xr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Xr || {});
const zu = ["aria-valuenow"], Vu = { class: "lc-button__content" }, Hu = {
  key: 0,
  class: "lc-button__label-bubble"
}, Uu = {
  key: 0,
  class: "lc-button__overlay"
}, qu = { class: "lc-button__long-press-hint" }, ju = {
  key: 1,
  class: "lc-button__overlay"
}, Zu = {
  key: 0,
  class: "lc-button__loading-text"
}, il = 1e3 / 25, Ct = /* @__PURE__ */ ke({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: () => Nu },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => je.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: () => Pu },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: () => Bu }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = cn(), o = ge(!!r.default), i = ge(!1), a = ge(!1), s = ge(!1), l = ge(!1), h = ge(0), v = ge(null);
    let u, f, m;
    const c = W(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !o.value,
        "lc-button--link": x.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && s.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = W(() => e.disabled || e.loading), x = W(() => !!(e.href || e.to) && !p.value), g = W(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = W(() => l.value || !!v.value), C = W(() => typeof e.to == "string" ? void 0 : e.to?.replace), A = W(() => {
      const z = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? z : {
        ...z,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = W(() => x.value ? Xn(e.to) : "button"), L = () => {
      i.value = !1, s.value = !1, G(), _();
    }, T = (z) => {
      p.value || tn(z.key, Xr) && (v.value || (v.value = z.key, H()));
    }, P = (z) => {
      tn(z.key, Xr) && z.key === v.value && (G(), !l.value && V());
    }, H = (z = !1) => {
      e.trigger !== "click" && (z && window.addEventListener("pointerup", N), clearTimeout(m), s.value = !0);
    }, Q = () => {
      p.value || (l.value = !0, H(!0));
    }, N = () => {
      window.removeEventListener("pointerup", N), _(), !v.value && V();
    }, G = () => {
      v.value = null;
    }, V = () => {
      !s.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, s.value = !1);
    }, _ = () => {
      l.value = !1;
    }, E = () => {
      p.value || H();
    }, M = () => {
      _(), V();
    };
    return fo(() => {
      o.value = !!r.default;
    }), Ln(() => {
      clearInterval(u), clearTimeout(f), clearTimeout(m);
    }), He(s, (z) => {
      if (!p.value) {
        if (!z) {
          clearInterval(u), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, u = setInterval(() => {
          h.value += il / e.longPressDelay * 100;
        }, il), f = setTimeout(() => {
          clearInterval(u), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (z, q) => ($(), we(Nt(I.value), Ce(z.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: A.value,
      replace: C.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: q[0] || (q[0] = sa(() => {
      }, ["prevent"])),
      onKeydown: T,
      onKeyup: P,
      onPointerdown: Q,
      onPointerup: N,
      onTouchend: M,
      onTouchstartPassive: E
    }), {
      default: _e(() => [
        e.trigger === "long-press" ? ($(), Z("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, zu)) : se("", !0),
        ne("div", Vu, [
          e.icon ? ($(), we(j(et), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : se("", !0),
          Re(xn, { name: "font-size-fade" }, {
            default: _e(() => [
              z.$slots.default ? ($(), Z("span", Hu, [
                ve(z.$slots, "default"),
                Re(j(jr), Ce({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : se("", !0)
            ]),
            _: 3
          }),
          z.$slots.default ? se("", !0) : ($(), we(j(jr), Ce({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Re(j(ca), { name: "fade" }, {
          default: _e(() => [
            g.value ? ($(), Z("div", Uu, [
              ne("span", qu, Oe(e.longPressHint), 1)
            ])) : se("", !0),
            e.loading ? ($(), Z("div", ju, [
              Re(j(et), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), Z("span", Zu, Oe(e.loadingText), 1)) : se("", !0)
            ])) : se("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), Wu = "default", Eg = ["dashed", "default"], fi = /* @__PURE__ */ ke({
  __name: "LcSeparator",
  props: {
    variant: { default: () => Wu }
  },
  setup(e) {
    return (t, n) => ($(), Z("hr", {
      class: pe(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), It = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, hi = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Xu = {}, Yu = { viewBox: "0 0 752 8" }, Gu = { id: "perforation" }, Ku = ["cx"];
function Ju(e, t) {
  return $(), Z("svg", Yu, [
    ne("mask", Gu, [
      t[0] || (t[0] = ne("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), Z(at, null, yt(new Array(21), (n, r) => ($(), Z("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Ku))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Qu = /* @__PURE__ */ hi(Xu, [["render", Ju]]), ed = {}, td = { viewBox: "0 0 752 8" }, nd = { id: "perforation" }, ad = ["points"];
function rd(e, t) {
  return $(), Z("svg", td, [
    ne("mask", nd, [
      t[0] || (t[0] = ne("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), Z(at, null, yt(new Array(150), (n, r) => ($(), Z("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, ad))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const ll = /* @__PURE__ */ hi(ed, [["render", rd]]), id = ["id"], ld = {
  key: 0,
  class: "lc-card__background"
}, od = {
  key: 1,
  class: /* @__PURE__ */ pe(["lc-card__perforation", "lc-card__perforation--top"])
}, sd = {
  key: 0,
  class: "lc-card__toggle"
}, cd = {
  key: 2,
  class: /* @__PURE__ */ pe(["lc-card__perforation", "lc-card__perforation--bottom"])
}, ya = /* @__PURE__ */ ke({
  __name: "LcCard",
  props: /* @__PURE__ */ _n({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => je.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = It(e.id), r = ge(!!t.default), o = Xa(e, "modelValue"), i = W(() => !!e.animated && (!!e.expandable || o.value)), a = W(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": o.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), s = () => {
      e.expandable && (o.value = !o.value);
    };
    return fo(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), Z("article", {
      id: j(n),
      class: pe(a.value)
    }, [
      l.$slots.background ? ($(), Z("div", ld, [
        ve(l.$slots, "background")
      ])) : se("", !0),
      e.variant === "transaction" ? ($(), Z("div", od, [
        Re(ll)
      ])) : se("", !0),
      l.$slots.header || e.expandable ? ($(), we(Nt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${j(n)}-region` : void 0,
        "aria-expanded": e.expandable ? o.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: s
      }, {
        default: _e(() => [
          e.headerTo && !e.expandable ? ($(), we(j(di), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: _e(() => [
              ne("header", {
                class: pe(["lc-card__header", e.headerClass])
              }, [
                ve(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), Z("header", {
            key: 1,
            class: pe(["lc-card__header", e.headerClass])
          }, [
            ve(l.$slots, "header"),
            e.expandable ? ($(), Z(at, { key: 0 }, [
              l.$slots.toggle ? ($(), Z("div", sd, [
                ve(l.$slots, "toggle")
              ])) : ($(), we(j(et), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : se("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : se("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || o.value) ? ($(), we(j(Ro), Ce({
        key: 3,
        id: `${j(n)}-region`
      }, { when: o.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: _e(() => [
          l.$slots.default ? ($(), Z("div", {
            key: 0,
            class: pe(["lc-card__body", e.bodyClass])
          }, [
            ve(l.$slots, "default")
          ], 2)) : se("", !0),
          l.$slots.footer ? ($(), Z("footer", {
            key: 1,
            class: pe(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), we(j(fi), {
              key: 0,
              variant: "dashed"
            })) : se("", !0),
            ve(l.$slots, "footer")
          ], 2)) : se("", !0),
          e.variant !== "default" ? ($(), Z("div", cd, [
            e.variant == "order" ? ($(), we(Qu, { key: 0 })) : ($(), we(ll, { key: 1 }))
          ])) : se("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : se("", !0)
    ], 10, id));
  }
}), Cg = ["large", "medium", "none"], Tg = ["large", "none", "small"], Ag = ["default", "order", "transaction"], vi = () => typeof window < "u", Yr = /* @__PURE__ */ new Set();
let wr;
const ud = () => {
  wr ??= js(!0).run(() => bo(() => document.documentElement)), wr && (wr.value = Yr.size > 0);
}, dd = (e) => {
  const t = /* @__PURE__ */ Symbol("lc-scroll-lock-owner"), n = (r) => {
    vi() && (r ? Yr.add(t) : Yr.delete(t), ud());
  };
  He(() => nt(e), n, { immediate: !0 }), go(() => n(!1));
}, fd = ["aria-hidden", "inert"], hd = { class: "lc-modal__card-header-wrap" }, vd = { class: "lc-modal__card-header-actions" }, No = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => je.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => je.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => je.lcModal.noFocusTrap },
    spacing: { default: () => je.lcModal.spacing },
    stackDepth: {},
    to: { default: () => je.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = ge(), o = W(() => (e.stackDepth ?? 0) > 0), i = W(() => v("close-button")), a = W(
      () => e.stackDepth === void 0 ? void 0 : { "--lc-modal-stack-depth": e.stackDepth }
    ), h = {
      allowOutsideClick: (m) => {
        const c = m.target;
        return c ? nt(e.ignoreOutsideClickOn).some((p) => (typeof p == "string" ? document.querySelector(p) : mo(p))?.contains(c) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const m = document.createElement("button");
        return m.id = "lc-modal-fallback-focus", m.hidden = !0, m;
      })(),
      immediate: !0
    }, v = (m) => e.closeTriggers.includes(m), u = (m) => {
      o.value || v(m) && n("close");
    }, f = (m) => {
      r.value = m;
    };
    return Ka(r, () => u("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), po("Escape", () => u("escape")), dd(() => e.isVisible), (m, c) => e.isVisible ? ($(), we(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Re(j(ca), { name: "fade" }, {
        default: _e(() => [
          ne("div", {
            "aria-hidden": o.value || void 0,
            class: pe([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize,
                "lc-modal__bg--no-backdrop": o.value
              },
              e.backgroundClass
            ]),
            inert: o.value || void 0,
            style: Et(a.value)
          }, [
            Re(j(ca), Ce(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: _e(() => [
                ($(), we(Nt(e.noFocusTrap ? "div" : j(Lo)), {
                  options: e.noFocusTrap ? null : h
                }, {
                  default: _e(() => [
                    ve(m.$slots, "modal", $t(Rt({ setRef: f })), () => [
                      Re(j(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: pe([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: _e(() => [
                          m.$slots.header || i.value ? ($(), Z("header", {
                            key: 0,
                            class: pe(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ne("div", hd, [
                              ve(m.$slots, "header")
                            ]),
                            ne("div", vd, [
                              ve(m.$slots, "actions"),
                              i.value ? ($(), we(j(Ct), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: c[0] || (c[0] = (p) => u("close-button"))
                              })) : se("", !0)
                            ])
                          ], 2)) : se("", !0),
                          ve(m.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 14, fd)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
}), Lg = ["click-outside", "close-button", "escape"], $g = ["large", "medium", "small"], md = 30, gd = 0.3, ol = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const o = parseFloat(t[1]);
    return t[2] === "px" ? o : o / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, bd = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const o = ge(0), i = ge(0), a = ge(!1), s = ge(0), l = ge(0), h = ge(0), v = ge(0), u = W(
    () => nt(t)[s.value] ?? nt(t)[0]
  ), f = W(() => s.value < nt(t).length - 1), m = () => {
    i.value = 0, o.value = 0, a.value = !1;
  }, c = () => {
    s.value = 0;
  }, p = (C, A) => (A > 0 ? C / A : 0) > gd || C > md, x = () => {
    if (!a.value) return;
    const C = v.value - h.value, A = Date.now() - l.value, I = Math.abs(C), L = C > 0 ? "down" : "up", T = nt(t);
    if (L === "up" && f.value && p(I, A)) {
      const H = ol(T[s.value]) + I;
      let Q = s.value + 1, N = 1 / 0;
      for (let G = s.value + 1; G < T.length; G++) {
        const V = Math.abs(ol(T[G]) - H);
        V < N && (N = V, Q = G);
      }
      s.value = Q, m();
      return;
    }
    if (L === "down" && p(I, A) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (C) => {
    if (C.target.closest('button, a, [role="button"]')) return;
    C.currentTarget.setPointerCapture(C.pointerId), h.value = C.clientY, v.value = C.clientY, l.value = Date.now(), a.value = !0;
  }, b = (C) => {
    if (!a.value) return;
    v.value = C.clientY;
    const A = v.value - h.value;
    A < 0 && f.value ? (i.value = -A, o.value = 0) : (i.value = 0, o.value = Math.max(0, A));
  };
  return qt(e, "pointerdown", g), qt(e, "pointermove", b), qt(e, "pointerup", x), qt(e, "pointercancel", x), qt(e, "lostpointercapture", x), {
    currentSnapHeight: u,
    currentSnapIndex: s,
    dismissOffset: o,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, pd = { class: "lc-bottom-sheet-modal__header" }, yd = { class: "lc-bottom-sheet-modal__header-actions" }, wd = { class: "lc-bottom-sheet" }, xd = ["aria-labelledby"], kd = { class: "lc-bottom-sheet__header-actions" }, Aa = 300, sl = "lc-bottom-sheet__drag-area", Sd = "(width < 496px)", Ig = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => je.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${sl}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], o = t;
    let i;
    const s = `${It()}-header`, l = ft("dragArea"), h = ge(!1), v = ge(!1), u = ge(!0), f = ic(Sd), m = bo(() => document.documentElement), {
      currentSnapHeight: c,
      dismissOffset: p,
      isDragging: x,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: C
    } = bd({
      canClose: () => P("swipe-down"),
      dragAreaRef: l,
      onClose: () => L(),
      snapHeights: W(() => e.snapHeights)
    }), A = W(
      () => e.closeTriggers.filter(
        (Q) => r.includes(Q)
      )
    ), I = W(() => {
      if (x.value) {
        const N = C.value !== 0;
        return {
          height: N ? `calc(${c.value} + ${C.value}px)` : c.value,
          transform: N ? "translateY(0)" : `translateY(${Math.max(0, p.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: c.value,
          transform: "translateY(100%)",
          transition: `transform ${Aa}ms ease`
        };
      const Q = u.value;
      return {
        height: c.value,
        transform: Q ? "translateY(100%)" : "translateY(0)",
        transition: u.value ? "none" : `height ${Aa}ms ease, transform ${Aa}ms ease`
      };
    }), L = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), o("update:modelValue", !1);
      }, Aa));
    }, T = () => {
      P("click-outside") && L();
    }, P = (Q) => e.closeTriggers.includes(Q), H = (Q) => {
      const N = Q.target;
      v.value = N.scrollTop > 0;
    };
    return He(
      () => e.modelValue,
      async (Q) => {
        if (!Q) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, u.value = !0, m.value = !0, await Ya(), requestAnimationFrame(() => {
          u.value = !1;
        });
      },
      { immediate: !0 }
    ), po("Escape", () => {
      P("escape") && L();
    }), Ln(() => {
      clearTimeout(i), m.value = !1;
    }), (Q, N) => j(f) ? e.modelValue ? ($(), we(ba, {
      key: 1,
      to: e.to
    }, [
      ne("div", wd, [
        ne("div", {
          class: pe(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: T
        }, null, 2),
        Re(j(Lo), { options: n }, {
          default: _e(() => [
            ne("div", {
              "aria-labelledby": Q.$slots.title ? s : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Et(I.value)
            }, [
              ne("div", {
                ref: "dragArea",
                class: pe([
                  sl,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                N[1] || (N[1] = ne("div", { class: "lc-bottom-sheet__handle" }, [
                  ne("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                Q.$slots.title || P("close-button") ? ($(), Z("div", {
                  key: 0,
                  id: s,
                  class: "lc-bottom-sheet__header"
                }, [
                  ve(Q.$slots, "title"),
                  ne("div", kd, [
                    ve(Q.$slots, "actions"),
                    P("close-button") ? ($(), we(j(Ct), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: L
                    })) : se("", !0)
                  ])
                ])) : se("", !0)
              ], 2),
              ne("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: H
              }, [
                ve(Q.$slots, "default")
              ], 544)
            ], 12, xd)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : se("", !0) : ($(), we(j(No), Ce({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": A.value,
      spacing: "small",
      onClose: N[0] || (N[0] = (G) => o("update:modelValue", !1))
    }), Ga({
      default: _e(() => [
        ne("div", {
          class: pe(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: H
        }, [
          ve(Q.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      Q.$slots.title ? {
        name: "header",
        fn: _e(() => [
          ne("div", pd, [
            ve(Q.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      Q.$slots.actions ? {
        name: "actions",
        fn: _e(() => [
          ne("div", yd, [
            ve(Q.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), Dg = ["swipe-down", "click-outside", "escape"];
function Po(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function o(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (n = u.map((f) => f.height), r.forEach((f) => t.on(f, s)), s());
  }
  function i() {
    r.forEach((v) => t.off(v, s));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => n[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function s() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: o,
    destroy: i
  };
}
Po.globalOptions = void 0;
const _d = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Jn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Qn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function La(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Qa(e = {}) {
  let t, n, r, o, i = [], a = [];
  const s = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, C) {
    n = b;
    const {
      mergeOptions: A,
      optionsAtMedia: I
    } = C, L = A(_d, Qa.globalOptions), T = A(L, e);
    t = I(T), r = n.rootNode(), o = n.slideNodes();
    const {
      watchDrag: P,
      loop: H
    } = n.internalEngine().options, Q = !!P;
    t.loop && H && (v.loop = Jn(t.loop), La(r, v.loop)), t.draggable && Q && (v.draggable = Jn(t.draggable), La(r, v.draggable)), t.dragging && (v.dragging = Jn(t.dragging), l.forEach((N) => n.on(N, m))), t.snapped && (v.snapped = Jn(t.snapped), s.forEach((N) => n.on(N, p)), p()), t.inView && (v.inView = Jn(t.inView), h.forEach((N) => n.on(N, x)), x());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), s.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, x)), Qn(r, v.loop), Qn(r, v.draggable), Qn(r, v.dragging), c([], i, v.snapped), c([], a, v.inView), Object.keys(v).forEach((b) => {
      const C = b;
      v[C] = [];
    });
  }
  function m(b, C) {
    (C === "pointerDown" ? La : Qn)(r, v.dragging);
  }
  function c(b = [], C = [], A) {
    const I = C.map((T) => o[T]), L = b.map((T) => o[T]);
    return I.forEach((T) => Qn(T, A)), L.forEach((T) => La(T, A)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), C = b[n.selectedScrollSnap()];
    i = c(C, i, v.snapped);
  }
  function x() {
    const b = n.slidesInView();
    a = c(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
Qa.globalOptions = void 0;
function cl(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function xr(e) {
  return typeof e == "number" && !isNaN(e);
}
function Bo(e = {}) {
  let o, i = [], a, s = 0, l = 0, h = 0, v = !1, u, f;
  function m(_) {
    o = _;
    const E = o.selectedScrollSnap(), {
      scrollBody: M,
      containerRect: z,
      axis: q
    } = o.internalEngine(), X = q.measureSize(z);
    a = cl(X * 0.75, 200, 500), v = !1, i = o.scrollSnapList().map((U, oe) => oe === E ? 1 : 0), u = M.settled, f = o.scrollProgress, M.settled = N, o.scrollProgress = G, o.on("select", b).on("slideFocus", p).on("pointerDown", g).on("pointerUp", x), A(), p();
  }
  function c() {
    const {
      scrollBody: _
    } = o.internalEngine();
    _.settled = u, o.scrollProgress = f, o.off("select", b).off("slideFocus", p).off("pointerDown", g).off("pointerUp", x), o.slideNodes().forEach((E) => {
      const M = E.style;
      M.opacity = "", M.transform = "", M.pointerEvents = "", E.getAttribute("style") || E.removeAttribute("style");
    });
  }
  function p() {
    const _ = o.selectedScrollSnap();
    L(_, 1);
  }
  function x() {
    v = !1;
  }
  function g() {
    v = !1, s = 0, l = 0;
  }
  function b() {
    const _ = o.internalEngine().scrollBody.duration();
    l = _ ? 0 : 1, v = !0, _ || p();
  }
  function C(_) {
    const {
      axis: E
    } = o.internalEngine();
    return `translate${E.scroll.toUpperCase()}(${E.direction(_)}px)`;
  }
  function A() {
    const {
      translate: _,
      slideLooper: E
    } = o.internalEngine();
    _.clear(), _.toggleActive(!1), E.loopPoints.forEach(({
      translate: M
    }) => {
      M.clear(), M.toggleActive(!1);
    });
  }
  function I(_) {
    const {
      scrollSnaps: E,
      location: M,
      target: z
    } = o.internalEngine();
    !xr(_) || i[_] < 0.5 || (M.set(E[_]), z.set(M));
  }
  function L(_, E) {
    o.scrollSnapList().forEach((z, q) => {
      const X = Math.abs(E), U = i[q], oe = q === _, re = oe ? U + X : U - X, fe = cl(re, 0, 1);
      i[q] = fe;
      const be = oe && v, Se = o.previousScrollSnap();
      be && (i[Se] = 1 - fe), oe && P(_, fe), T(q);
    });
  }
  function T(_) {
    const E = o.internalEngine().slideRegistry[_], {
      scrollSnaps: M,
      containerRect: z
    } = o.internalEngine(), q = i[_];
    E.forEach((X) => {
      const U = o.slideNodes()[X].style, oe = parseFloat(q.toFixed(2)), re = oe > 0, fe = re ? M[_] : z.width + 2, be = C(fe);
      re && (U.transform = be), U.opacity = oe.toString(), U.pointerEvents = q > 0.5 ? "auto" : "none", re || (U.transform = be);
    });
  }
  function P(_, E) {
    const {
      index: M,
      dragHandler: z,
      scrollSnaps: q
    } = o.internalEngine(), X = z.pointerDown(), U = 1 / (q.length - 1);
    let oe = _, re = X ? o.selectedScrollSnap() : o.previousScrollSnap();
    if (X && oe === re) {
      const Se = Math.sign(s) * -1;
      oe = re, re = M.clone().set(re).add(Se).get();
    }
    const fe = re * U, be = (oe - re) * U;
    h = fe + be * E;
  }
  function H() {
    const {
      dragHandler: _,
      index: E,
      scrollBody: M
    } = o.internalEngine(), z = o.selectedScrollSnap();
    if (!_.pointerDown()) return z;
    const q = Math.sign(M.velocity()), X = Math.sign(s), U = E.clone().set(z).add(q * -1).get();
    return !q || !X ? null : X === q ? U : z;
  }
  function Q(_) {
    const {
      dragHandler: E,
      scrollBody: M
    } = _.internalEngine(), z = E.pointerDown(), q = M.velocity(), X = M.duration(), U = H(), oe = !xr(U);
    if (z) {
      if (!q) return;
      s += q, l = Math.abs(q / a), I(U);
    }
    if (!z) {
      if (!X || oe) return;
      l += (1 - i[U]) / X, l *= 0.68;
    }
    oe || L(U, l);
  }
  function N() {
    const {
      target: _,
      location: E
    } = o.internalEngine(), M = _.get() - E.get(), z = Math.abs(M) >= 1, q = H(), X = !xr(q);
    return Q(o), X || z ? !1 : i[q] > 0.999;
  }
  function G() {
    return h;
  }
  return {
    name: "fade",
    options: e,
    init: m,
    destroy: c
  };
}
Bo.globalOptions = void 0;
function Ed(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ul(e) {
  return Ed(e) || Array.isArray(e);
}
function Cd() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function mi(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== i ? !1 : n.every((a) => {
    const s = e[a], l = t[a];
    return typeof s == "function" ? `${s}` == `${l}` : !ul(s) || !ul(l) ? s === l : mi(s, l);
  });
}
function dl(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Td(e, t) {
  if (e.length !== t.length) return !1;
  const n = dl(e), r = dl(t);
  return n.every((o, i) => {
    const a = r[i];
    return mi(o, a);
  });
}
function gi(e) {
  return typeof e == "number";
}
function Gr(e) {
  return typeof e == "string";
}
function er(e) {
  return typeof e == "boolean";
}
function fl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ut(e) {
  return Math.abs(e);
}
function bi(e) {
  return Math.sign(e);
}
function la(e, t) {
  return ut(e - t);
}
function Ad(e, t) {
  if (e === 0 || t === 0 || ut(e) <= ut(t)) return 0;
  const n = la(ut(e), ut(t));
  return ut(n / e);
}
function Ld(e) {
  return Math.round(e * 100) / 100;
}
function ua(e) {
  return da(e).map(Number);
}
function jt(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function pi(e, t) {
  return t === wa(e);
}
function hl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function zo(e, t) {
  return [e, t].reduce((n, r) => (da(r).forEach((o) => {
    const i = n[o], a = r[o], s = fl(i) && fl(a);
    n[o] = s ? zo(i, a) : a;
  }), n), {});
}
function Kr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function $d(e, t) {
  const n = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Gr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function fa() {
  let e = [];
  function t(o, i, a, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(i, a, s), l = () => o.removeEventListener(i, a, s);
    else {
      const h = o;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function Id(e, t, n, r) {
  const o = fa(), i = 1e3 / 60;
  let a = null, s = 0, l = 0;
  function h() {
    o.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), o.clear();
  }
  function u(x) {
    if (!l) return;
    a || (a = x, n(), n());
    const g = x - a;
    for (a = x, s += g; s >= i; )
      n(), s -= i;
    const b = s / i;
    r(b), l && (l = t.requestAnimationFrame(u));
  }
  function f() {
    l || (l = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, s = 0, l = 0;
  }
  function c() {
    a = null, s = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function Dd(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, s = v(), l = u();
  function h(c) {
    const {
      height: p,
      width: x
    } = c;
    return r ? p : x;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(c) {
    return c * a;
  }
  return {
    scroll: o,
    cross: i,
    startEdge: s,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function Cn(e = 0, t = 0) {
  const n = ut(e - t);
  function r(h) {
    return h < e;
  }
  function o(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || o(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function s(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function Vo(e, t, n) {
  const {
    constrain: r
  } = Cn(0, e), o = e + 1;
  let i = a(t);
  function a(f) {
    return n ? ut((o + f) % o) : r(f);
  }
  function s() {
    return i;
  }
  function l(f) {
    return i = a(f), u;
  }
  function h(f) {
    return v().set(s() + f);
  }
  function v() {
    return Vo(e, s(), n);
  }
  const u = {
    get: s,
    set: l,
    add: h,
    clone: v
  };
  return u;
}
function Od(e, t, n, r, o, i, a, s, l, h, v, u, f, m, c, p, x, g, b) {
  const {
    cross: C,
    direction: A
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, T = fa(), P = fa(), H = Cn(50, 225).constrain(m.measure(20)), Q = {
    mouse: 300,
    touch: 400
  }, N = {
    mouse: 500,
    touch: 600
  }, G = c ? 43 : 25;
  let V = !1, _ = 0, E = 0, M = !1, z = !1, q = !1, X = !1;
  function U(ue) {
    if (!b) return;
    function Fe(Ze) {
      (er(b) || b(ue, Ze)) && de(Ze);
    }
    const qe = t;
    T.add(qe, "dragstart", (Ze) => Ze.preventDefault(), L).add(qe, "touchmove", () => {
    }, L).add(qe, "touchend", () => {
    }).add(qe, "touchstart", Fe).add(qe, "mousedown", Fe).add(qe, "touchcancel", Ae).add(qe, "contextmenu", Ae).add(qe, "click", De, !0);
  }
  function oe() {
    T.clear(), P.clear();
  }
  function re() {
    const ue = X ? n : t;
    P.add(ue, "touchmove", ye, L).add(ue, "touchend", Ae).add(ue, "mousemove", ye, L).add(ue, "mouseup", Ae);
  }
  function fe(ue) {
    const Fe = ue.nodeName || "";
    return I.includes(Fe);
  }
  function be() {
    return (c ? N : Q)[X ? "mouse" : "touch"];
  }
  function Se(ue, Fe) {
    const qe = u.add(bi(ue) * -1), Ze = v.byDistance(ue, !c).distance;
    return c || ut(ue) < H ? Ze : x && Fe ? Ze * 0.5 : v.byIndex(qe.get(), 0).distance;
  }
  function de(ue) {
    const Fe = Kr(ue, r);
    X = Fe, q = c && Fe && !ue.buttons && V, V = la(o.get(), a.get()) >= 2, !(Fe && ue.button !== 0) && (fe(ue.target) || (M = !0, i.pointerDown(ue), h.useFriction(0).useDuration(0), o.set(a), re(), _ = i.readPoint(ue), E = i.readPoint(ue, C), f.emit("pointerDown")));
  }
  function ye(ue) {
    if (!Kr(ue, r) && ue.touches.length >= 2) return Ae(ue);
    const qe = i.readPoint(ue), Ze = i.readPoint(ue, C), Xe = la(qe, _), Ve = la(Ze, E);
    if (!z && !X && (!ue.cancelable || (z = Xe > Ve, !z)))
      return Ae(ue);
    const Pe = i.pointerMove(ue);
    Xe > p && (q = !0), h.useFriction(0.3).useDuration(0.75), s.start(), o.add(A(Pe)), ue.preventDefault();
  }
  function Ae(ue) {
    const qe = v.byDistance(0, !1).index !== u.get(), Ze = i.pointerUp(ue) * be(), Xe = Se(A(Ze), qe), Ve = Ad(Ze, Xe), Pe = G - 10 * Ve, rt = g + Ve / 50;
    z = !1, M = !1, P.clear(), h.useDuration(Pe).useFriction(rt), l.distance(Xe, !c), X = !1, f.emit("pointerUp");
  }
  function De(ue) {
    q && (ue.stopPropagation(), ue.preventDefault(), q = !1);
  }
  function We() {
    return M;
  }
  return {
    init: U,
    destroy: oe,
    pointerDown: We
  };
}
function Md(e, t) {
  let r, o;
  function i(u) {
    return u.timeStamp;
  }
  function a(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Kr(u, t) ? u : u.touches[0])[c];
  }
  function s(u) {
    return r = u, o = u, a(u);
  }
  function l(u) {
    const f = a(u) - a(o), m = i(u) - i(r) > 170;
    return o = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !o) return 0;
    const f = a(o) - a(r), m = i(u) - i(r), c = i(u) - i(o) > 170, p = f / m;
    return m && !c && ut(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function Rd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: o + i,
      bottom: r + a,
      left: o,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function Fd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function Nd(e, t, n, r, o, i, a) {
  const s = [e].concat(r);
  let l, h, v = [], u = !1;
  function f(x) {
    return o.measureSize(a.measure(x));
  }
  function m(x) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const C of b) {
        if (u) return;
        const A = C.target === e, I = r.indexOf(C.target), L = A ? h : v[I], T = f(A ? e : r[I]);
        if (ut(T - L) >= 0.5) {
          x.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (er(i) || i(x, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      s.forEach((b) => l.observe(b));
    });
  }
  function c() {
    u = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function Pd(e, t, n, r, o, i) {
  let a = 0, s = 0, l = o, h = i, v = e.get(), u = 0;
  function f() {
    const L = r.get() - e.get(), T = !l;
    let P = 0;
    return T ? (a = 0, n.set(r), e.set(r), P = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), P = v - u), s = bi(P), u = v, I;
  }
  function m() {
    const L = r.get() - t.get();
    return ut(L) < 1e-3;
  }
  function c() {
    return l;
  }
  function p() {
    return s;
  }
  function x() {
    return a;
  }
  function g() {
    return C(o);
  }
  function b() {
    return A(i);
  }
  function C(L) {
    return l = L, I;
  }
  function A(L) {
    return h = L, I;
  }
  const I = {
    direction: p,
    duration: c,
    velocity: x,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: A,
    useDuration: C
  };
  return I;
}
function Bd(e, t, n, r, o) {
  const i = o.measure(10), a = o.measure(50), s = Cn(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", p = ut(e[c] - t.get()), x = n.get() - t.get(), g = s.constrain(p / a);
    n.subtract(x * g), !m && ut(x) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function zd(e, t, n, r, o) {
  const i = Cn(-t + e, 0), a = u(), s = v(), l = f();
  function h(c, p) {
    return la(c, p) <= 1;
  }
  function v() {
    const c = a[0], p = jt(a), x = a.lastIndexOf(c), g = a.indexOf(p) + 1;
    return Cn(x, g);
  }
  function u() {
    return n.map((c, p) => {
      const {
        min: x,
        max: g
      } = i, b = i.constrain(c), C = !p, A = pi(n, p);
      return C ? g : A || h(x, b) ? x : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + o) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: c,
      max: p
    } = s;
    return a.slice(c, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function Vd(e, t, n) {
  const r = t[0], o = n ? r - e : jt(t);
  return {
    limit: Cn(o, r)
  };
}
function Hd(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = Cn(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? s(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function Ud(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function qd(e, t, n, r, o) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: s
  } = o, l = u().map(t.measure), h = f(), v = m();
  function u() {
    return s(r).map((p) => jt(p)[a] - p[0][i]).map(ut);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -ut(p));
  }
  function m() {
    return s(h).map((p) => p[0]).map((p, x) => p + l[x]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function jd(e, t, n, r, o, i) {
  const {
    groupSlides: a
  } = o, {
    min: s,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(s, l).map((c, p, x) => {
      const g = !p, b = pi(x, p);
      if (g) {
        const C = jt(x[0]) + 1;
        return hl(C);
      }
      if (b) {
        const C = wa(i) - jt(x)[0] + 1;
        return hl(C, jt(x)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function Zd(e, t, n, r, o) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: s
  } = r;
  function l(c) {
    return c.concat().sort((p, x) => ut(p) - ut(x))[0];
  }
  function h(c) {
    const p = e ? a(c) : s(c), x = t.map((b, C) => ({
      diff: v(b - p, 0),
      index: C
    })).sort((b, C) => ut(b.diff) - ut(C.diff)), {
      index: g
    } = x[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(c, p) {
    const x = [c, c + n, c - n];
    if (!e) return c;
    if (!p) return l(x);
    const g = x.filter((b) => bi(b) === p);
    return g.length ? l(g) : jt(x) - n;
  }
  function u(c, p) {
    const x = t[c] - o.get(), g = v(x, p);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, p) {
    const x = o.get() + c, {
      index: g,
      distance: b
    } = h(x), C = !e && i(x);
    if (!p || C) return {
      index: g,
      distance: c
    };
    const A = t[g] - b, I = c + v(A, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function Wd(e, t, n, r, o, i, a) {
  function s(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(u.index), a.emit("select"));
  }
  function l(u, f) {
    const m = o.byDistance(u, f);
    s(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = o.byIndex(m.get(), f);
    s(c);
  }
  return {
    distance: l,
    index: h
  };
}
function Xd(e, t, n, r, o, i, a, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!s) return;
    function c(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((C) => C.includes(p));
      gi(b) && (o.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((p, x) => {
      i.add(p, "focus", (g) => {
        (er(s) || s(m, g)) && c(x);
      }, l);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function na(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function o(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return gi(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: i
  };
}
function Ho(e, t) {
  const n = e.scroll === "x" ? a : s, r = t.style;
  let o = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function s(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = Ld(e.direction(f));
    m !== o && (r.transform = n(m), o = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function Yd(e, t, n, r, o, i, a, s, l) {
  const v = ua(o), u = ua(o).reverse(), f = g().concat(b());
  function m(T, P) {
    return T.reduce((H, Q) => H - o[Q], P);
  }
  function c(T, P) {
    return T.reduce((H, Q) => m(H, P) > 0 ? H.concat([Q]) : H, []);
  }
  function p(T) {
    return i.map((P, H) => ({
      start: P - r[H] + 0.5 + T,
      end: P + t - 0.5 + T
    }));
  }
  function x(T, P, H) {
    const Q = p(P);
    return T.map((N) => {
      const G = H ? 0 : -n, V = H ? n : 0, _ = H ? "end" : "start", E = Q[N][_];
      return {
        index: N,
        loopPoint: E,
        slideLocation: na(-1),
        translate: Ho(e, l[N]),
        target: () => s.get() > E ? G : V
      };
    });
  }
  function g() {
    const T = a[0], P = c(u, T);
    return x(P, n, !1);
  }
  function b() {
    const T = t - a[0] - 1, P = c(v, T);
    return x(P, -n, !0);
  }
  function C() {
    return f.every(({
      index: T
    }) => {
      const P = v.filter((H) => H !== T);
      return m(P, t) <= 0.1;
    });
  }
  function A() {
    f.forEach((T) => {
      const {
        target: P,
        translate: H,
        slideLocation: Q
      } = T, N = P();
      N !== Q.get() && (H.to(N), Q.set(N));
    });
  }
  function I() {
    f.forEach((T) => T.translate.clear());
  }
  return {
    canLoop: C,
    clear: I,
    loop: A,
    loopPoints: f
  };
}
function Gd(e, t, n) {
  let r, o = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      o || (er(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function Kd(e, t, n, r) {
  const o = {};
  let i = null, a = null, s, l = !1;
  function h() {
    s = new IntersectionObserver((c) => {
      l || (c.forEach((p) => {
        const x = t.indexOf(p.target);
        o[x] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => s.observe(c));
  }
  function v() {
    s && s.disconnect(), l = !0;
  }
  function u(c) {
    return da(o).reduce((p, x) => {
      const g = parseInt(x), {
        isIntersecting: b
      } = o[g];
      return (c && b || !c && !b) && p.push(g), p;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && a) return a;
    const p = u(c);
    return c && (i = p), c || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function Jd(e, t, n, r, o, i) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: l
  } = e, h = n[0] && o, v = c(), u = p(), f = n.map(a), m = x();
  function c() {
    if (!h) return 0;
    const b = n[0];
    return ut(t[s] - b[s]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(jt(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function x() {
    return n.map((b, C, A) => {
      const I = !C, L = pi(A, C);
      return I ? f[C] + v : L ? f[C] + u : A[C + 1][s] - b[s];
    }).map(ut);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function Qd(e, t, n, r, o, i, a, s, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = gi(n);
  function m(g, b) {
    return ua(g).filter((C) => C % b === 0).map((C) => g.slice(C, C + b));
  }
  function c(g) {
    return g.length ? ua(g).reduce((b, C, A) => {
      const I = jt(b) || 0, L = I === 0, T = C === wa(g), P = o[h] - i[I][h], H = o[h] - i[C][v], Q = !r && L ? u(a) : 0, N = !r && T ? u(s) : 0, G = ut(H - N - (P + Q));
      return A && G > t + l && b.push(C), T && b.push(g.length), b;
    }, []).map((b, C, A) => {
      const I = Math.max(A[C - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : c(g);
  }
  return {
    groupSlides: p
  };
}
function ef(e, t, n, r, o, i, a) {
  const {
    align: s,
    axis: l,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: p,
    slidesToScroll: x,
    skipSnaps: g,
    containScroll: b,
    watchResize: C,
    watchSlides: A,
    watchDrag: I,
    watchFocus: L
  } = i, T = 2, P = Rd(), H = P.measure(t), Q = n.map(P.measure), N = Dd(l, h), G = N.measureSize(H), V = Fd(G), _ = $d(s, G), E = !u && !!b, M = u || !!b, {
    slideSizes: z,
    slideSizesWithGaps: q,
    startGap: X,
    endGap: U
  } = Jd(N, H, Q, n, M, o), oe = Qd(N, G, x, u, H, Q, X, U, T), {
    snaps: re,
    snapsAligned: fe
  } = qd(N, _, H, Q, oe), be = -jt(re) + jt(q), {
    snapsContained: Se,
    scrollContainLimit: de
  } = zd(G, be, fe, b, T), ye = E ? Se : fe, {
    limit: Ae
  } = Vd(be, ye, u), De = Vo(wa(ye), v, u), We = De.clone(), Ne = ua(n), ue = ({
    dragHandler: S,
    scrollBody: w,
    scrollBounds: K,
    options: {
      loop: O
    }
  }) => {
    O || K.constrain(S.pointerDown()), w.seek();
  }, Fe = ({
    scrollBody: S,
    translate: w,
    location: K,
    offsetLocation: O,
    previousLocation: ie,
    scrollLooper: D,
    slideLooper: J,
    dragHandler: y,
    animation: ce,
    eventHandler: Te,
    scrollBounds: d,
    options: {
      loop: ae
    }
  }, te) => {
    const k = S.settled(), F = !d.shouldConstrain(), ee = ae ? k : k && F, $e = ee && !y.pointerDown();
    $e && ce.stop();
    const xe = K.get() * te + ie.get() * (1 - te);
    O.set(xe), ae && (D.loop(S.direction()), J.loop()), w.to(O.get()), $e && Te.emit("settle"), ee || Te.emit("scroll");
  }, qe = Id(r, o, () => ue(R), (S) => Fe(R, S)), Ze = 0.68, Xe = ye[De.get()], Ve = na(Xe), Pe = na(Xe), rt = na(Xe), ct = na(Xe), me = Pd(Ve, rt, Pe, ct, f, Ze), Be = Zd(u, ye, be, Ae, ct), ze = Wd(qe, De, We, me, Be, ct, a), Ke = Ud(Ae), Je = fa(), ht = Kd(t, n, a, p), {
    slideRegistry: vt
  } = jd(E, b, ye, de, oe, Ne), tt = Xd(e, n, vt, ze, me, Je, a, L), R = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: a,
    containerRect: H,
    slideRects: Q,
    animation: qe,
    axis: N,
    dragHandler: Od(N, e, r, o, ct, Md(N, o), Ve, qe, ze, me, Be, De, a, V, m, c, g, Ze, I),
    eventStore: Je,
    percentOfView: V,
    index: De,
    indexPrevious: We,
    limit: Ae,
    location: Ve,
    offsetLocation: rt,
    previousLocation: Pe,
    options: i,
    resizeHandler: Nd(t, a, o, n, N, C, P),
    scrollBody: me,
    scrollBounds: Bd(Ae, rt, ct, me, V),
    scrollLooper: Hd(be, Ae, rt, [Ve, rt, Pe, ct]),
    scrollProgress: Ke,
    scrollSnapList: ye.map(Ke.get),
    scrollSnaps: ye,
    scrollTarget: Be,
    scrollTo: ze,
    slideLooper: Yd(N, G, be, z, q, re, ye, rt, n),
    slideFocus: tt,
    slidesHandler: Gd(t, a, A),
    slidesInView: ht,
    slideIndexes: Ne,
    slideRegistry: vt,
    slidesToScroll: oe,
    target: ct,
    translate: Ho(N, t)
  };
  return R;
}
function tf() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function o(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((u) => u !== v), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: a,
    on: i,
    clear: s
  };
  return l;
}
const nf = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function af(e) {
  function t(i, a) {
    return zo(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, s = da(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, s);
  }
  function r(i) {
    return i.map((a) => da(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function rf(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(i, e)), a.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function qa(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, i = af(o), a = rf(i), s = fa(), l = tf(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = l, p = N;
  let x = !1, g, b = h(nf, qa.globalOptions), C = h(b), A = [], I, L, T;
  function P() {
    const {
      container: Ne,
      slides: ue
    } = C;
    L = (Gr(Ne) ? e.querySelector(Ne) : Ne) || e.children[0];
    const qe = Gr(ue) ? L.querySelectorAll(ue) : ue;
    T = [].slice.call(qe || L.children);
  }
  function H(Ne) {
    const ue = ef(e, L, T, r, o, Ne, l);
    if (Ne.loop && !ue.slideLooper.canLoop()) {
      const Fe = Object.assign({}, Ne, {
        loop: !1
      });
      return H(Fe);
    }
    return ue;
  }
  function Q(Ne, ue) {
    x || (b = h(b, Ne), C = v(b), A = ue || A, P(), g = H(C), u([b, ...A.map(({
      options: Fe
    }) => Fe)]).forEach((Fe) => s.add(Fe, "change", N)), C.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(We), g.eventHandler.init(We), g.resizeHandler.init(We), g.slidesHandler.init(We), g.options.loop && g.slideLooper.loop(), L.offsetParent && T.length && g.dragHandler.init(We), I = a.init(We, A)));
  }
  function N(Ne, ue) {
    const Fe = oe();
    G(), Q(h({
      startIndex: Fe
    }, Ne), ue), l.emit("reInit");
  }
  function G() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), s.clear();
  }
  function V() {
    x || (x = !0, s.clear(), G(), l.emit("destroy"), l.clear());
  }
  function _(Ne, ue, Fe) {
    !C.active || x || (g.scrollBody.useBaseFriction().useDuration(ue === !0 ? 0 : C.duration), g.scrollTo.index(Ne, Fe || 0));
  }
  function E(Ne) {
    const ue = g.index.add(1).get();
    _(ue, Ne, -1);
  }
  function M(Ne) {
    const ue = g.index.add(-1).get();
    _(ue, Ne, 1);
  }
  function z() {
    return g.index.add(1).get() !== oe();
  }
  function q() {
    return g.index.add(-1).get() !== oe();
  }
  function X() {
    return g.scrollSnapList;
  }
  function U() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function oe() {
    return g.index.get();
  }
  function re() {
    return g.indexPrevious.get();
  }
  function fe() {
    return g.slidesInView.get();
  }
  function be() {
    return g.slidesInView.get(!1);
  }
  function Se() {
    return I;
  }
  function de() {
    return g;
  }
  function ye() {
    return e;
  }
  function Ae() {
    return L;
  }
  function De() {
    return T;
  }
  const We = {
    canScrollNext: z,
    canScrollPrev: q,
    containerNode: Ae,
    internalEngine: de,
    destroy: V,
    off: m,
    on: f,
    emit: c,
    plugins: Se,
    previousScrollSnap: re,
    reInit: p,
    rootNode: ye,
    scrollNext: E,
    scrollPrev: M,
    scrollProgress: U,
    scrollSnapList: X,
    scrollTo: _,
    selectedScrollSnap: oe,
    slideNodes: De,
    slidesInView: fe,
    slidesNotInView: be
  };
  return Q(t, n), setTimeout(() => l.emit("init"), 0), We;
}
qa.globalOptions = void 0;
function tr(e = {}, t = []) {
  const n = Ui(e), r = Ui(t);
  let o = n ? e.value : e, i = r ? t.value : t;
  const a = Sn(), s = Sn();
  function l() {
    s.value && s.value.reInit(o, i);
  }
  return kt(() => {
    !Cd() || !a.value || (qa.globalOptions = tr.globalOptions, s.value = qa(a.value, o, i));
  }), li(() => {
    s.value && s.value.destroy();
  }), n && He(e, (h) => {
    mi(o, h) || (o = h, l());
  }), r && He(t, (h) => {
    Td(i, h) || (i = h, l());
  }), [a, s];
}
tr.globalOptions = void 0;
const Og = ["default", "highlight"], Mg = ["click", "keyboard"], Jr = /* @__PURE__ */ Symbol();
var Ma = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ma || {});
const lf = ["tabindex"], of = {
  key: 0,
  class: "lc-carousel__arrows"
}, sf = ["aria-controls", "aria-current", "aria-label", "onClick"], cf = { class: "lc-carousel__dot-indicator" }, uf = ["aria-label", "aria-pressed"], vl = 1.08, df = /* @__PURE__ */ ke({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    arrows: { type: Boolean },
    autoPlay: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    fade: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    pagination: { type: Boolean },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = W(() => e.slides.length > 1), i = W(() => !e.disableSwipe && o.value), a = {
      align: "start",
      containScroll: "trimSnaps"
    }, s = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, l = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: i.value,
      watchResize: ({ containerNode: O, emit: ie, reInit: D }, J) => {
        if (!e.adaptiveHeight) return !0;
        for (const y of J) {
          if (O() === y.target) return !0;
          requestAnimationFrame(() => {
            D(), ie("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? s : a
    }, h = je.lcCarousel.autoPlayDelayInSeconds * 1e3, v = (O = e.fade) => [
      ...e.adaptiveHeight ? [Po()] : [],
      ...O ? [Bo()] : [],
      Qa({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [u, f] = tr(
      {
        ...l,
        startIndex: e.defaultIndex
      },
      v()
    ), m = Wn(Jr, () => null, !0), c = yo(), p = ge(0), x = ge(0), g = ge(!i.value), b = ge(!1), C = ge(!1), A = ge(!1), I = ge(!1), L = ge(!1), T = ge(), P = ge(e.defaultIndex), H = ge(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((O, ie) => ie)
      )
    );
    let Q = h, N, G, V, _, E, M;
    const z = W(() => je.lcCarousel), q = W(
      () => !!e.autoPlay && o.value && !I.value && !A.value && !b.value
    ), X = W(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--arrows": !!e.arrows && o.value,
        "lc-carousel--auto-play": !!e.autoPlay && o.value,
        "lc-carousel--auto-play-paused": !!e.autoPlay && !q.value,
        "lc-carousel--draggable": !g.value,
        "lc-carousel--fade": e.fade,
        "lc-carousel--keyboard-enabled": ze("keyboard"),
        "lc-carousel--swipe-hint": L.value
      }
    ]), U = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !1
      }), g.value = !0);
    }, oe = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !0
      }), g.value = !1);
    }, re = (O, ie) => e.keyExtractor ? e.keyExtractor(O, ie) : e.keyProp && Fu(e.keyProp, O) ? String(O[e.keyProp]) : String(ie), fe = (O) => {
      const ie = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return Ke(O) ? ie : {
        ...ie,
        "aria-hidden": "true",
        inert: "true"
      };
    }, be = ({ clientX: O }) => {
      if (!f.value || !ze("click") || g.value) return;
      const D = f.value.slideNodes().map((J) => J.getBoundingClientRect());
      for (const [J, { left: y, right: ce }] of D.entries())
        if (!(O < y || O > ce)) {
          vt(J);
          break;
        }
    }, Se = () => {
      C.value = !0, w(), K(), Ze(), r("ready");
    }, de = (O) => {
      if (!(!tn(O.key, Ma) || !ze("keyboard") || g.value))
        switch (O.preventDefault(), O.stopPropagation(), O.key) {
          case Ma.ArrowLeft:
            R();
            break;
          case Ma.ArrowRight:
            tt();
            break;
        }
    }, ye = () => {
      m?.disable(), Fe();
    }, Ae = () => {
      m?.enable(), Ze();
    }, De = () => {
      w(), K();
    }, We = () => {
      const O = f.value?.selectedScrollSnap() ?? 0;
      P.value = O, r("changed", O);
    }, Ne = () => {
      clearTimeout(G), G = void 0, N = void 0;
    }, ue = () => {
      clearTimeout(G), N = Date.now(), G = setTimeout(() => Xe(1), Q);
    }, Fe = () => {
      !G || N === void 0 || (Q = Math.max(0, Q - (Date.now() - N)), Ne());
    }, qe = () => {
      !q.value || G || ue();
    }, Ze = () => {
      if (Q = h, p.value += 1, !q.value) {
        Ne();
        return;
      }
      ue();
    }, Xe = (O) => {
      const ie = (P.value + O + e.slides.length) % e.slides.length;
      Ve(ie);
    }, Ve = (O) => {
      f.value?.scrollTo(O, Je(!0)), Ze();
    }, Pe = (O) => z.value.slideAriaLabel.replace("{slide}", String(O + 1)), rt = () => {
      if (q.value) {
        I.value = !0;
        return;
      }
      I.value = !1, A.value = !1;
    }, ct = () => {
      b.value = document.visibilityState === "hidden", ht();
    }, me = [
      ["focusin", () => A.value = !0],
      ["focusout", () => A.value = !1],
      ["mouseenter", () => A.value = !0],
      ["mouseleave", () => A.value = !1]
    ], Be = () => {
      clearTimeout(E), E = setTimeout(() => f.value?.reInit(), 50);
    }, ze = (O) => e.moveTriggers.includes(O), Ke = (O) => H.value.has(O), Je = (O) => !O || c.value === "reduce", ht = () => {
      const O = T.value?.querySelector(".lc-carousel__dot-progress")?.getAnimations?.().at(0);
      if (O) {
        if (q.value) {
          O.play();
          return;
        }
        O.pause();
      }
    }, vt = (O, ie = !0) => {
      f.value?.scrollTo(O, Je(ie));
    }, tt = (O = !0) => {
      f.value?.scrollNext(Je(O));
    }, R = (O = !0) => {
      f.value?.scrollPrev(Je(O));
    }, S = async () => {
      L.value || (L.value = !0, await new Promise((O) => {
        M = setTimeout(() => {
          L.value = !1, O();
        }, 1800);
      }));
    }, w = () => {
      if (!f.value || e.variant !== "highlight") return;
      const { rootNode: O, slideNodes: ie } = f.value, D = ie(), y = O().getBoundingClientRect(), ce = y.left + y.width / 2;
      let Te = D[0], d = 1 / 0;
      D.forEach((F) => {
        const ee = F.getBoundingClientRect(), $e = ee.left + ee.width / 2, xe = Math.abs($e - ce);
        xe < d && (Te = F, d = xe);
      });
      const k = Te.offsetWidth * (vl - 1) / 2;
      D.forEach((F, ee) => {
        if (F === Te) {
          x.value = ee, F.style.transform = `scale(${vl.toString()}) translateX(0px)`, F.style.zIndex = "1";
          return;
        }
        const $e = F.getBoundingClientRect(), Le = $e.left + $e.width / 2 < ce ? -1 : 1;
        F.style.transform = `scale(1) translateX(${(Le * k).toString()}px)`, F.style.zIndex = "0";
      });
    }, K = () => {
      if (!f.value) return;
      const O = f.value.slidesInView();
      if (!O.length) return;
      const ie = e.slides.length, D = /* @__PURE__ */ new Set();
      O.forEach((J) => {
        for (let y = -e.visibleSlideBuffer; y <= e.visibleSlideBuffer; y++) {
          const ce = (J + y + ie) % ie;
          D.add(ce);
        }
      }), H.value = D;
    };
    return kt(() => {
      document.addEventListener("visibilitychange", ct), f.value && (f.value.on("init", Se).on("pointerDown", ye).on("pointerUp", Ae).on("reInit", De).on("resize", K).on("scroll", w).on("select", We).on("slidesChanged", w).on("slidesInView", K), _ = f.value.rootNode(), me.forEach(
        ([O, ie]) => _?.addEventListener(O, ie)
      ), e.adaptiveHeight && (V = new ResizeObserver(Be), f.value.slideNodes().forEach((O) => V?.observe(O))));
    }), Ln(() => {
      document.removeEventListener("visibilitychange", ct), me.forEach(
        ([O, ie]) => _?.removeEventListener(O, ie)
      ), Ne(), clearTimeout(M), clearTimeout(E), V?.disconnect();
    }), He(
      [i, () => e.fade, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([O, ie, D, J, y]) => {
        g.value = !O, f.value?.reInit(
          {
            ...l,
            loop: D,
            skipSnaps: J,
            watchDrag: O,
            ...y === "highlight" ? s : a
          },
          v(ie)
        );
      }
    ), He(q, (O) => O ? qe() : Fe()), t({
      disable: U,
      enable: oe,
      moveToIndex: vt,
      next: tt,
      prev: R,
      showSwipeHint: S
    }), oi(Jr, {
      disable: U,
      enable: oe
    }), (O, ie) => ($(), Z("div", {
      class: pe(X.value),
      style: Et(
        e.autoPlay ? { "--lc-carousel-auto-play-delay": `${h}ms` } : void 0
      ),
      tabindex: ze("keyboard") ? 0 : void 0,
      onClickPassive: be,
      onKeydown: de
    }, [
      ne("div", {
        ref_key: "emblaRef",
        ref: u,
        class: "lc-carousel__container"
      }, [
        ne("div", Ce({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), Z(at, null, yt(e.slides, (D, J) => ve(O.$slots, "slide", Ce({ ref_for: !0 }, { slide: D, index: J }, {
            key: re(D, J),
            attributes: fe(J),
            isHighlighted: x.value === J,
            isVisible: Ke(J)
          }))), 128))
        ], 16),
        e.arrows && o.value ? ($(), Z("nav", of, [
          Re(j(Ct), {
            "aria-controls": e.id,
            "aria-label": z.value.prevSlideAriaLabel,
            icon: "chevron-left",
            size: "small",
            variant: "filled",
            onClick: ie[0] || (ie[0] = (D) => Xe(-1))
          }, null, 8, ["aria-controls", "aria-label"]),
          Re(j(Ct), {
            "aria-controls": e.id,
            "aria-label": z.value.nextSlideAriaLabel,
            icon: "chevron-right",
            size: "small",
            variant: "filled",
            onClick: ie[1] || (ie[1] = (D) => Xe(1))
          }, null, 8, ["aria-controls", "aria-label"])
        ])) : se("", !0)
      ], 512),
      e.pagination && o.value ? ($(), Z("div", {
        key: 0,
        ref_key: "paginationElement",
        ref: T,
        class: "lc-carousel__pagination"
      }, [
        ($(!0), Z(at, null, yt(e.slides, (D, J) => ($(), Z("button", {
          key: re(D, J),
          "aria-controls": e.id,
          "aria-current": P.value === J ? "true" : void 0,
          "aria-label": Pe(J),
          class: pe(["lc-carousel__dot", { "lc-carousel__dot--active": P.value === J }]),
          type: "button",
          onClick: (y) => Ve(J)
        }, [
          ne("span", cf, [
            e.autoPlay && P.value === J ? ($(), Z("span", {
              key: p.value,
              class: "lc-carousel__dot-progress"
            })) : se("", !0)
          ])
        ], 10, sf))), 128)),
        e.autoPlay ? ($(), Z("button", {
          key: 0,
          "aria-label": q.value ? z.value.pauseAriaLabel : z.value.playAriaLabel,
          "aria-pressed": q.value ? "false" : "true",
          class: "lc-carousel__auto-play-toggle",
          type: "button",
          onClick: rt
        }, [
          Re(j(et), {
            name: q.value ? "pause" : "play-filled",
            size: "small"
          }, null, 8, ["name"])
        ], 8, uf)) : se("", !0)
      ], 512)) : se("", !0)
    ], 46, lf));
  }
}), ff = ["for"], hf = { class: "lc-checkbox__control" }, vf = ["id", "data-click-name"], mf = ["id"], Rg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = It(e.id), { vibrate: o } = wo(), i = W(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), Z("div", {
      class: pe([i.value, s.$attrs.class])
    }, [
      ne("label", {
        class: "lc-checkbox__wrap",
        for: j(r)
      }, [
        ne("div", hf, [
          Qt(ne("input", Ce({ id: j(r) }, {
            ...en(s.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = si((h) => a.value = !a.value, ["enter"]))
          }), null, 16, vf), [
            [ho, a.value]
          ]),
          Re(j(et), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(r)}-label`,
          class: "lc-checkbox__label"
        }, Oe(e.label), 9, mf)) : se("", !0)
      ], 8, ff),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Uo = () => typeof window > "u";
function gf(e, t) {
  const n = pa(), r = typeof e == "string" ? e : void 0, o = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, o) : n.useState(o);
  const i = o ? nt(o()) : void 0;
  return ge(i);
}
const yi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, qo = (e, t) => fu({
  end: new Date(t),
  start: new Date(e)
}), jo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...yi[t],
  timeZone: r
}).format(new Date(e)), kr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), bf = 2147483647, pf = /* @__PURE__ */ ke({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, o = Uo(), i = gf(() => /* @__PURE__ */ new Date()), a = ge(!1);
    let s, l;
    const h = W(() => {
      if (a.value) return n;
      const { hours: A, minutes: I, seconds: L } = qo(i.value, m.value);
      return {
        ...n,
        hours: A || 0,
        minutes: I || 0,
        seconds: L || 0
      };
    }), v = W(() => u.value ? m.value.toISOString() : void 0), u = W(() => Ua(m.value)), f = W(() => {
      const { hours: A, minutes: I, seconds: L } = h.value, T = `${kr(I)}:${kr(L)}`;
      return e.variant === "without-hours" ? T : `${kr(A)}:${T}`;
    }), m = W(() => new Date(e.expiresAt)), c = () => {
      clearInterval(s), clearTimeout(l);
    }, p = () => {
      a.value || (a.value = !0, r("expired"), c());
    }, x = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, g = () => hu(m.value), b = () => {
      if (!u.value) return;
      const A = m.value.getTime() - Date.now();
      A > bf || (l = setTimeout(p, Math.max(0, A)));
    }, C = () => {
      c(), b(), s = setInterval(() => {
        g() ? p() : x();
      }, 1e3);
    };
    return li(() => {
      c();
    }), He(
      v,
      () => {
        o || (a.value = !1, C());
      },
      {
        immediate: !0
      }
    ), (A, I) => u.value ? ($(), Z("time", Ce({ key: 0 }, { datetime: v.value }, { class: "lc-countdown" }), Oe(f.value), 17)) : se("", !0);
  }
}), Fg = ["default", "without-hours"], yf = { class: "lc-data-list" }, Ng = /* @__PURE__ */ ke({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), Z("ul", yf, [
      ve(t.$slots, "default")
    ]));
  }
}), wf = { class: "lc-data-list-item" }, xf = { class: "lc-data-list-item__content" }, kf = {
  key: 0,
  class: "lc-data-list-item__headline"
}, Sf = {
  key: 0,
  class: "lc-data-list-item__text"
}, _f = { key: 0 }, Ef = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, Pg = /* @__PURE__ */ ke({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("li", wf, [
      ne("div", xf, [
        ne("section", null, [
          e.headline ? ($(), Z("span", kf, Oe(e.headline), 1)) : se("", !0),
          ve(t.$slots, "default", {}, () => [
            e.text ? ($(), Z("p", Sf, Oe(e.text), 1)) : se("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), Z("aside", _f, [
          ve(t.$slots, "suffix")
        ])) : se("", !0)
      ]),
      t.$slots.underneath ? ($(), Z("div", Ef, [
        ve(t.$slots, "underneath")
      ])) : se("", !0)
    ]));
  }
});
var Cf = Object.defineProperty, Tf = (e, t, n) => t in e ? Cf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oa = (e, t, n) => Tf(e, typeof t != "symbol" ? t + "" : t, n);
const ml = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, gl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), bl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, Af = (e, t = !0, n) => {
  var r, o, i, a;
  const s = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((o = n.number) == null ? void 0 : o.fraction) ?? 0;
  let h = bl(0, l, n);
  const v = h.formatToParts(1000.12), u = ((i = v.find((x) => x.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((x) => x.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = gl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return s;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const x = c[1].length <= l ? c[1].length : l;
    h = bl(x, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = gl(p, u, f), s + p;
}, Zo = (e) => JSON.parse(e.replaceAll("'", '"')), Lf = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = $f(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = $a(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = $a(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = $a(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = If(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = $a(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, $a = (e) => e !== "" ? !!JSON.parse(e) : !0, $f = (e) => e.startsWith("[") && e.endsWith("]") ? Zo(e) : e, If = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Zo(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Wo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Wo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class Df {
  constructor(t = {}) {
    oa(this, "opts", {}), oa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...ml, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Wo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = ml;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, o) => r.length - o.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((o) => this.process(t, o, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((o, i) => {
      o === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(o);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return Af(t, r, this.opts);
    if (n == null) return t;
    const o = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(o)) return this.memo.get(o);
    const { mask: i, escaped: a } = this.escapeMask(n), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => x > -1 && g > -1 : () => x < i.length && g < t.length, m = (C) => !this.isReversed() && C <= u || this.isReversed() && C >= u;
    let c, p = -1, x = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const C = i.charAt(x), A = l[C], I = A?.transform != null ? A.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(x) && A != null ? (I.match(A.pattern) != null ? (s[v](I), A.repeated ? (p === -1 ? p = x : x === u && x !== p && (x = p - h), u === p && (x -= h)) : A.multiple && (b = !0, x -= h), x += h) : A.multiple ? b && (x += h, g -= h, b = !1) : I === c ? c = void 0 : A.optional && (x += h, g -= h), g += h) : (r && !this.isEager() && s[v](C), I === C && !this.isEager() ? g += h : c = C, this.isEager() || (x += h)), this.isEager())
        for (; m(x) && (l[i.charAt(x)] == null || a.includes(x)); ) {
          if (r) {
            if (s[v](i.charAt(x)), t.charAt(g) === i.charAt(x)) {
              x += h, g += h;
              continue;
            }
          } else i.charAt(x) === t.charAt(g) && (g += h);
          x += h;
        }
    }
    return this.memo.set(o, s.join("")), this.memo.get(o);
  }
}
const Xo = ["text", "search", "url", "tel", "password"];
let Of = class {
  constructor(t, n = {}) {
    oa(this, "items", /* @__PURE__ */ new Map()), oa(this, "eventAbortController"), oa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const o = r.target, i = this.items.get(o);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), s = i.isEager(), l = a && s && i.unmasked(o.value) === "" ? "" : o.value;
      this.fixCursor(o, a, () => this.setValue(o, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!Xo.includes(r.type)) return;
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const o = new Df(Lf(r, n));
      this.items.set(r, o), queueMicrotask(() => this.updateValue(r));
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: o, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var o, i, a;
    const s = t.selectionStart, l = t.value;
    if (r(), s === null || s === l.length && !n) return;
    const h = t.value, v = l.slice(0, s), u = h.slice(0, s), f = (o = this.processInput(t, v)) == null ? void 0 : o.unmasked, m = (i = this.processInput(t, u)) == null ? void 0 : i.unmasked;
    if (f === void 0 || m === void 0) return;
    let c = s;
    if (v !== u)
      if (n)
        c += h.length - l.length;
      else if (f.length === 0)
        c = 0;
      else {
        c = h.length;
        for (let p = 1; p <= h.length; p++)
          if ((((a = this.processInput(t, h.slice(0, p))) == null ? void 0 : a.unmasked) ?? "").length >= f.length) {
            c = p;
            break;
          }
      }
    t.setSelectionRange(c, c);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((o) => o(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let o = n ?? t.value;
    this.options.preProcess != null && (o = this.options.preProcess(o));
    let i = r.masked(o);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(o),
      completed: r.completed(o)
    };
  }
};
const Sr = /* @__PURE__ */ new WeakMap(), Mf = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, Rf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || !Xo.includes(r.type)) return;
  let o = {};
  if (t.value != null && (o = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const s = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      Mf(t, s);
    };
    o.onMaska = o.onMaska == null ? i : Array.isArray(o.onMaska) ? [...o.onMaska, i] : [o.onMaska, i];
  }
  Sr.has(r) ? (n = Sr.get(r)) == null || n.update(o) : Sr.set(r, new Of(r, o));
}, Ff = ["for"], Nf = ["id"], Pf = { class: "lc-input__input-wrap" }, Bf = ["data-testid"], zf = ["data-testid"], nr = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, o = n, i = ft("input"), a = It(e.id), s = ge(!1), l = W(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = W(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => s.value = !0,
      onFocusout: () => s.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = W(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": s.value || !!e.value || typeof e.value == "number"
      }
    ]), u = W(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = W({
      get: () => e.value,
      set: (c) => {
        o("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return kt(() => {
      e.autofocus && i.value?.focus(), e.value && o("update:value", e.value);
    }), t({ ref: i }), (c, p) => ($(), Z("div", {
      class: pe([l.value, c.$attrs.class])
    }, [
      ne("label", {
        class: "lc-input__wrap",
        for: j(a)
      }, [
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(a)}-label`,
          class: pe(v.value)
        }, Oe(e.label), 11, Nf)) : se("", !0),
        ne("div", Pf, [
          c.$slots.prefix ? ($(), Z("div", {
            key: 0,
            class: pe(["lc-input__prefix", e.prefixClass])
          }, [
            ve(c.$slots, "prefix")
          ], 2)) : se("", !0),
          e.mask ? Qt(($(), Z("input", Ce({
            key: 1,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, Bf)), [
            [qi, f.value],
            [j(Rf), u.value]
          ]) : Qt(($(), Z("input", Ce({
            key: 2,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, zf)), [
            [qi, f.value]
          ]),
          c.$slots.suffix ? ($(), Z("div", {
            key: 3,
            class: pe(["lc-input__suffix", e.suffixClass])
          }, [
            ve(c.$slots, "suffix")
          ], 2)) : se("", !0)
        ])
      ], 8, Ff),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), zg = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], Vg = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], Hg = /* @__PURE__ */ ke({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (n, r) => ($(), we(j(nr), Ce({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), Vf = { class: "lc-description-list" }, Ug = /* @__PURE__ */ ke({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), Z("dl", Vf, [
      ve(t.$slots, "default")
    ]));
  }
}), Yo = /* @__PURE__ */ Symbol();
var ln = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(ln || {});
const qg = /* @__PURE__ */ ke({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ga(e, ["index"]), i = ft("input"), a = Wn(Yo, () => null, !0), s = W(() => nt(a?.config)), l = W(() => o.disabled || !!nt(a?.disabled)), h = W(() => l.value ? "*" : "#"), v = W({
      get: () => l.value ? "X" : f.value,
      set: (c) => {
        if (l.value || c === "X") return;
        const p = typeof c == "number" ? c : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), u = W(() => a ? `${nt(a.name)}_input_${e.index}` : o.name), f = W(() => a ? nt(a.value)?.[e.index] : o.value), m = (c) => {
      if (tn(c.key, ln))
        switch (c.key !== ln.Dead && c.preventDefault(), c.key) {
          case ln.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case ln.ArrowRight:
            a?.focusNext(e.index);
            break;
          case ln.Backspace:
          case ln.Delete:
            v.value = null;
            break;
          case ln.Dead: {
            const p = c.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(c.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (c, p) => ($(), we(j(nr), Ce({ ref: "input" }, { ...c.$attrs, ...o, ...s.value, disabled: l.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), Hf = ["id"], Uf = ["id"], qf = ["aria-labelledby"], jg = /* @__PURE__ */ ke({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ge([]), i = It(e.id), a = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, s = () => {
      const f = o.value.findIndex((m) => !m.disabled);
      o.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= o.value.length) return;
      const m = o.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = o.value.slice(0, f).reverse().find(({ disabled: x }) => !x)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= o.value.length) return;
      const p = o.value[c];
      if (p.disabled) {
        v(c, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (o.value[m.index] = m);
    };
    return kt(s), t({ focusFirstEnabledInput: s, focusInputByIndex: l }), oi(Yo, {
      config: vo(
        W(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), Z("fieldset", Ce(f.$attrs, {
      id: j(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), Z("legend", {
        key: 0,
        id: `${j(i)}-label`,
        class: pe(["lc-digit-input-group__label", e.legendClass])
      }, [
        ve(f.$slots, "legend")
      ], 10, Uf)) : se("", !0),
      ne("div", {
        "aria-labelledby": f.$slots.legend ? `${j(i)}-label` : void 0,
        class: pe(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        ve(f.$slots, "default", $t(Rt({ setRef: u })))
      ], 10, qf),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, Hf));
  }
}), jf = ["id"], Zf = ["aria-expanded"], Wf = ["aria-expanded"], Xf = /* @__PURE__ */ ke({
  __name: "LcExpandable",
  props: /* @__PURE__ */ _n({
    actionClass: {},
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    hideIcon: { type: Boolean },
    headerTag: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = It(e.id), r = `${n}-region`, o = Xa(e, "modelValue"), i = W(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": o.value,
        "lc-expandable--with-action": !!t.action
      }
    ]), a = W(() => ["lc-expandable__action", e.actionClass]), s = W(() => ["lc-expandable__content", e.contentClass]), l = () => {
      o.value = !o.value;
    };
    return (h, v) => ($(), Z("article", Ce(h.$attrs, {
      id: j(n),
      class: i.value
    }), [
      e.headerTag ? ($(), we(Nt(e.headerTag), {
        key: 0,
        class: "lc-expandable__heading"
      }, {
        default: _e(() => [
          ne("button", Ce({ "aria-controls": r }, { disabled: e.disabled }, {
            "aria-expanded": o.value,
            class: ["lc-expandable__header", e.headerClass],
            type: "button",
            onClickPassive: l
          }), [
            ve(h.$slots, "header"),
            e.disabled ? se("", !0) : ($(), we(j(et), {
              key: 0,
              class: "lc-expandable__header-icon",
              name: "chevron-down"
            }))
          ], 16, Zf)
        ]),
        _: 3
      })) : ($(), Z("button", Ce({
        key: 1,
        "aria-controls": r
      }, { disabled: e.disabled }, {
        "aria-expanded": o.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: l
      }), [
        ve(h.$slots, "header"),
        !e.disabled && !e.hideIcon ? ($(), we(j(et), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        })) : se("", !0)
      ], 16, Wf)),
      t.action ? ($(), Z("div", {
        key: 2,
        class: pe(a.value)
      }, [
        ve(h.$slots, "action")
      ], 2)) : se("", !0),
      e.animated ? ($(), we(j(Ro), {
        key: 3,
        animated: "",
        class: "lc-expandable__collapse",
        when: o.value,
        onCollapse: v[0] || (v[0] = (u) => h.$emit("collapse")),
        onCollapsed: v[1] || (v[1] = (u) => h.$emit("collapsed")),
        onExpand: v[2] || (v[2] = (u) => h.$emit("expand")),
        onExpanded: v[3] || (v[3] = (u) => h.$emit("expanded"))
      }, {
        default: _e(() => [
          ne("section", {
            id: r,
            class: pe(s.value),
            role: "region"
          }, [
            ve(h.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Qt(($(), Z("section", {
        key: 4,
        id: r,
        class: pe(s.value),
        role: "region"
      }, [
        ve(h.$slots, "default")
      ], 2)), [
        [ci, o.value]
      ])
    ], 16, jf));
  }
}), Yf = { class: "lc-expandable-list" }, Zg = /* @__PURE__ */ ke({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), Z("div", Yf, [
      ve(t.$slots, "default")
    ]));
  }
}), Gf = () => {
  const e = ge(!1);
  return kt(() => {
    e.value = !0;
  }), Ln(() => {
    e.value = !1;
  }), e;
}, Kf = {
  key: 0,
  class: "lc-fly-out__illustration"
}, Jf = { class: "lc-fly-out__message" }, Wg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => je.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => je.lcFlyOut.to },
    visibleInSeconds: { default: () => je.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = Gf(), o = W(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = ta(
      () => {
        n("update:isVisible", !1);
      },
      o,
      { immediate: !1 }
    );
    return Ln(a), He(
      () => e.isVisible,
      (s) => {
        s ? i() : a();
      },
      { immediate: !0 }
    ), (s, l) => j(r) ? ($(), we(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Re(j(ca), { name: "slide-down-lg" }, {
        default: _e(() => [
          e.isVisible ? ($(), Z("div", Ce({ key: 0 }, s.$attrs, { class: "lc-fly-out__container" }), [
            Re(j(Ru), {
              class: "lc-fly-out__timer",
              "duration-in-ms": o.value
            }, {
              default: _e(() => [
                Re(j(Ct), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => s.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            s.$slots.default ? ($(), Z("div", Kf, [
              ve(s.$slots, "default")
            ])) : se("", !0),
            ne("p", Jf, Oe(e.message), 1)
          ], 16)) : se("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function pl(e) {
  return Number(e) >= 0;
}
function Qf(e) {
  return typeof e == "object" && e !== null;
}
function e0(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function yl(e) {
  if (!Qf(e) || e0(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Go(e, t) {
  return Object.keys(t).forEach((n) => {
    if (yl(t[n]) && yl(e[n])) {
      e[n] || (e[n] = {}), Go(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function t0(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var o;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((o = a.inner) === null || o === void 0) && o.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const s = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(s) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? Go(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return wl(e.spec);
        const o = n0(r, e);
        return o ? wl(o) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function wl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function n0(e, t) {
  if (!xl(t))
    return null;
  if (cc(e)) {
    const o = t.fields[uc(e)];
    return o?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let o = 0; o < n.length; o++) {
    const i = n[o];
    if (xl(r) && i in r.fields ? r = r.fields[i] : a0(r) && pl(i) ? r = r.spec.types[Number(i)] : pl(i) && r0(r) && (r = r.innerType), o === n.length - 1)
      return r.spec;
  }
  return null;
}
function a0(e) {
  return ha(e) && e.type === "tuple";
}
function xl(e) {
  return ha(e) && e.type === "object";
}
function r0(e) {
  return ha(e) && e.type === "array";
}
const Xg = /* @__PURE__ */ ke({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    } = dc({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? t0(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        o.value = !0;
        const { valid: c, values: p } = await v();
        c && n.onSubmit && await n.onSubmit(p), c && n.resetOnSubmit && s();
      } finally {
        o.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    }), (m, c) => ($(), Z("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      ve(m.$slots, "default", $t(Rt({ isSubmitting: j(o), meta: j(i), values: j(u) })))
    ], 32));
  }
}), Yg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Ko = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Ko || {});
const Bt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, i0 = { class: "lc-form-field" }, Gg = /* @__PURE__ */ ke({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Bt.Blur, Bt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Change],
      lazy: () => [Bt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: o,
      handleChange: i,
      meta: a,
      value: s
    } = fc(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Bt.Blur]: (f) => u(f, !0),
      [Bt.Change]: (f) => i(f, !0),
      [Bt.Update]: (f) => i(f, !0)
    }, h = W(() => ({
      errorMessage: r.value,
      name: e.name,
      value: s.value,
      ...v.value
    })), v = W(() => {
      const f = {
        [Bt.Blur]: (m) => u(m, !1),
        [Bt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), u = async (f, m) => {
      if (o(f, m), await Ya(), !f) return;
      const c = new CustomEvent(Ko.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => ($(), Z("div", i0, [
      ve(f.$slots, "default", $t(Rt({ field: h.value })))
    ]));
  }
}), l0 = ["id"], o0 = { ref: "wrapper" }, s0 = { class: "lc-header__wrap" }, c0 = { class: "lc-header__left-button-wrap" }, u0 = { class: "lc-header__headline-wrap" }, d0 = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, f0 = ["id", "aria-labelledby"], h0 = { class: "lc-header__fly-out-content-container" }, Kg = /* @__PURE__ */ ke({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => je.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => je.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = ft("wrapper"), n = It(e.id), r = ge(!1), o = W(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ka(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...nt(e.ignoreOutsideClickOn)] }
    ), (a, s) => ($(), Z("header", {
      id: j(n),
      class: pe(o.value)
    }, [
      ne("div", o0, [
        ne("div", s0, [
          ne("div", c0, [
            Re(j(Ct), Ce({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: s[0] || (s[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ne("div", u0, [
            ne("h1", {
              class: pe(["lc-header__headline", e.headlineClass])
            }, [
              ve(a.$slots, "headline")
            ], 2)
          ]),
          ve(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), Z("div", d0, [
              Re(j(Ct), {
                id: `${j(n)}-toggle`,
                "aria-controls": `${j(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: pe(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: _e(() => [
                  ve(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : se("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), Z("div", {
          key: 0,
          id: `${j(n)}-region`,
          "aria-labelledby": `${j(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ne("div", h0, [
            ne("div", {
              class: pe(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              ve(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, f0)) : se("", !0)
      ], 512),
      ve(a.$slots, "default")
    ], 10, l0));
  }
}), v0 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = W(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), Z("div", {
      class: pe(t.value),
      style: Et({
        "--ball-opacity": e.opacity
      })
    }, Oe(e.content), 7));
  }
}), m0 = { class: "lc-high-frequency-ball-background" }, Jo = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", m0, [
      ($(!0), Z(at, null, yt(e.ballConfig, (r, o) => ($(), we(v0, {
        key: o,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Et({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ne("div", {
        class: pe(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), g0 = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, b0 = { class: "lc-lottery-jackpot__value" }, p0 = { class: "lc-lottery-jackpot__currency" }, y0 = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, kl = 10 ** 9, Sl = 10 ** 6, w0 = "mil millones", x0 = "mil M", Qo = /* @__PURE__ */ ke({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = kl * 100, n = Sl * 100, r = W(() => {
      let a;
      const s = e.value >= t, l = e.value >= n;
      switch (!0) {
        case s:
          a = Math.floor(e.value / kl) / 100;
          break;
        case l:
          a = Math.floor(e.value / Sl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = l || s;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(c));
    }), o = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = W(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === w0 ? x0 : a;
    });
    return (a, s) => ($(), Z("div", {
      class: pe([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), Z("span", g0, Oe(e.placeholder), 1)) : ($(), Z(at, { key: 1 }, [
        ne("span", b0, [
          ne("span", p0, Oe(o.value), 1),
          ne("span", null, Oe(r.value), 1)
        ]),
        i.value ? ($(), Z("span", y0, Oe(i.value), 1)) : se("", !0)
      ], 64))
    ], 2));
  }
}), Jg = ["large", "medium", "small"], k0 = { class: "lc-info-button__modal" }, S0 = { class: "lc-info-button__modal-header" }, _0 = { class: "lc-info-button__modal-headline" }, E0 = { class: "lc-info-button__modal-text" }, es = /* @__PURE__ */ ke({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => je.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => je.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = vi(), n = ge(!1), r = () => {
      n.value = !1;
    }, o = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), Z("div", {
      class: pe(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Re(j(Ct), Ce({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: o
      }), null, 16, ["aria-label"]),
      j(t) && n.value ? ($(), we(j(No), Ce({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: _e(() => [
          ne("div", k0, [
            ne("header", S0, [
              ne("span", _0, Oe(e.headline), 1),
              Re(j(Ct), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            ve(i.$slots, "default", {}, () => [
              ne("p", E0, Oe(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : se("", !0)
    ], 2));
  }
}), Qg = ["default", "prominent"], C0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", T0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", A0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", L0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", $0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, I0 = ["src"], D0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, O0 = ["src"], M0 = 8, rn = 10, R0 = 20, F0 = /* @__PURE__ */ ke({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = W(() => o.value.length > 1), r = W(() => {
      switch (e.variant) {
        case "fire":
          return C0;
        case "pie":
          return A0;
        case "star":
          return L0;
        default:
          return null;
      }
    }), o = W(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, R0);
      if (i.length <= M0) return [i];
      const s = i.split(" ").filter(Boolean);
      if (s.length === 1)
        return [
          i.slice(0, rn),
          i.slice(rn)
        ];
      let l = "";
      const h = [];
      return s.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= rn) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > rn) {
          if (l.length > 0) {
            let u = 0;
            l.length < rn && (l += " ", u = rn - l.length, l += v.slice(0, u)), h.push(l), h.push(v.slice(u)), l = "";
            return;
          }
          h.push(v.slice(0, rn)), l = v.slice(rn);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), Z("div", {
      class: pe(t.value)
    }, [
      e.variant === "price-tag" ? ($(), Z("svg", $0, [...a[0] || (a[0] = [
        ne("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : se("", !0),
      r.value ? ($(), Z("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, I0)) : se("", !0),
      e.variant !== "new" ? ($(), Z("span", D0, Oe(o.value.join(`
`)), 1)) : ($(), Z("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: j(T0),
        width: "48"
      }, null, 8, O0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), we(j(es), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${j(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 2));
  }
}), e2 = ["fire", "lightning", "money", "star"], t2 = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], n2 = ["bottom-m", "bottom-xl", "top-m", "top-xl"], ts = ["badge", "default", "hero"];
var ns = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(ns || {});
const N0 = { class: "lc-teaser-hero-badge__text-wrap" }, P0 = /* @__PURE__ */ ke({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => ns.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", {
      class: pe(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Et({
        "--teaser-badge-color": e.color
      })
    }, [
      ne("div", N0, [
        ne("span", null, Oe(e.title), 1),
        ne("span", null, Oe(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), we(j(es), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${j(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 6));
  }
}), B0 = (e) => !!e.title && !!e.subtitle, z0 = { class: "lc-teaser__background" }, ar = /* @__PURE__ */ ke({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = cn(), n = W(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, o) => ($(), we(j(ya), Ce({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Ga({
      default: _e(() => [
        ve(r.$slots, "default"),
        e.badge ? ($(), Z(at, { key: 0 }, [
          j(B0)(e.badge) ? ($(), we(P0, $t(Ce({ key: 0 }, e.badge)), null, 16)) : ($(), we(F0, $t(Ce({ key: 1 }, e.badge)), null, 16))
        ], 64)) : se("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: _e(() => [
          ne("div", z0, [
            ve(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: _e(() => [
          ve(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: _e(() => [
          ve(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), V0 = { class: "lc-high-frequency-teaser__background" }, H0 = { class: "lc-high-frequency-teaser__jackpot-section" }, U0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, q0 = { class: "lc-high-frequency-teaser__button-container" }, j0 = { class: "lc-high-frequency-teaser__button-wrap" }, Z0 = { class: "lc-high-frequency-teaser__hint-container" }, W0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, a2 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    cn();
    const t = W(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = W(
      () => e.primaryButtonProps.to ? Xn(e.primaryButtonProps.to) : "div"
    );
    return (r, o) => ($(), we(j(ar), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: _e(() => [
        ne("div", V0, [
          Re(j(Jo), $t(Rt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: _e(() => [
        ve(r.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        ne("section", H0, [
          ($(), we(Nt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), Z("strong", U0, Oe(e.headline), 1)) : se("", !0),
              Re(j(Qo), Ce(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", q0, [
          ne("div", j0, [
            ve(r.$slots, "primary-button", {}, () => [
              Re(j(Ct), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: o[0] || (o[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  Tt(Oe(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ne("section", Z0, [
          e.hint ? ($(), Z("p", W0, [
            ve(r.$slots, "hint", {}, () => [
              Tt(Oe(e.hint), 1)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), X0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, Y0 = ["stroke"], G0 = ["stroke"], _l = "lc-high-frequency-teaser-watch-arrows-gradient-1", El = "lc-high-frequency-teaser-watch-arrows-gradient-2", K0 = /* @__PURE__ */ ke({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), Z("svg", X0, [
      ne("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${_l})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, Y0),
      n[2] || (n[2] = ne("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${El})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, G0),
      n[3] || (n[3] = ne("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("defs", null, [
        ne("linearGradient", {
          id: _l,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ne("linearGradient", {
          id: El,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), J0 = {}, Q0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function eh(e, t) {
  return $(), Z("svg", Q0, [...t[0] || (t[0] = [
    Zs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const th = /* @__PURE__ */ hi(J0, [["render", eh], ["__scopeId", "data-v-0c679bcf"]]), nh = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, ah = ["fill"], Cl = "lc-high-frequency-teaser-watch-play-button-gradient", rh = /* @__PURE__ */ ke({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), Z("svg", nh, [
      n[1] || (n[1] = ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${Cl})`
      }, null, 8, ah),
      ne("defs", null, [
        ne("radialGradient", {
          id: Cl,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ea = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, ih = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, lh = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, oh = { class: "lc-high-frequency-teaser-watch__game-badge" }, sh = { class: "lc-high-frequency-teaser-watch__game-label" }, ch = { class: "lc-high-frequency-teaser-watch__game-number" }, uh = { class: "lc-high-frequency-teaser-watch__game-icon" }, dh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, fh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, hh = { class: "lc-high-frequency-teaser-watch__timer-value" }, vh = { class: "lc-high-frequency-teaser-watch__timer-unit" }, mh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, gh = { class: "lc-high-frequency-teaser-watch__main" }, bh = { class: "lc-high-frequency-teaser-watch__title" }, r2 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = ge("idle"), n = ge(e.gameNumber), r = ge(!1), o = ge(0), i = W(() => e.to ? Xn(e.to) : "div"), a = W(() => String(n.value).split("")), s = W(() => t.value === "spinning"), l = W(() => t.value === "idle" || s.value), h = W(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": s.value
    })), v = W(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": s.value
    })), u = W(() => ({
      "lc-high-frequency-teaser-watch__arrows--idle-spin": o.value > 0 && t.value === "idle",
      "lc-high-frequency-teaser-watch__arrows--spinning": s.value
    })), f = W(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = xo(
      () => {
        t.value === "idle" && e.isOperational && o.value++;
      },
      ea.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: x } = ta(
      () => {
        t.value = "spinning";
      },
      ea.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ta(
      () => t.value = "paused",
      ea.PAUSE_DELAY,
      { immediate: !1 }
    ), C = ge(e.gameNumber), { start: A, stop: I } = ta(
      () => {
        t.value = "label", n.value = C.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ea.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: T } = ta(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      ea.IDLE_DELAY,
      { immediate: !1 }
    ), P = () => {
      x(), b(), I(), T();
    };
    return He(
      () => e.isOperational,
      (H) => {
        H ? c() : (P(), m(), t.value = "idle", r.value = !1);
      }
    ), He(
      () => e.gameNumber,
      (H, Q) => {
        if (H === Q || !e.isOperational) {
          n.value = H;
          return;
        }
        P(), m(), C.value = H, t.value = "idle", p(), g(), A(), L();
      }
    ), (H, Q) => ($(), we(Nt(i.value), $t(Rt({ to: e.to })), {
      default: _e(() => [
        Re(j(ar), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: _e(() => [
            ne("div", ih, [
              Re(j(Jo), Ce({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: _e(() => [
            ne("div", lh, [
              ne("div", oh, [
                ne("span", sh, Oe(e.gameLabel), 1),
                ne("span", ch, [
                  ($(!0), Z(at, null, yt(a.value, (N, G) => ($(), Z("span", {
                    key: `pos-${G}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Re(Ws, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: _e(() => [
                        ($(), Z("span", {
                          key: N,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Et({ transitionDelay: `${G * 35}ms` })
                        }, Oe(N), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ne("div", uh, [
                Re(xn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: _e(() => [
                    e.isOperational ? se("", !0) : ($(), Z("div", dh, [
                      Re(th)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), Z("div", fh, [
                  Re(xn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: _e(() => [
                      l.value ? ($(), Z("div", {
                        key: 0,
                        class: pe(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ne("span", {
                          class: pe(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ne("span", hh, Oe(e.timerValueLabel), 1),
                          ne("span", vh, Oe(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), Z("div", {
                          key: `arrows-${o.value}`,
                          class: pe(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Re(K0)
                        ], 2))
                      ], 2)) : se("", !0)
                    ]),
                    _: 1
                  }),
                  Re(xn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: _e(() => [
                      t.value === "label" ? ($(), Z("div", mh, [
                        ve(H.$slots, "new-game-label")
                      ])) : se("", !0)
                    ]),
                    _: 3
                  })
                ])) : se("", !0)
              ])
            ])
          ]),
          footer: _e(() => [
            ve(H.$slots, "message")
          ]),
          default: _e(() => [
            ne("div", gh, [
              ne("div", {
                class: pe(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Re(rh)
              ], 2),
              ne("span", bh, Oe(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Pn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ph = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ia = 0; Ia < Pn.length; Ia++)
  ph[Pn.charCodeAt(Ia)] = Ia;
var yh = function(e) {
  var t = new Uint8Array(e), n, r = t.length, o = "";
  for (n = 0; n < r; n += 3)
    o += Pn[t[n] >> 2], o += Pn[(t[n] & 3) << 4 | t[n + 1] >> 4], o += Pn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], o += Pn[t[n + 2] & 63];
  return r % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : r % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, wh = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], aa = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], o = wh.indexOf(r);
    t = t * 83 + o;
  }
  return t;
}, _r = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, Er = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, xh = (e) => e < 0 ? -1 : 1, Cr = (e, t) => xh(e) * Math.pow(Math.abs(e), t), Tl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, kh = (e) => {
  if (!e || e.length < 6) throw new Tl("The blurhash string must be at least 6 characters");
  let t = aa(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new Tl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, Sh = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [_r(t), _r(n), _r(r)];
}, _h = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, o = e % 19;
  return [Cr((n - 9) / 9, 2) * t, Cr((r - 9) / 9, 2) * t, Cr((o - 9) / 9, 2) * t];
}, Eh = (e, t, n, r) => {
  kh(e), r = r | 1;
  let o = aa(e[0]), i = Math.floor(o / 9) + 1, a = o % 9 + 1, s = (aa(e[1]) + 1) / 166, l = new Array(a * i);
  for (let u = 0; u < l.length; u++) if (u === 0) {
    let f = aa(e.substring(2, 6));
    l[u] = Sh(f);
  } else {
    let f = aa(e.substring(4 + u * 2, 6 + u * 2));
    l[u] = _h(f, s * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let u = 0; u < n; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, p = 0;
    for (let C = 0; C < i; C++) for (let A = 0; A < a; A++) {
      let I = Math.cos(Math.PI * f * A / t) * Math.cos(Math.PI * u * C / n), L = l[A + C * a];
      m += L[0] * I, c += L[1] * I, p += L[2] * I;
    }
    let x = Er(m), g = Er(c), b = Er(p);
    v[4 * f + 0 + u * h] = x, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, Ch = Eh;
function Th(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ah(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Tr = { exports: {} }, Ar = {}, Al;
function dn() {
  return Al || (Al = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var s = a.shift();
        if (s) {
          if (typeof s != "object")
            throw new TypeError(s + "must be non-object");
          for (var l in s)
            n(s, l) && (i[l] = s[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, s, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(s, s + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, s, l, h, v, u;
        for (l = 0, a = 0, s = i.length; a < s; a++)
          l += i[a].length;
        for (u = new Uint8Array(l), h = 0, a = 0, s = i.length; a < s; a++)
          v = i[a], u.set(v, h), h += v.length;
        return u;
      }
    }, o = {
      arraySet: function(i, a, s, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, o));
    }, e.setTyped(t);
  })(Ar)), Ar;
}
var Rn = {}, Ht = {}, gn = {}, Ll;
function Lh() {
  if (Ll) return gn;
  Ll = 1;
  var e = dn(), t = 4, n = 0, r = 1, o = 2;
  function i(w) {
    for (var K = w.length; --K >= 0; )
      w[K] = 0;
  }
  var a = 0, s = 1, l = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, p = 19, x = 2 * m + 1, g = 15, b = 16, C = 7, A = 256, I = 16, L = 17, T = 18, P = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), H = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), Q = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), N = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], G = 512, V = new Array((m + 2) * 2);
  i(V);
  var _ = new Array(c * 2);
  i(_);
  var E = new Array(G);
  i(E);
  var M = new Array(v - h + 1);
  i(M);
  var z = new Array(u);
  i(z);
  var q = new Array(c);
  i(q);
  function X(w, K, O, ie, D) {
    this.static_tree = w, this.extra_bits = K, this.extra_base = O, this.elems = ie, this.max_length = D, this.has_stree = w && w.length;
  }
  var U, oe, re;
  function fe(w, K) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = K;
  }
  function be(w) {
    return w < 256 ? E[w] : E[256 + (w >>> 7)];
  }
  function Se(w, K) {
    w.pending_buf[w.pending++] = K & 255, w.pending_buf[w.pending++] = K >>> 8 & 255;
  }
  function de(w, K, O) {
    w.bi_valid > b - O ? (w.bi_buf |= K << w.bi_valid & 65535, Se(w, w.bi_buf), w.bi_buf = K >> b - w.bi_valid, w.bi_valid += O - b) : (w.bi_buf |= K << w.bi_valid & 65535, w.bi_valid += O);
  }
  function ye(w, K, O) {
    de(
      w,
      O[K * 2],
      O[K * 2 + 1]
      /*.Len*/
    );
  }
  function Ae(w, K) {
    var O = 0;
    do
      O |= w & 1, w >>>= 1, O <<= 1;
    while (--K > 0);
    return O >>> 1;
  }
  function De(w) {
    w.bi_valid === 16 ? (Se(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function We(w, K) {
    var O = K.dyn_tree, ie = K.max_code, D = K.stat_desc.static_tree, J = K.stat_desc.has_stree, y = K.stat_desc.extra_bits, ce = K.stat_desc.extra_base, Te = K.stat_desc.max_length, d, ae, te, k, F, ee, $e = 0;
    for (k = 0; k <= g; k++)
      w.bl_count[k] = 0;
    for (O[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < x; d++)
      ae = w.heap[d], k = O[O[ae * 2 + 1] * 2 + 1] + 1, k > Te && (k = Te, $e++), O[ae * 2 + 1] = k, !(ae > ie) && (w.bl_count[k]++, F = 0, ae >= ce && (F = y[ae - ce]), ee = O[ae * 2], w.opt_len += ee * (k + F), J && (w.static_len += ee * (D[ae * 2 + 1] + F)));
    if ($e !== 0) {
      do {
        for (k = Te - 1; w.bl_count[k] === 0; )
          k--;
        w.bl_count[k]--, w.bl_count[k + 1] += 2, w.bl_count[Te]--, $e -= 2;
      } while ($e > 0);
      for (k = Te; k !== 0; k--)
        for (ae = w.bl_count[k]; ae !== 0; )
          te = w.heap[--d], !(te > ie) && (O[te * 2 + 1] !== k && (w.opt_len += (k - O[te * 2 + 1]) * O[te * 2], O[te * 2 + 1] = k), ae--);
    }
  }
  function Ne(w, K, O) {
    var ie = new Array(g + 1), D = 0, J, y;
    for (J = 1; J <= g; J++)
      ie[J] = D = D + O[J - 1] << 1;
    for (y = 0; y <= K; y++) {
      var ce = w[y * 2 + 1];
      ce !== 0 && (w[y * 2] = Ae(ie[ce]++, ce));
    }
  }
  function ue() {
    var w, K, O, ie, D, J = new Array(g + 1);
    for (O = 0, ie = 0; ie < u - 1; ie++)
      for (z[ie] = O, w = 0; w < 1 << P[ie]; w++)
        M[O++] = ie;
    for (M[O - 1] = ie, D = 0, ie = 0; ie < 16; ie++)
      for (q[ie] = D, w = 0; w < 1 << H[ie]; w++)
        E[D++] = ie;
    for (D >>= 7; ie < c; ie++)
      for (q[ie] = D << 7, w = 0; w < 1 << H[ie] - 7; w++)
        E[256 + D++] = ie;
    for (K = 0; K <= g; K++)
      J[K] = 0;
    for (w = 0; w <= 143; )
      V[w * 2 + 1] = 8, w++, J[8]++;
    for (; w <= 255; )
      V[w * 2 + 1] = 9, w++, J[9]++;
    for (; w <= 279; )
      V[w * 2 + 1] = 7, w++, J[7]++;
    for (; w <= 287; )
      V[w * 2 + 1] = 8, w++, J[8]++;
    for (Ne(V, m + 1, J), w = 0; w < c; w++)
      _[w * 2 + 1] = 5, _[w * 2] = Ae(w, 5);
    U = new X(V, P, f + 1, m, g), oe = new X(_, H, 0, c, g), re = new X(new Array(0), Q, 0, p, C);
  }
  function Fe(w) {
    var K;
    for (K = 0; K < m; K++)
      w.dyn_ltree[K * 2] = 0;
    for (K = 0; K < c; K++)
      w.dyn_dtree[K * 2] = 0;
    for (K = 0; K < p; K++)
      w.bl_tree[K * 2] = 0;
    w.dyn_ltree[A * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function qe(w) {
    w.bi_valid > 8 ? Se(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function Ze(w, K, O, ie) {
    qe(w), Se(w, O), Se(w, ~O), e.arraySet(w.pending_buf, w.window, K, O, w.pending), w.pending += O;
  }
  function Xe(w, K, O, ie) {
    var D = K * 2, J = O * 2;
    return w[D] < w[J] || w[D] === w[J] && ie[K] <= ie[O];
  }
  function Ve(w, K, O) {
    for (var ie = w.heap[O], D = O << 1; D <= w.heap_len && (D < w.heap_len && Xe(K, w.heap[D + 1], w.heap[D], w.depth) && D++, !Xe(K, ie, w.heap[D], w.depth)); )
      w.heap[O] = w.heap[D], O = D, D <<= 1;
    w.heap[O] = ie;
  }
  function Pe(w, K, O) {
    var ie, D, J = 0, y, ce;
    if (w.last_lit !== 0)
      do
        ie = w.pending_buf[w.d_buf + J * 2] << 8 | w.pending_buf[w.d_buf + J * 2 + 1], D = w.pending_buf[w.l_buf + J], J++, ie === 0 ? ye(w, D, K) : (y = M[D], ye(w, y + f + 1, K), ce = P[y], ce !== 0 && (D -= z[y], de(w, D, ce)), ie--, y = be(ie), ye(w, y, O), ce = H[y], ce !== 0 && (ie -= q[y], de(w, ie, ce)));
      while (J < w.last_lit);
    ye(w, A, K);
  }
  function rt(w, K) {
    var O = K.dyn_tree, ie = K.stat_desc.static_tree, D = K.stat_desc.has_stree, J = K.stat_desc.elems, y, ce, Te = -1, d;
    for (w.heap_len = 0, w.heap_max = x, y = 0; y < J; y++)
      O[y * 2] !== 0 ? (w.heap[++w.heap_len] = Te = y, w.depth[y] = 0) : O[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = Te < 2 ? ++Te : 0, O[d * 2] = 1, w.depth[d] = 0, w.opt_len--, D && (w.static_len -= ie[d * 2 + 1]);
    for (K.max_code = Te, y = w.heap_len >> 1; y >= 1; y--)
      Ve(w, O, y);
    d = J;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], Ve(
        w,
        O,
        1
        /*SMALLEST*/
      ), ce = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = ce, O[d * 2] = O[y * 2] + O[ce * 2], w.depth[d] = (w.depth[y] >= w.depth[ce] ? w.depth[y] : w.depth[ce]) + 1, O[y * 2 + 1] = O[ce * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, Ve(
        w,
        O,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], We(w, K), Ne(O, Te, w.bl_count);
  }
  function ct(w, K, O) {
    var ie, D = -1, J, y = K[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), K[(O + 1) * 2 + 1] = 65535, ie = 0; ie <= O; ie++)
      J = y, y = K[(ie + 1) * 2 + 1], !(++ce < Te && J === y) && (ce < d ? w.bl_tree[J * 2] += ce : J !== 0 ? (J !== D && w.bl_tree[J * 2]++, w.bl_tree[I * 2]++) : ce <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[T * 2]++, ce = 0, D = J, y === 0 ? (Te = 138, d = 3) : J === y ? (Te = 6, d = 3) : (Te = 7, d = 4));
  }
  function me(w, K, O) {
    var ie, D = -1, J, y = K[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), ie = 0; ie <= O; ie++)
      if (J = y, y = K[(ie + 1) * 2 + 1], !(++ce < Te && J === y)) {
        if (ce < d)
          do
            ye(w, J, w.bl_tree);
          while (--ce !== 0);
        else J !== 0 ? (J !== D && (ye(w, J, w.bl_tree), ce--), ye(w, I, w.bl_tree), de(w, ce - 3, 2)) : ce <= 10 ? (ye(w, L, w.bl_tree), de(w, ce - 3, 3)) : (ye(w, T, w.bl_tree), de(w, ce - 11, 7));
        ce = 0, D = J, y === 0 ? (Te = 138, d = 3) : J === y ? (Te = 6, d = 3) : (Te = 7, d = 4);
      }
  }
  function Be(w) {
    var K;
    for (ct(w, w.dyn_ltree, w.l_desc.max_code), ct(w, w.dyn_dtree, w.d_desc.max_code), rt(w, w.bl_desc), K = p - 1; K >= 3 && w.bl_tree[N[K] * 2 + 1] === 0; K--)
      ;
    return w.opt_len += 3 * (K + 1) + 5 + 5 + 4, K;
  }
  function ze(w, K, O, ie) {
    var D;
    for (de(w, K - 257, 5), de(w, O - 1, 5), de(w, ie - 4, 4), D = 0; D < ie; D++)
      de(w, w.bl_tree[N[D] * 2 + 1], 3);
    me(w, w.dyn_ltree, K - 1), me(w, w.dyn_dtree, O - 1);
  }
  function Ke(w) {
    var K = 4093624447, O;
    for (O = 0; O <= 31; O++, K >>>= 1)
      if (K & 1 && w.dyn_ltree[O * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (O = 32; O < f; O++)
      if (w.dyn_ltree[O * 2] !== 0)
        return r;
    return n;
  }
  var Je = !1;
  function ht(w) {
    Je || (ue(), Je = !0), w.l_desc = new fe(w.dyn_ltree, U), w.d_desc = new fe(w.dyn_dtree, oe), w.bl_desc = new fe(w.bl_tree, re), w.bi_buf = 0, w.bi_valid = 0, Fe(w);
  }
  function vt(w, K, O, ie) {
    de(w, (a << 1) + (ie ? 1 : 0), 3), Ze(w, K, O);
  }
  function tt(w) {
    de(w, s << 1, 3), ye(w, A, V), De(w);
  }
  function R(w, K, O, ie) {
    var D, J, y = 0;
    w.level > 0 ? (w.strm.data_type === o && (w.strm.data_type = Ke(w)), rt(w, w.l_desc), rt(w, w.d_desc), y = Be(w), D = w.opt_len + 3 + 7 >>> 3, J = w.static_len + 3 + 7 >>> 3, J <= D && (D = J)) : D = J = O + 5, O + 4 <= D && K !== -1 ? vt(w, K, O, ie) : w.strategy === t || J === D ? (de(w, (s << 1) + (ie ? 1 : 0), 3), Pe(w, V, _)) : (de(w, (l << 1) + (ie ? 1 : 0), 3), ze(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Pe(w, w.dyn_ltree, w.dyn_dtree)), Fe(w), ie && qe(w);
  }
  function S(w, K, O) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = K >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = K & 255, w.pending_buf[w.l_buf + w.last_lit] = O & 255, w.last_lit++, K === 0 ? w.dyn_ltree[O * 2]++ : (w.matches++, K--, w.dyn_ltree[(M[O] + f + 1) * 2]++, w.dyn_dtree[be(K) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return gn._tr_init = ht, gn._tr_stored_block = vt, gn._tr_flush_block = R, gn._tr_tally = S, gn._tr_align = tt, gn;
}
var Lr, $l;
function as() {
  if ($l) return Lr;
  $l = 1;
  function e(t, n, r, o) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, s = 0; r !== 0; ) {
      s = r > 2e3 ? 2e3 : r, r -= s;
      do
        i = i + n[o++] | 0, a = a + i | 0;
      while (--s);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Lr = e, Lr;
}
var $r, Il;
function rs() {
  if (Il) return $r;
  Il = 1;
  function e() {
    for (var r, o = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      o[i] = r;
    }
    return o;
  }
  var t = e();
  function n(r, o, i, a) {
    var s = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ s[(r ^ o[h]) & 255];
    return r ^ -1;
  }
  return $r = n, $r;
}
var Ir, Dl;
function wi() {
  return Dl || (Dl = 1, Ir = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Ir;
}
var Ol;
function $h() {
  if (Ol) return Ht;
  Ol = 1;
  var e = dn(), t = Lh(), n = as(), r = rs(), o = wi(), i = 0, a = 1, s = 3, l = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, p = -1, x = 1, g = 2, b = 3, C = 4, A = 0, I = 2, L = 8, T = 9, P = 15, H = 8, Q = 29, N = 256, G = N + 1 + Q, V = 30, _ = 19, E = 2 * G + 1, M = 15, z = 3, q = 258, X = q + z + 1, U = 32, oe = 42, re = 69, fe = 73, be = 91, Se = 103, de = 113, ye = 666, Ae = 1, De = 2, We = 3, Ne = 4, ue = 3;
  function Fe(d, ae) {
    return d.msg = o[ae], ae;
  }
  function qe(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function Ze(d) {
    for (var ae = d.length; --ae >= 0; )
      d[ae] = 0;
  }
  function Xe(d) {
    var ae = d.state, te = ae.pending;
    te > d.avail_out && (te = d.avail_out), te !== 0 && (e.arraySet(d.output, ae.pending_buf, ae.pending_out, te, d.next_out), d.next_out += te, ae.pending_out += te, d.total_out += te, d.avail_out -= te, ae.pending -= te, ae.pending === 0 && (ae.pending_out = 0));
  }
  function Ve(d, ae) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, ae), d.block_start = d.strstart, Xe(d.strm);
  }
  function Pe(d, ae) {
    d.pending_buf[d.pending++] = ae;
  }
  function rt(d, ae) {
    d.pending_buf[d.pending++] = ae >>> 8 & 255, d.pending_buf[d.pending++] = ae & 255;
  }
  function ct(d, ae, te, k) {
    var F = d.avail_in;
    return F > k && (F = k), F === 0 ? 0 : (d.avail_in -= F, e.arraySet(ae, d.input, d.next_in, F, te), d.state.wrap === 1 ? d.adler = n(d.adler, ae, F, te) : d.state.wrap === 2 && (d.adler = r(d.adler, ae, F, te)), d.next_in += F, d.total_in += F, F);
  }
  function me(d, ae) {
    var te = d.max_chain_length, k = d.strstart, F, ee, $e = d.prev_length, xe = d.nice_match, Le = d.strstart > d.w_size - X ? d.strstart - (d.w_size - X) : 0, Ye = d.window, wt = d.w_mask, lt = d.prev, Ge = d.strstart + q, mt = Ye[k + $e - 1], St = Ye[k + $e];
    d.prev_length >= d.good_match && (te >>= 2), xe > d.lookahead && (xe = d.lookahead);
    do
      if (F = ae, !(Ye[F + $e] !== St || Ye[F + $e - 1] !== mt || Ye[F] !== Ye[k] || Ye[++F] !== Ye[k + 1])) {
        k += 2, F++;
        do
          ;
        while (Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && Ye[++k] === Ye[++F] && k < Ge);
        if (ee = q - (Ge - k), k = Ge - q, ee > $e) {
          if (d.match_start = ae, $e = ee, ee >= xe)
            break;
          mt = Ye[k + $e - 1], St = Ye[k + $e];
        }
      }
    while ((ae = lt[ae & wt]) > Le && --te !== 0);
    return $e <= d.lookahead ? $e : d.lookahead;
  }
  function Be(d) {
    var ae = d.w_size, te, k, F, ee, $e;
    do {
      if (ee = d.window_size - d.lookahead - d.strstart, d.strstart >= ae + (ae - X)) {
        e.arraySet(d.window, d.window, ae, ae, 0), d.match_start -= ae, d.strstart -= ae, d.block_start -= ae, k = d.hash_size, te = k;
        do
          F = d.head[--te], d.head[te] = F >= ae ? F - ae : 0;
        while (--k);
        k = ae, te = k;
        do
          F = d.prev[--te], d.prev[te] = F >= ae ? F - ae : 0;
        while (--k);
        ee += ae;
      }
      if (d.strm.avail_in === 0)
        break;
      if (k = ct(d.strm, d.window, d.strstart + d.lookahead, ee), d.lookahead += k, d.lookahead + d.insert >= z)
        for ($e = d.strstart - d.insert, d.ins_h = d.window[$e], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + z - 1]) & d.hash_mask, d.prev[$e & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = $e, $e++, d.insert--, !(d.lookahead + d.insert < z)); )
          ;
    } while (d.lookahead < X && d.strm.avail_in !== 0);
  }
  function ze(d, ae) {
    var te = 65535;
    for (te > d.pending_buf_size - 5 && (te = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (Be(d), d.lookahead === 0 && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var k = d.block_start + te;
      if ((d.strstart === 0 || d.strstart >= k) && (d.lookahead = d.strstart - k, d.strstart = k, Ve(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - X && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : (d.strstart > d.block_start && (Ve(d, !1), d.strm.avail_out === 0), Ae);
  }
  function Ke(d, ae) {
    for (var te, k; ; ) {
      if (d.lookahead < X) {
        if (Be(d), d.lookahead < X && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= z && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + z - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), te !== 0 && d.strstart - te <= d.w_size - X && (d.match_length = me(d, te)), d.match_length >= z)
        if (k = t._tr_tally(d, d.strstart - d.match_start, d.match_length - z), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= z) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + z - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        k = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (k && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = d.strstart < z - 1 ? d.strstart : z - 1, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : De;
  }
  function Je(d, ae) {
    for (var te, k, F; ; ) {
      if (d.lookahead < X) {
        if (Be(d), d.lookahead < X && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= z && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + z - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = z - 1, te !== 0 && d.prev_length < d.max_lazy_match && d.strstart - te <= d.w_size - X && (d.match_length = me(d, te), d.match_length <= 5 && (d.strategy === x || d.match_length === z && d.strstart - d.match_start > 4096) && (d.match_length = z - 1)), d.prev_length >= z && d.match_length <= d.prev_length) {
        F = d.strstart + d.lookahead - z, k = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - z), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= F && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + z - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = z - 1, d.strstart++, k && (Ve(d, !1), d.strm.avail_out === 0))
          return Ae;
      } else if (d.match_available) {
        if (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), k && Ve(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return Ae;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < z - 1 ? d.strstart : z - 1, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : De;
  }
  function ht(d, ae) {
    for (var te, k, F, ee, $e = d.window; ; ) {
      if (d.lookahead <= q) {
        if (Be(d), d.lookahead <= q && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= z && d.strstart > 0 && (F = d.strstart - 1, k = $e[F], k === $e[++F] && k === $e[++F] && k === $e[++F])) {
        ee = d.strstart + q;
        do
          ;
        while (k === $e[++F] && k === $e[++F] && k === $e[++F] && k === $e[++F] && k === $e[++F] && k === $e[++F] && k === $e[++F] && k === $e[++F] && F < ee);
        d.match_length = q - (ee - F), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= z ? (te = t._tr_tally(d, 1, d.match_length - z), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), te && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : De;
  }
  function vt(d, ae) {
    for (var te; ; ) {
      if (d.lookahead === 0 && (Be(d), d.lookahead === 0)) {
        if (ae === i)
          return Ae;
        break;
      }
      if (d.match_length = 0, te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, te && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : De;
  }
  function tt(d, ae, te, k, F) {
    this.good_length = d, this.max_lazy = ae, this.nice_length = te, this.max_chain = k, this.func = F;
  }
  var R;
  R = [
    /*      good lazy nice chain */
    new tt(0, 0, 0, 0, ze),
    /* 0 store only */
    new tt(4, 4, 8, 4, Ke),
    /* 1 max speed, no lazy matches */
    new tt(4, 5, 16, 8, Ke),
    /* 2 */
    new tt(4, 6, 32, 32, Ke),
    /* 3 */
    new tt(4, 4, 16, 16, Je),
    /* 4 lazy matches */
    new tt(8, 16, 32, 32, Je),
    /* 5 */
    new tt(8, 16, 128, 128, Je),
    /* 6 */
    new tt(8, 32, 128, 256, Je),
    /* 7 */
    new tt(32, 128, 258, 1024, Je),
    /* 8 */
    new tt(32, 258, 258, 4096, Je)
    /* 9 max compression */
  ];
  function S(d) {
    d.window_size = 2 * d.w_size, Ze(d.head), d.max_lazy_match = R[d.level].max_lazy, d.good_match = R[d.level].good_length, d.nice_match = R[d.level].nice_length, d.max_chain_length = R[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = z - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(E * 2), this.dyn_dtree = new e.Buf16((2 * V + 1) * 2), this.bl_tree = new e.Buf16((2 * _ + 1) * 2), Ze(this.dyn_ltree), Ze(this.dyn_dtree), Ze(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(M + 1), this.heap = new e.Buf16(2 * G + 1), Ze(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * G + 1), Ze(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function K(d) {
    var ae;
    return !d || !d.state ? Fe(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, ae = d.state, ae.pending = 0, ae.pending_out = 0, ae.wrap < 0 && (ae.wrap = -ae.wrap), ae.status = ae.wrap ? oe : de, d.adler = ae.wrap === 2 ? 0 : 1, ae.last_flush = i, t._tr_init(ae), v);
  }
  function O(d) {
    var ae = K(d);
    return ae === v && S(d.state), ae;
  }
  function ie(d, ae) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = ae, v);
  }
  function D(d, ae, te, k, F, ee) {
    if (!d)
      return f;
    var $e = 1;
    if (ae === p && (ae = 6), k < 0 ? ($e = 0, k = -k) : k > 15 && ($e = 2, k -= 16), F < 1 || F > T || te !== L || k < 8 || k > 15 || ae < 0 || ae > 9 || ee < 0 || ee > C)
      return Fe(d, f);
    k === 8 && (k = 9);
    var xe = new w();
    return d.state = xe, xe.strm = d, xe.wrap = $e, xe.gzhead = null, xe.w_bits = k, xe.w_size = 1 << xe.w_bits, xe.w_mask = xe.w_size - 1, xe.hash_bits = F + 7, xe.hash_size = 1 << xe.hash_bits, xe.hash_mask = xe.hash_size - 1, xe.hash_shift = ~~((xe.hash_bits + z - 1) / z), xe.window = new e.Buf8(xe.w_size * 2), xe.head = new e.Buf16(xe.hash_size), xe.prev = new e.Buf16(xe.w_size), xe.lit_bufsize = 1 << F + 6, xe.pending_buf_size = xe.lit_bufsize * 4, xe.pending_buf = new e.Buf8(xe.pending_buf_size), xe.d_buf = 1 * xe.lit_bufsize, xe.l_buf = 3 * xe.lit_bufsize, xe.level = ae, xe.strategy = ee, xe.method = te, O(d);
  }
  function J(d, ae) {
    return D(d, ae, L, P, H, A);
  }
  function y(d, ae) {
    var te, k, F, ee;
    if (!d || !d.state || ae > h || ae < 0)
      return d ? Fe(d, f) : f;
    if (k = d.state, !d.output || !d.input && d.avail_in !== 0 || k.status === ye && ae !== l)
      return Fe(d, d.avail_out === 0 ? c : f);
    if (k.strm = d, te = k.last_flush, k.last_flush = ae, k.status === oe)
      if (k.wrap === 2)
        d.adler = 0, Pe(k, 31), Pe(k, 139), Pe(k, 8), k.gzhead ? (Pe(
          k,
          (k.gzhead.text ? 1 : 0) + (k.gzhead.hcrc ? 2 : 0) + (k.gzhead.extra ? 4 : 0) + (k.gzhead.name ? 8 : 0) + (k.gzhead.comment ? 16 : 0)
        ), Pe(k, k.gzhead.time & 255), Pe(k, k.gzhead.time >> 8 & 255), Pe(k, k.gzhead.time >> 16 & 255), Pe(k, k.gzhead.time >> 24 & 255), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, k.gzhead.os & 255), k.gzhead.extra && k.gzhead.extra.length && (Pe(k, k.gzhead.extra.length & 255), Pe(k, k.gzhead.extra.length >> 8 & 255)), k.gzhead.hcrc && (d.adler = r(d.adler, k.pending_buf, k.pending, 0)), k.gzindex = 0, k.status = re) : (Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, ue), k.status = de);
      else {
        var $e = L + (k.w_bits - 8 << 4) << 8, xe = -1;
        k.strategy >= g || k.level < 2 ? xe = 0 : k.level < 6 ? xe = 1 : k.level === 6 ? xe = 2 : xe = 3, $e |= xe << 6, k.strstart !== 0 && ($e |= U), $e += 31 - $e % 31, k.status = de, rt(k, $e), k.strstart !== 0 && (rt(k, d.adler >>> 16), rt(k, d.adler & 65535)), d.adler = 1;
      }
    if (k.status === re)
      if (k.gzhead.extra) {
        for (F = k.pending; k.gzindex < (k.gzhead.extra.length & 65535) && !(k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), Xe(d), F = k.pending, k.pending === k.pending_buf_size)); )
          Pe(k, k.gzhead.extra[k.gzindex] & 255), k.gzindex++;
        k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), k.gzindex === k.gzhead.extra.length && (k.gzindex = 0, k.status = fe);
      } else
        k.status = fe;
    if (k.status === fe)
      if (k.gzhead.name) {
        F = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), Xe(d), F = k.pending, k.pending === k.pending_buf_size)) {
            ee = 1;
            break;
          }
          k.gzindex < k.gzhead.name.length ? ee = k.gzhead.name.charCodeAt(k.gzindex++) & 255 : ee = 0, Pe(k, ee);
        } while (ee !== 0);
        k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), ee === 0 && (k.gzindex = 0, k.status = be);
      } else
        k.status = be;
    if (k.status === be)
      if (k.gzhead.comment) {
        F = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), Xe(d), F = k.pending, k.pending === k.pending_buf_size)) {
            ee = 1;
            break;
          }
          k.gzindex < k.gzhead.comment.length ? ee = k.gzhead.comment.charCodeAt(k.gzindex++) & 255 : ee = 0, Pe(k, ee);
        } while (ee !== 0);
        k.gzhead.hcrc && k.pending > F && (d.adler = r(d.adler, k.pending_buf, k.pending - F, F)), ee === 0 && (k.status = Se);
      } else
        k.status = Se;
    if (k.status === Se && (k.gzhead.hcrc ? (k.pending + 2 > k.pending_buf_size && Xe(d), k.pending + 2 <= k.pending_buf_size && (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), d.adler = 0, k.status = de)) : k.status = de), k.pending !== 0) {
      if (Xe(d), d.avail_out === 0)
        return k.last_flush = -1, v;
    } else if (d.avail_in === 0 && qe(ae) <= qe(te) && ae !== l)
      return Fe(d, c);
    if (k.status === ye && d.avail_in !== 0)
      return Fe(d, c);
    if (d.avail_in !== 0 || k.lookahead !== 0 || ae !== i && k.status !== ye) {
      var Le = k.strategy === g ? vt(k, ae) : k.strategy === b ? ht(k, ae) : R[k.level].func(k, ae);
      if ((Le === We || Le === Ne) && (k.status = ye), Le === Ae || Le === We)
        return d.avail_out === 0 && (k.last_flush = -1), v;
      if (Le === De && (ae === a ? t._tr_align(k) : ae !== h && (t._tr_stored_block(k, 0, 0, !1), ae === s && (Ze(k.head), k.lookahead === 0 && (k.strstart = 0, k.block_start = 0, k.insert = 0))), Xe(d), d.avail_out === 0))
        return k.last_flush = -1, v;
    }
    return ae !== l ? v : k.wrap <= 0 ? u : (k.wrap === 2 ? (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), Pe(k, d.adler >> 16 & 255), Pe(k, d.adler >> 24 & 255), Pe(k, d.total_in & 255), Pe(k, d.total_in >> 8 & 255), Pe(k, d.total_in >> 16 & 255), Pe(k, d.total_in >> 24 & 255)) : (rt(k, d.adler >>> 16), rt(k, d.adler & 65535)), Xe(d), k.wrap > 0 && (k.wrap = -k.wrap), k.pending !== 0 ? v : u);
  }
  function ce(d) {
    var ae;
    return !d || !d.state ? f : (ae = d.state.status, ae !== oe && ae !== re && ae !== fe && ae !== be && ae !== Se && ae !== de && ae !== ye ? Fe(d, f) : (d.state = null, ae === de ? Fe(d, m) : v));
  }
  function Te(d, ae) {
    var te = ae.length, k, F, ee, $e, xe, Le, Ye, wt;
    if (!d || !d.state || (k = d.state, $e = k.wrap, $e === 2 || $e === 1 && k.status !== oe || k.lookahead))
      return f;
    for ($e === 1 && (d.adler = n(d.adler, ae, te, 0)), k.wrap = 0, te >= k.w_size && ($e === 0 && (Ze(k.head), k.strstart = 0, k.block_start = 0, k.insert = 0), wt = new e.Buf8(k.w_size), e.arraySet(wt, ae, te - k.w_size, k.w_size, 0), ae = wt, te = k.w_size), xe = d.avail_in, Le = d.next_in, Ye = d.input, d.avail_in = te, d.next_in = 0, d.input = ae, Be(k); k.lookahead >= z; ) {
      F = k.strstart, ee = k.lookahead - (z - 1);
      do
        k.ins_h = (k.ins_h << k.hash_shift ^ k.window[F + z - 1]) & k.hash_mask, k.prev[F & k.w_mask] = k.head[k.ins_h], k.head[k.ins_h] = F, F++;
      while (--ee);
      k.strstart = F, k.lookahead = z - 1, Be(k);
    }
    return k.strstart += k.lookahead, k.block_start = k.strstart, k.insert = k.lookahead, k.lookahead = 0, k.match_length = k.prev_length = z - 1, k.match_available = 0, d.next_in = Le, d.input = Ye, d.avail_in = xe, k.wrap = $e, v;
  }
  return Ht.deflateInit = J, Ht.deflateInit2 = D, Ht.deflateReset = O, Ht.deflateResetKeep = K, Ht.deflateSetHeader = ie, Ht.deflate = y, Ht.deflateEnd = ce, Ht.deflateSetDictionary = Te, Ht.deflateInfo = "pako deflate (from Nodeca project)", Ht;
}
var bn = {}, Ml;
function is() {
  if (Ml) return bn;
  Ml = 1;
  var e = dn(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), o = 0; o < 256; o++)
    r[o] = o >= 252 ? 6 : o >= 248 ? 5 : o >= 240 ? 4 : o >= 224 ? 3 : o >= 192 ? 2 : 1;
  r[254] = r[254] = 1, bn.string2buf = function(a) {
    var s, l, h, v, u, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (s = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? s[u++] = l : l < 2048 ? (s[u++] = 192 | l >>> 6, s[u++] = 128 | l & 63) : l < 65536 ? (s[u++] = 224 | l >>> 12, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63) : (s[u++] = 240 | l >>> 18, s[u++] = 128 | l >>> 12 & 63, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63);
    return s;
  };
  function i(a, s) {
    if (s < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, s));
    for (var l = "", h = 0; h < s; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return bn.buf2binstring = function(a) {
    return i(a, a.length);
  }, bn.binstring2buf = function(a) {
    for (var s = new e.Buf8(a.length), l = 0, h = s.length; l < h; l++)
      s[l] = a.charCodeAt(l);
    return s;
  }, bn.buf2string = function(a, s) {
    var l, h, v, u, f = s || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, l += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && l < f; )
        v = v << 6 | a[l++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, bn.utf8border = function(a, s) {
    var l;
    for (s = s || a.length, s > a.length && (s = a.length), l = s - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? s : l + r[a[l]] > s ? l : s;
  }, bn;
}
var Dr, Rl;
function ls() {
  if (Rl) return Dr;
  Rl = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Dr = e, Dr;
}
var Fl;
function Ih() {
  if (Fl) return Rn;
  Fl = 1;
  var e = $h(), t = dn(), n = is(), r = wi(), o = ls(), i = Object.prototype.toString, a = 0, s = 4, l = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var C = this.options;
    C.raw && C.windowBits > 0 ? C.windowBits = -C.windowBits : C.gzip && C.windowBits > 0 && C.windowBits < 16 && (C.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new o(), this.strm.avail_out = 0;
    var A = e.deflateInit2(
      this.strm,
      C.level,
      C.method,
      C.windowBits,
      C.memLevel,
      C.strategy
    );
    if (A !== l)
      throw new Error(r[A]);
    if (C.header && e.deflateSetHeader(this.strm, C.header), C.dictionary) {
      var I;
      if (typeof C.dictionary == "string" ? I = n.string2buf(C.dictionary) : i.call(C.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(C.dictionary) : I = C.dictionary, A = e.deflateSetDictionary(this.strm, I), A !== l)
        throw new Error(r[A]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, C) {
    var A = this.strm, I = this.options.chunkSize, L, T;
    if (this.ended)
      return !1;
    T = C === ~~C ? C : C === !0 ? s : a, typeof b == "string" ? A.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? A.input = new Uint8Array(b) : A.input = b, A.next_in = 0, A.avail_in = A.input.length;
    do {
      if (A.avail_out === 0 && (A.output = new t.Buf8(I), A.next_out = 0, A.avail_out = I), L = e.deflate(A, T), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (A.avail_out === 0 || A.avail_in === 0 && (T === s || T === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(A.output, A.next_out))) : this.onData(t.shrinkBuf(A.output, A.next_out)));
    } while ((A.avail_in > 0 || A.avail_out === 0) && L !== h);
    return T === s ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (T === v && (this.onEnd(l), A.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, C) {
    var A = new c(C);
    if (A.push(b, !0), A.err)
      throw A.msg || r[A.err];
    return A.result;
  }
  function x(b, C) {
    return C = C || {}, C.raw = !0, p(b, C);
  }
  function g(b, C) {
    return C = C || {}, C.gzip = !0, p(b, C);
  }
  return Rn.Deflate = c, Rn.deflate = p, Rn.deflateRaw = x, Rn.gzip = g, Rn;
}
var Fn = {}, zt = {}, Or, Nl;
function Dh() {
  if (Nl) return Or;
  Nl = 1;
  var e = 30, t = 12;
  return Or = function(r, o) {
    var i, a, s, l, h, v, u, f, m, c, p, x, g, b, C, A, I, L, T, P, H, Q, N, G, V;
    i = r.state, a = r.next_in, G = r.input, s = a + (r.avail_in - 5), l = r.next_out, V = r.output, h = l - (o - r.avail_out), v = l + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, p = i.window, x = i.hold, g = i.bits, b = i.lencode, C = i.distcode, A = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (x += G[a++] << g, g += 8, x += G[a++] << g, g += 8), L = b[x & A];
        t:
          for (; ; ) {
            if (T = L >>> 24, x >>>= T, g -= T, T = L >>> 16 & 255, T === 0)
              V[l++] = L & 65535;
            else if (T & 16) {
              P = L & 65535, T &= 15, T && (g < T && (x += G[a++] << g, g += 8), P += x & (1 << T) - 1, x >>>= T, g -= T), g < 15 && (x += G[a++] << g, g += 8, x += G[a++] << g, g += 8), L = C[x & I];
              n:
                for (; ; ) {
                  if (T = L >>> 24, x >>>= T, g -= T, T = L >>> 16 & 255, T & 16) {
                    if (H = L & 65535, T &= 15, g < T && (x += G[a++] << g, g += 8, g < T && (x += G[a++] << g, g += 8)), H += x & (1 << T) - 1, H > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (x >>>= T, g -= T, T = l - h, H > T) {
                      if (T = H - T, T > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (Q = 0, N = p, c === 0) {
                        if (Q += f - T, T < P) {
                          P -= T;
                          do
                            V[l++] = p[Q++];
                          while (--T);
                          Q = l - H, N = V;
                        }
                      } else if (c < T) {
                        if (Q += f + c - T, T -= c, T < P) {
                          P -= T;
                          do
                            V[l++] = p[Q++];
                          while (--T);
                          if (Q = 0, c < P) {
                            T = c, P -= T;
                            do
                              V[l++] = p[Q++];
                            while (--T);
                            Q = l - H, N = V;
                          }
                        }
                      } else if (Q += c - T, T < P) {
                        P -= T;
                        do
                          V[l++] = p[Q++];
                        while (--T);
                        Q = l - H, N = V;
                      }
                      for (; P > 2; )
                        V[l++] = N[Q++], V[l++] = N[Q++], V[l++] = N[Q++], P -= 3;
                      P && (V[l++] = N[Q++], P > 1 && (V[l++] = N[Q++]));
                    } else {
                      Q = l - H;
                      do
                        V[l++] = V[Q++], V[l++] = V[Q++], V[l++] = V[Q++], P -= 3;
                      while (P > 2);
                      P && (V[l++] = V[Q++], P > 1 && (V[l++] = V[Q++]));
                    }
                  } else if ((T & 64) === 0) {
                    L = C[(L & 65535) + (x & (1 << T) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((T & 64) === 0) {
              L = b[(L & 65535) + (x & (1 << T) - 1)];
              continue t;
            } else if (T & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < s && l < v);
    P = g >> 3, a -= P, g -= P << 3, x &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < s ? 5 + (s - a) : 5 - (a - s), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = x, i.bits = g;
  }, Or;
}
var Mr, Pl;
function Oh() {
  if (Pl) return Mr;
  Pl = 1;
  var e = dn(), t = 15, n = 852, r = 592, o = 0, i = 1, a = 2, s = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Mr = function(f, m, c, p, x, g, b, C) {
    var A = C.bits, I = 0, L = 0, T = 0, P = 0, H = 0, Q = 0, N = 0, G = 0, V = 0, _ = 0, E, M, z, q, X, U = null, oe = 0, re, fe = new e.Buf16(t + 1), be = new e.Buf16(t + 1), Se = null, de = 0, ye, Ae, De;
    for (I = 0; I <= t; I++)
      fe[I] = 0;
    for (L = 0; L < p; L++)
      fe[m[c + L]]++;
    for (H = A, P = t; P >= 1 && fe[P] === 0; P--)
      ;
    if (H > P && (H = P), P === 0)
      return x[g++] = 1 << 24 | 64 << 16 | 0, x[g++] = 1 << 24 | 64 << 16 | 0, C.bits = 1, 0;
    for (T = 1; T < P && fe[T] === 0; T++)
      ;
    for (H < T && (H = T), G = 1, I = 1; I <= t; I++)
      if (G <<= 1, G -= fe[I], G < 0)
        return -1;
    if (G > 0 && (f === o || P !== 1))
      return -1;
    for (be[1] = 0, I = 1; I < t; I++)
      be[I + 1] = be[I] + fe[I];
    for (L = 0; L < p; L++)
      m[c + L] !== 0 && (b[be[m[c + L]]++] = L);
    if (f === o ? (U = Se = b, re = 19) : f === i ? (U = s, oe -= 257, Se = l, de -= 257, re = 256) : (U = h, Se = v, re = -1), _ = 0, L = 0, I = T, X = g, Q = H, N = 0, z = -1, V = 1 << H, q = V - 1, f === i && V > n || f === a && V > r)
      return 1;
    for (; ; ) {
      ye = I - N, b[L] < re ? (Ae = 0, De = b[L]) : b[L] > re ? (Ae = Se[de + b[L]], De = U[oe + b[L]]) : (Ae = 96, De = 0), E = 1 << I - N, M = 1 << Q, T = M;
      do
        M -= E, x[X + (_ >> N) + M] = ye << 24 | Ae << 16 | De | 0;
      while (M !== 0);
      for (E = 1 << I - 1; _ & E; )
        E >>= 1;
      if (E !== 0 ? (_ &= E - 1, _ += E) : _ = 0, L++, --fe[I] === 0) {
        if (I === P)
          break;
        I = m[c + b[L]];
      }
      if (I > H && (_ & q) !== z) {
        for (N === 0 && (N = H), X += T, Q = I - N, G = 1 << Q; Q + N < P && (G -= fe[Q + N], !(G <= 0)); )
          Q++, G <<= 1;
        if (V += 1 << Q, f === i && V > n || f === a && V > r)
          return 1;
        z = _ & q, x[z] = H << 24 | Q << 16 | X - g | 0;
      }
    }
    return _ !== 0 && (x[X + _] = I - N << 24 | 64 << 16 | 0), C.bits = H, 0;
  }, Mr;
}
var Bl;
function Mh() {
  if (Bl) return zt;
  Bl = 1;
  var e = dn(), t = as(), n = rs(), r = Dh(), o = Oh(), i = 0, a = 1, s = 2, l = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, p = -3, x = -4, g = -5, b = 8, C = 1, A = 2, I = 3, L = 4, T = 5, P = 6, H = 7, Q = 8, N = 9, G = 10, V = 11, _ = 12, E = 13, M = 14, z = 15, q = 16, X = 17, U = 18, oe = 19, re = 20, fe = 21, be = 22, Se = 23, de = 24, ye = 25, Ae = 26, De = 27, We = 28, Ne = 29, ue = 30, Fe = 31, qe = 32, Ze = 852, Xe = 592, Ve = 15, Pe = Ve;
  function rt(D) {
    return (D >>> 24 & 255) + (D >>> 8 & 65280) + ((D & 65280) << 8) + ((D & 255) << 24);
  }
  function ct() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function me(D) {
    var J;
    return !D || !D.state ? c : (J = D.state, D.total_in = D.total_out = J.total = 0, D.msg = "", J.wrap && (D.adler = J.wrap & 1), J.mode = C, J.last = 0, J.havedict = 0, J.dmax = 32768, J.head = null, J.hold = 0, J.bits = 0, J.lencode = J.lendyn = new e.Buf32(Ze), J.distcode = J.distdyn = new e.Buf32(Xe), J.sane = 1, J.back = -1, u);
  }
  function Be(D) {
    var J;
    return !D || !D.state ? c : (J = D.state, J.wsize = 0, J.whave = 0, J.wnext = 0, me(D));
  }
  function ze(D, J) {
    var y, ce;
    return !D || !D.state || (ce = D.state, J < 0 ? (y = 0, J = -J) : (y = (J >> 4) + 1, J < 48 && (J &= 15)), J && (J < 8 || J > 15)) ? c : (ce.window !== null && ce.wbits !== J && (ce.window = null), ce.wrap = y, ce.wbits = J, Be(D));
  }
  function Ke(D, J) {
    var y, ce;
    return D ? (ce = new ct(), D.state = ce, ce.window = null, y = ze(D, J), y !== u && (D.state = null), y) : c;
  }
  function Je(D) {
    return Ke(D, Pe);
  }
  var ht = !0, vt, tt;
  function R(D) {
    if (ht) {
      var J;
      for (vt = new e.Buf32(512), tt = new e.Buf32(32), J = 0; J < 144; )
        D.lens[J++] = 8;
      for (; J < 256; )
        D.lens[J++] = 9;
      for (; J < 280; )
        D.lens[J++] = 7;
      for (; J < 288; )
        D.lens[J++] = 8;
      for (o(a, D.lens, 0, 288, vt, 0, D.work, { bits: 9 }), J = 0; J < 32; )
        D.lens[J++] = 5;
      o(s, D.lens, 0, 32, tt, 0, D.work, { bits: 5 }), ht = !1;
    }
    D.lencode = vt, D.lenbits = 9, D.distcode = tt, D.distbits = 5;
  }
  function S(D, J, y, ce) {
    var Te, d = D.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), ce >= d.wsize ? (e.arraySet(d.window, J, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Te = d.wsize - d.wnext, Te > ce && (Te = ce), e.arraySet(d.window, J, y - ce, Te, d.wnext), ce -= Te, ce ? (e.arraySet(d.window, J, y - ce, ce, 0), d.wnext = ce, d.whave = d.wsize) : (d.wnext += Te, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Te))), 0;
  }
  function w(D, J) {
    var y, ce, Te, d, ae, te, k, F, ee, $e, xe, Le, Ye, wt, lt = 0, Ge, mt, St, At, hn, an, ot, Dt, xt = new e.Buf8(4), Vt, Pt, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!D || !D.state || !D.output || !D.input && D.avail_in !== 0)
      return c;
    y = D.state, y.mode === _ && (y.mode = E), ae = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, te = D.avail_in, F = y.hold, ee = y.bits, $e = te, xe = k, Dt = u;
    e:
      for (; ; )
        switch (y.mode) {
          case C:
            if (y.wrap === 0) {
              y.mode = E;
              break;
            }
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if (y.wrap & 2 && F === 35615) {
              y.check = 0, xt[0] = F & 255, xt[1] = F >>> 8 & 255, y.check = n(y.check, xt, 2, 0), F = 0, ee = 0, y.mode = A;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((F & 255) << 8) + (F >> 8)) % 31) {
              D.msg = "incorrect header check", y.mode = ue;
              break;
            }
            if ((F & 15) !== b) {
              D.msg = "unknown compression method", y.mode = ue;
              break;
            }
            if (F >>>= 4, ee -= 4, ot = (F & 15) + 8, y.wbits === 0)
              y.wbits = ot;
            else if (ot > y.wbits) {
              D.msg = "invalid window size", y.mode = ue;
              break;
            }
            y.dmax = 1 << ot, D.adler = y.check = 1, y.mode = F & 512 ? G : _, F = 0, ee = 0;
            break;
          case A:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if (y.flags = F, (y.flags & 255) !== b) {
              D.msg = "unknown compression method", y.mode = ue;
              break;
            }
            if (y.flags & 57344) {
              D.msg = "unknown header flags set", y.mode = ue;
              break;
            }
            y.head && (y.head.text = F >> 8 & 1), y.flags & 512 && (xt[0] = F & 255, xt[1] = F >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), F = 0, ee = 0, y.mode = I;
          /* falls through */
          case I:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            y.head && (y.head.time = F), y.flags & 512 && (xt[0] = F & 255, xt[1] = F >>> 8 & 255, xt[2] = F >>> 16 & 255, xt[3] = F >>> 24 & 255, y.check = n(y.check, xt, 4, 0)), F = 0, ee = 0, y.mode = L;
          /* falls through */
          case L:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            y.head && (y.head.xflags = F & 255, y.head.os = F >> 8), y.flags & 512 && (xt[0] = F & 255, xt[1] = F >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), F = 0, ee = 0, y.mode = T;
          /* falls through */
          case T:
            if (y.flags & 1024) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              y.length = F, y.head && (y.head.extra_len = F), y.flags & 512 && (xt[0] = F & 255, xt[1] = F >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), F = 0, ee = 0;
            } else y.head && (y.head.extra = null);
            y.mode = P;
          /* falls through */
          case P:
            if (y.flags & 1024 && (Le = y.length, Le > te && (Le = te), Le && (y.head && (ot = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              ce,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Le,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              ot
            )), y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, y.length -= Le), y.length))
              break e;
            y.length = 0, y.mode = H;
          /* falls through */
          case H:
            if (y.flags & 2048) {
              if (te === 0)
                break e;
              Le = 0;
              do
                ot = ce[d + Le++], y.head && ot && y.length < 65536 && (y.head.name += String.fromCharCode(ot));
              while (ot && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, ot)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = Q;
          /* falls through */
          case Q:
            if (y.flags & 4096) {
              if (te === 0)
                break e;
              Le = 0;
              do
                ot = ce[d + Le++], y.head && ot && y.length < 65536 && (y.head.comment += String.fromCharCode(ot));
              while (ot && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, ot)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = N;
          /* falls through */
          case N:
            if (y.flags & 512) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              if (F !== (y.check & 65535)) {
                D.msg = "header crc mismatch", y.mode = ue;
                break;
              }
              F = 0, ee = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), D.adler = y.check = 0, y.mode = _;
            break;
          case G:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            D.adler = y.check = rt(F), F = 0, ee = 0, y.mode = V;
          /* falls through */
          case V:
            if (y.havedict === 0)
              return D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = F, y.bits = ee, m;
            D.adler = y.check = 1, y.mode = _;
          /* falls through */
          case _:
            if (J === h || J === v)
              break e;
          /* falls through */
          case E:
            if (y.last) {
              F >>>= ee & 7, ee -= ee & 7, y.mode = De;
              break;
            }
            for (; ee < 3; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            switch (y.last = F & 1, F >>>= 1, ee -= 1, F & 3) {
              case 0:
                y.mode = M;
                break;
              case 1:
                if (R(y), y.mode = re, J === v) {
                  F >>>= 2, ee -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = X;
                break;
              case 3:
                D.msg = "invalid block type", y.mode = ue;
            }
            F >>>= 2, ee -= 2;
            break;
          case M:
            for (F >>>= ee & 7, ee -= ee & 7; ee < 32; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if ((F & 65535) !== (F >>> 16 ^ 65535)) {
              D.msg = "invalid stored block lengths", y.mode = ue;
              break;
            }
            if (y.length = F & 65535, F = 0, ee = 0, y.mode = z, J === v)
              break e;
          /* falls through */
          case z:
            y.mode = q;
          /* falls through */
          case q:
            if (Le = y.length, Le) {
              if (Le > te && (Le = te), Le > k && (Le = k), Le === 0)
                break e;
              e.arraySet(Te, ce, d, Le, ae), te -= Le, d += Le, k -= Le, ae += Le, y.length -= Le;
              break;
            }
            y.mode = _;
            break;
          case X:
            for (; ee < 14; ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if (y.nlen = (F & 31) + 257, F >>>= 5, ee -= 5, y.ndist = (F & 31) + 1, F >>>= 5, ee -= 5, y.ncode = (F & 15) + 4, F >>>= 4, ee -= 4, y.nlen > 286 || y.ndist > 30) {
              D.msg = "too many length or distance symbols", y.mode = ue;
              break;
            }
            y.have = 0, y.mode = U;
          /* falls through */
          case U:
            for (; y.have < y.ncode; ) {
              for (; ee < 3; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              y.lens[xa[y.have++]] = F & 7, F >>>= 3, ee -= 3;
            }
            for (; y.have < 19; )
              y.lens[xa[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, Vt = { bits: y.lenbits }, Dt = o(i, y.lens, 0, 19, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, Dt) {
              D.msg = "invalid code lengths set", y.mode = ue;
              break;
            }
            y.have = 0, y.mode = oe;
          /* falls through */
          case oe:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; lt = y.lencode[F & (1 << y.lenbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, St = lt & 65535, !(Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              if (St < 16)
                F >>>= Ge, ee -= Ge, y.lens[y.have++] = St;
              else {
                if (St === 16) {
                  for (Pt = Ge + 2; ee < Pt; ) {
                    if (te === 0)
                      break e;
                    te--, F += ce[d++] << ee, ee += 8;
                  }
                  if (F >>>= Ge, ee -= Ge, y.have === 0) {
                    D.msg = "invalid bit length repeat", y.mode = ue;
                    break;
                  }
                  ot = y.lens[y.have - 1], Le = 3 + (F & 3), F >>>= 2, ee -= 2;
                } else if (St === 17) {
                  for (Pt = Ge + 3; ee < Pt; ) {
                    if (te === 0)
                      break e;
                    te--, F += ce[d++] << ee, ee += 8;
                  }
                  F >>>= Ge, ee -= Ge, ot = 0, Le = 3 + (F & 7), F >>>= 3, ee -= 3;
                } else {
                  for (Pt = Ge + 7; ee < Pt; ) {
                    if (te === 0)
                      break e;
                    te--, F += ce[d++] << ee, ee += 8;
                  }
                  F >>>= Ge, ee -= Ge, ot = 0, Le = 11 + (F & 127), F >>>= 7, ee -= 7;
                }
                if (y.have + Le > y.nlen + y.ndist) {
                  D.msg = "invalid bit length repeat", y.mode = ue;
                  break;
                }
                for (; Le--; )
                  y.lens[y.have++] = ot;
              }
            }
            if (y.mode === ue)
              break;
            if (y.lens[256] === 0) {
              D.msg = "invalid code -- missing end-of-block", y.mode = ue;
              break;
            }
            if (y.lenbits = 9, Vt = { bits: y.lenbits }, Dt = o(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, Dt) {
              D.msg = "invalid literal/lengths set", y.mode = ue;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, Vt = { bits: y.distbits }, Dt = o(s, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, Vt), y.distbits = Vt.bits, Dt) {
              D.msg = "invalid distances set", y.mode = ue;
              break;
            }
            if (y.mode = re, J === v)
              break e;
          /* falls through */
          case re:
            y.mode = fe;
          /* falls through */
          case fe:
            if (te >= 6 && k >= 258) {
              D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = F, y.bits = ee, r(D, xe), ae = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, te = D.avail_in, F = y.hold, ee = y.bits, y.mode === _ && (y.back = -1);
              break;
            }
            for (y.back = 0; lt = y.lencode[F & (1 << y.lenbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, St = lt & 65535, !(Ge <= ee); ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if (mt && (mt & 240) === 0) {
              for (At = Ge, hn = mt, an = St; lt = y.lencode[an + ((F & (1 << At + hn) - 1) >> At)], Ge = lt >>> 24, mt = lt >>> 16 & 255, St = lt & 65535, !(At + Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              F >>>= At, ee -= At, y.back += At;
            }
            if (F >>>= Ge, ee -= Ge, y.back += Ge, y.length = St, mt === 0) {
              y.mode = Ae;
              break;
            }
            if (mt & 32) {
              y.back = -1, y.mode = _;
              break;
            }
            if (mt & 64) {
              D.msg = "invalid literal/length code", y.mode = ue;
              break;
            }
            y.extra = mt & 15, y.mode = be;
          /* falls through */
          case be:
            if (y.extra) {
              for (Pt = y.extra; ee < Pt; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              y.length += F & (1 << y.extra) - 1, F >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = Se;
          /* falls through */
          case Se:
            for (; lt = y.distcode[F & (1 << y.distbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, St = lt & 65535, !(Ge <= ee); ) {
              if (te === 0)
                break e;
              te--, F += ce[d++] << ee, ee += 8;
            }
            if ((mt & 240) === 0) {
              for (At = Ge, hn = mt, an = St; lt = y.distcode[an + ((F & (1 << At + hn) - 1) >> At)], Ge = lt >>> 24, mt = lt >>> 16 & 255, St = lt & 65535, !(At + Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              F >>>= At, ee -= At, y.back += At;
            }
            if (F >>>= Ge, ee -= Ge, y.back += Ge, mt & 64) {
              D.msg = "invalid distance code", y.mode = ue;
              break;
            }
            y.offset = St, y.extra = mt & 15, y.mode = de;
          /* falls through */
          case de:
            if (y.extra) {
              for (Pt = y.extra; ee < Pt; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              y.offset += F & (1 << y.extra) - 1, F >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              D.msg = "invalid distance too far back", y.mode = ue;
              break;
            }
            y.mode = ye;
          /* falls through */
          case ye:
            if (k === 0)
              break e;
            if (Le = xe - k, y.offset > Le) {
              if (Le = y.offset - Le, Le > y.whave && y.sane) {
                D.msg = "invalid distance too far back", y.mode = ue;
                break;
              }
              Le > y.wnext ? (Le -= y.wnext, Ye = y.wsize - Le) : Ye = y.wnext - Le, Le > y.length && (Le = y.length), wt = y.window;
            } else
              wt = Te, Ye = ae - y.offset, Le = y.length;
            Le > k && (Le = k), k -= Le, y.length -= Le;
            do
              Te[ae++] = wt[Ye++];
            while (--Le);
            y.length === 0 && (y.mode = fe);
            break;
          case Ae:
            if (k === 0)
              break e;
            Te[ae++] = y.length, k--, y.mode = fe;
            break;
          case De:
            if (y.wrap) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, F |= ce[d++] << ee, ee += 8;
              }
              if (xe -= k, D.total_out += xe, y.total += xe, xe && (D.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, Te, xe, ae - xe) : t(y.check, Te, xe, ae - xe)), xe = k, (y.flags ? F : rt(F)) !== y.check) {
                D.msg = "incorrect data check", y.mode = ue;
                break;
              }
              F = 0, ee = 0;
            }
            y.mode = We;
          /* falls through */
          case We:
            if (y.wrap && y.flags) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, F += ce[d++] << ee, ee += 8;
              }
              if (F !== (y.total & 4294967295)) {
                D.msg = "incorrect length check", y.mode = ue;
                break;
              }
              F = 0, ee = 0;
            }
            y.mode = Ne;
          /* falls through */
          case Ne:
            Dt = f;
            break e;
          case ue:
            Dt = p;
            break e;
          case Fe:
            return x;
          case qe:
          /* falls through */
          default:
            return c;
        }
    return D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = F, y.bits = ee, (y.wsize || xe !== D.avail_out && y.mode < ue && (y.mode < De || J !== l)) && S(D, D.output, D.next_out, xe - D.avail_out), $e -= D.avail_in, xe -= D.avail_out, D.total_in += $e, D.total_out += xe, y.total += xe, y.wrap && xe && (D.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, Te, xe, D.next_out - xe) : t(y.check, Te, xe, D.next_out - xe)), D.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === _ ? 128 : 0) + (y.mode === re || y.mode === z ? 256 : 0), ($e === 0 && xe === 0 || J === l) && Dt === u && (Dt = g), Dt;
  }
  function K(D) {
    if (!D || !D.state)
      return c;
    var J = D.state;
    return J.window && (J.window = null), D.state = null, u;
  }
  function O(D, J) {
    var y;
    return !D || !D.state || (y = D.state, (y.wrap & 2) === 0) ? c : (y.head = J, J.done = !1, u);
  }
  function ie(D, J) {
    var y = J.length, ce, Te, d;
    return !D || !D.state || (ce = D.state, ce.wrap !== 0 && ce.mode !== V) ? c : ce.mode === V && (Te = 1, Te = t(Te, J, y, 0), Te !== ce.check) ? p : (d = S(D, J, y, y), d ? (ce.mode = Fe, x) : (ce.havedict = 1, u));
  }
  return zt.inflateReset = Be, zt.inflateReset2 = ze, zt.inflateResetKeep = me, zt.inflateInit = Je, zt.inflateInit2 = Ke, zt.inflate = w, zt.inflateEnd = K, zt.inflateGetHeader = O, zt.inflateSetDictionary = ie, zt.inflateInfo = "pako inflate (from Nodeca project)", zt;
}
var Rr, zl;
function os() {
  return zl || (zl = 1, Rr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Rr;
}
var Fr, Vl;
function Rh() {
  if (Vl) return Fr;
  Vl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Fr = e, Fr;
}
var Hl;
function Fh() {
  if (Hl) return Fn;
  Hl = 1;
  var e = Mh(), t = dn(), n = is(), r = os(), o = wi(), i = ls(), a = Rh(), s = Object.prototype.toString;
  function l(u) {
    if (!(this instanceof l)) return new l(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(o[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : s.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(o[m]);
  }
  l.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, p = this.options.dictionary, x, g, b, C, A, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = n.binstring2buf(u) : s.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), x = e.inflate(m, r.Z_NO_FLUSH), x === r.Z_NEED_DICT && p && (x = e.inflateSetDictionary(this.strm, p)), x === r.Z_BUF_ERROR && I === !0 && (x = r.Z_OK, I = !1), x !== r.Z_STREAM_END && x !== r.Z_OK)
        return this.onEnd(x), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || x === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), C = m.next_out - b, A = n.buf2string(m.output, b), m.next_out = C, m.avail_out = c - C, C && t.arraySet(m.output, m.output, b, C, 0), this.onData(A)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && x !== r.Z_STREAM_END);
    return x === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (x = e.inflateEnd(this.strm), this.onEnd(x), this.ended = !0, x === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(u) {
    this.chunks.push(u);
  }, l.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new l(f);
    if (m.push(u, !0), m.err)
      throw m.msg || o[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return Fn.Inflate = l, Fn.inflate = h, Fn.inflateRaw = v, Fn.ungzip = h, Fn;
}
var Nr, Ul;
function Nh() {
  if (Ul) return Nr;
  Ul = 1;
  var e = dn().assign, t = Ih(), n = Fh(), r = os(), o = {};
  return e(o, t, n, r), Nr = o, Nr;
}
var ql;
function Ph() {
  return ql || (ql = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof Ah == "function" ? n = Nh() : n = window.pako, (function(r, o) {
        r.toRGBA8 = function(i) {
          var a = i.width, s = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, s, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * s * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, p = f.rect.width, x = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, x, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, x, h, a, s, m, c, 0) : f.blend == 1 && r._copyTile(g, p, x, h, a, s, m, c, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, x, h, a, s, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, s, l) {
          var h = a * s, v = r.decode._getBPP(l), u = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = l.ctype, p = l.depth, x = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var C = l.tabs.tRNS, A = -1, I = -1, L = -1;
            if (C && (A = C[0], I = C[1], L = C[2]), p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, P = b * 3;
              f[T] = i[P], f[T + 1] = i[P + 1], f[T + 2] = i[P + 2], f[T + 3] = 255, A != -1 && i[P] == A && i[P + 1] == I && i[P + 2] == L && (f[T + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var T = b << 2, P = b * 6;
              f[T] = i[P], f[T + 1] = i[P + 2], f[T + 2] = i[P + 4], f[T + 3] = 255, A != -1 && x(i, P) == A && x(i, P + 2) == I && x(i, P + 4) == L && (f[T + 3] = 0);
            }
          } else if (c == 3) {
            var H = l.tabs.PLTE, Q = l.tabs.tRNS, N = Q ? Q.length : 0;
            if (p == 1) for (var G = 0; G < s; G++)
              for (var V = G * u, _ = G * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[V + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, M = 3 * E;
                f[T] = H[M], f[T + 1] = H[M + 1], f[T + 2] = H[M + 2], f[T + 3] = E < N ? Q[E] : 255;
              }
            if (p == 2) for (var G = 0; G < s; G++)
              for (var V = G * u, _ = G * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[V + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, M = 3 * E;
                f[T] = H[M], f[T + 1] = H[M + 1], f[T + 2] = H[M + 2], f[T + 3] = E < N ? Q[E] : 255;
              }
            if (p == 4) for (var G = 0; G < s; G++)
              for (var V = G * u, _ = G * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[V + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, M = 3 * E;
                f[T] = H[M], f[T + 1] = H[M + 1], f[T + 2] = H[M + 2], f[T + 3] = E < N ? Q[E] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, E = i[b], M = 3 * E;
              f[T] = H[M], f[T + 1] = H[M + 1], f[T + 2] = H[M + 2], f[T + 3] = E < N ? Q[E] : 255;
            }
          } else if (c == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, z = b << 1, q = i[z];
              f[T] = q, f[T + 1] = q, f[T + 2] = q, f[T + 3] = i[z + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var T = b << 2, z = b << 2, q = i[z];
              f[T] = q, f[T + 1] = q, f[T + 2] = q, f[T + 3] = i[z + 2];
            }
          } else if (c == 0) {
            var A = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var q = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), X = q == A * 255 ? 0 : 255;
              m[b] = X << 24 | q << 16 | q << 8 | q;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var q = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), X = q == A * 85 ? 0 : 255;
              m[b] = X << 24 | q << 16 | q << 8 | q;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var q = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), X = q == A * 17 ? 0 : 255;
              m[b] = X << 24 | q << 16 | q << 8 | q;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var q = i[b], X = q == A ? 0 : 255;
              m[b] = X << 24 | q << 16 | q << 8 | q;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var q = i[b << 1], X = x(i, b << 1) == A ? 0 : 255;
              m[b] = X << 24 | q << 16 | q << 8 | q;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), s = 8, l = r._bin, h = l.readUshort, v = l.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, c, p = 0, x = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != x[g]) throw "The input is not a PNG file!";
          for (; s < a.length; ) {
            var b = l.readUint(a, s);
            s += 4;
            var C = l.readASCII(a, s, 4);
            if (s += 4, C == "IHDR")
              r.decode._IHDR(a, s, u);
            else if (C == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[s + g];
              m += b;
            } else if (C == "acTL")
              u.tabs[C] = { num_frames: v(a, s), num_plays: v(a, s + 4) }, c = new Uint8Array(a.length);
            else if (C == "fcTL") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              var I = { x: v(a, s + 12), y: v(a, s + 16), width: v(a, s + 4), height: v(a, s + 8) }, L = h(a, s + 22);
              L = h(a, s + 20) / (L == 0 ? 100 : L);
              var T = { rect: I, delay: Math.round(L * 1e3), dispose: a[s + 24], blend: a[s + 25] };
              u.frames.push(T);
            } else if (C == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[p + g] = a[s + g + 4];
              p += b - 4;
            } else if (C == "pHYs")
              u.tabs[C] = [l.readUint(a, s), l.readUint(a, s + 4), a[s + 8]];
            else if (C == "cHRM") {
              u.tabs[C] = [];
              for (var g = 0; g < 8; g++) u.tabs[C].push(l.readUint(a, s + g * 4));
            } else if (C == "tEXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var P = l.nextZero(a, s), H = l.readASCII(a, s, P - s), Q = l.readASCII(a, P + 1, s + b - P - 1);
              u.tabs[C][H] = Q;
            } else if (C == "iTXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var P = 0, N = s;
              P = l.nextZero(a, N);
              var H = l.readASCII(a, N, P - N);
              N = P + 1, a[N], a[N + 1], N += 2, P = l.nextZero(a, N), l.readASCII(a, N, P - N), N = P + 1, P = l.nextZero(a, N), l.readUTF8(a, N, P - N), N = P + 1;
              var Q = l.readUTF8(a, N, b - (N - s));
              u.tabs[C][H] = Q;
            } else if (C == "PLTE")
              u.tabs[C] = l.readBytes(a, s, b);
            else if (C == "hIST") {
              var G = u.tabs.PLTE.length / 3;
              u.tabs[C] = [];
              for (var g = 0; g < G; g++) u.tabs[C].push(h(a, s + g * 2));
            } else if (C == "tRNS")
              u.ctype == 3 ? u.tabs[C] = l.readBytes(a, s, b) : u.ctype == 0 ? u.tabs[C] = h(a, s) : u.ctype == 2 && (u.tabs[C] = [h(a, s), h(a, s + 2), h(a, s + 4)]);
            else if (C == "gAMA") u.tabs[C] = l.readUint(a, s) / 1e5;
            else if (C == "sRGB") u.tabs[C] = a[s];
            else if (C == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[C] = [h(a, s)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[C] = [h(a, s), h(a, s + 2), h(a, s + 4)] : u.ctype == 3 && (u.tabs[C] = a[s]);
            else if (C == "IEND") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            s += b, l.readUint(a, s), s += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, a, s, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, s, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return o.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var s = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, u = Math.ceil(s * h / 8), f = new Uint8Array(l * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], x = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var C = x[b], A = g[b], I = 0, L = 0, T = c[b]; T < l; )
              T += C, L++;
            for (var P = p[b]; P < s; )
              P += A, I++;
            var H = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, L);
            for (var Q = 0, N = c[b]; N < l; ) {
              for (var G = p[b], V = m + Q * H << 3; G < s; ) {
                if (h == 1) {
                  var _ = i[V >> 3];
                  _ = _ >> 7 - (V & 7) & 1, f[N * u + (G >> 3)] |= _ << 7 - ((G & 3) << 0);
                }
                if (h == 2) {
                  var _ = i[V >> 3];
                  _ = _ >> 6 - (V & 7) & 3, f[N * u + (G >> 2)] |= _ << 6 - ((G & 3) << 1);
                }
                if (h == 4) {
                  var _ = i[V >> 3];
                  _ = _ >> 4 - (V & 7) & 15, f[N * u + (G >> 1)] |= _ << 4 - ((G & 1) << 2);
                }
                if (h >= 8)
                  for (var E = N * u + G * v, M = 0; M < v; M++) f[E + M] = i[(V >> 3) + M];
                V += h, G += A;
              }
              Q++, N += C;
            }
            I * L != 0 && (m += L * (1 + H)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, s, l, h) {
          var v = r.decode._getBPP(a), u = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = s + m * u, p = c + m + 1, x = i[p - 1];
            if (x == 0) for (var g = 0; g < u; g++) i[c + g] = i[p + g];
            else if (x == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              for (var g = v; g < u; g++) i[c + g] = i[p + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              if (x == 2) for (var g = v; g < u; g++) i[c + g] = i[p + g] & 255;
              if (x == 3) for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - v] >> 1) & 255;
              if (x == 4) for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (x == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[p + g] + i[c + g - u] & 255;
              if (x == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (x == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, s) {
          var l = i + a - s, h = Math.abs(l - i), v = Math.abs(l - a), u = Math.abs(l - s);
          return h <= v && h <= u ? i : v <= u ? a : s;
        }, r.decode._IHDR = function(i, a, s) {
          var l = r._bin;
          s.width = l.readUint(i, a), a += 4, s.height = l.readUint(i, a), a += 4, s.depth = i[a], a++, s.ctype = i[a], a++, s.compress = i[a], a++, s.filter = i[a], a++, s.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, s) {
            i[a] = s >> 8 & 255, i[a + 1] = s & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, s) {
            i[a] = s >> 24 & 255, i[a + 1] = s >> 16 & 255, i[a + 2] = s >> 8 & 255, i[a + 3] = s & 255;
          },
          readASCII: function(i, a, s) {
            for (var l = "", h = 0; h < s; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, s) {
            for (var l = 0; l < s.length; l++) i[a + l] = s.charCodeAt(l);
          },
          readBytes: function(i, a, s) {
            for (var l = [], h = 0; h < s; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, s) {
            for (var l = "", h, v = 0; v < s; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, s);
            }
            return h;
          }
        }, r._copyTile = function(i, a, s, l, h, v, u, f, m) {
          for (var c = Math.min(a, h), p = Math.min(s, v), x = 0, g = 0, b = 0; b < p; b++)
            for (var C = 0; C < c; C++)
              if (u >= 0 && f >= 0 ? (x = b * a + C << 2, g = (f + b) * h + u + C << 2) : (x = (-f + b) * a - u + C << 2, g = b * h + C << 2), m == 0)
                l[g] = i[x], l[g + 1] = i[x + 1], l[g + 2] = i[x + 2], l[g + 3] = i[x + 3];
              else if (m == 1) {
                var A = i[x + 3] * 0.00392156862745098, I = i[x] * A, L = i[x + 1] * A, T = i[x + 2] * A, P = l[g + 3] * (1 / 255), H = l[g] * P, Q = l[g + 1] * P, N = l[g + 2] * P, G = 1 - A, V = A + P * G, _ = V == 0 ? 0 : 1 / V;
                l[g + 3] = 255 * V, l[g + 0] = (I + H * G) * _, l[g + 1] = (L + Q * G) * _, l[g + 2] = (T + N * G) * _;
              } else if (m == 2) {
                var A = i[x + 3], I = i[x], L = i[x + 1], T = i[x + 2], P = l[g + 3], H = l[g], Q = l[g + 1], N = l[g + 2];
                A == P && I == H && L == Q && T == N ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = I, l[g + 1] = L, l[g + 2] = T, l[g + 3] = A);
              } else if (m == 3) {
                var A = i[x + 3], I = i[x], L = i[x + 1], T = i[x + 2], P = l[g + 3], H = l[g], Q = l[g + 1], N = l[g + 2];
                if (A == P && I == H && L == Q && T == N) continue;
                if (A < 220 && P > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, s, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, p = r._bin, x = r.crc.crc, g = p.writeUint, b = p.writeUshort, C = p.writeASCII, A = r.encode.compressPNG(i, a, s, l, v);
          g(u, c, 13), c += 4, C(u, c, "IHDR"), c += 4, g(u, c, a), c += 4, g(u, c, s), c += 4, u[c] = A.depth, c++, u[c] = A.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, x(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, C(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, x(u, c - 5, 5)), c += 4;
          var I = i.length > 1;
          if (I && (g(u, c, 8), c += 4, C(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, x(u, c - 12, 12)), c += 4), A.ctype == 3) {
            var L = A.plte.length;
            g(u, c, L * 3), c += 4, C(u, c, "PLTE"), c += 4;
            for (var m = 0; m < L; m++) {
              var T = m * 3, P = A.plte[m], H = P & 255, Q = P >> 8 & 255, N = P >> 16 & 255;
              u[c + T + 0] = H, u[c + T + 1] = Q, u[c + T + 2] = N;
            }
            if (c += L * 3, g(u, c, x(u, c - L * 3 - 4, L * 3 + 4)), c += 4, A.gotAlpha) {
              g(u, c, L), c += 4, C(u, c, "tRNS"), c += 4;
              for (var m = 0; m < L; m++) u[c + m] = A.plte[m] >> 24 & 255;
              c += L, g(u, c, x(u, c - L - 4, L + 4)), c += 4;
            }
          }
          for (var G = 0, V = 0; V < A.frames.length; V++) {
            var _ = A.frames[V];
            I && (g(u, c, 26), c += 4, C(u, c, "fcTL"), c += 4, g(u, c, G++), c += 4, g(u, c, _.rect.width), c += 4, g(u, c, _.rect.height), c += 4, g(u, c, _.rect.x), c += 4, g(u, c, _.rect.y), c += 4, b(u, c, h[V]), c += 2, b(u, c, 1e3), c += 2, u[c] = _.dispose, c++, u[c] = _.blend, c++, g(u, c, x(u, c - 30, 30)), c += 4);
            var E = _.cimg, L = E.length;
            g(u, c, L + (V == 0 ? 0 : 4)), c += 4;
            var M = c;
            C(u, c, V == 0 ? "IDAT" : "fdAT"), c += 4, V != 0 && (g(u, c, G++), c += 4);
            for (var m = 0; m < L; m++) u[c + m] = E[m];
            c += L, g(u, c, x(u, M, c - M)), c += 4;
          }
          return g(u, c, 0), c += 4, C(u, c, "IEND"), c += 4, g(u, c, x(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, a, s, l, h) {
          for (var v = r.encode.compress(i, a, s, l, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, p = f.bpp, x = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, p, c, x);
          }
          return v;
        }, r.encode.compress = function(i, a, s, l, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, p = 0; p < i.length; p++)
            for (var x = new Uint8Array(i[p]), g = x.length, b = 0; b < g; b += 4) c &= x[b + 3];
          var C = c != 255, A = {}, I = [];
          if (i.length != 0 && (A[0] = 0, I.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var T = L.plte[b].est.rgba;
              A[T] == null && (A[T] = I.length, I.push(T));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var P = new Uint32Array(i[p]), g = P.length, b = 0; b < g; b++) {
                var T = P[b];
                if ((b < a || T != P[b - 1] && T != P[b - a]) && A[T] == null && (A[T] = I.length, I.push(T), I.length >= 300))
                  break;
              }
          var H = C ? h : !1, Q = I.length;
          Q <= 256 && v == !1 && (Q <= 2 ? f = 1 : Q <= 4 ? f = 2 : Q <= 16 ? f = 4 : f = 8, h && (f = 8), C = !0);
          for (var N = [], p = 0; p < i.length; p++) {
            var G = new Uint8Array(i[p]), V = new Uint32Array(G.buffer), _ = 0, E = 0, M = a, z = s, q = 0;
            if (p != 0 && !H) {
              for (var X = h || p == 1 || N[N.length - 2].dispose == 2 ? 1 : 2, U = 0, oe = 1e9, re = 0; re < X; re++) {
                for (var Ne = new Uint8Array(i[p - 1 - re]), fe = new Uint32Array(i[p - 1 - re]), be = a, Se = s, de = -1, ye = -1, Ae = 0; Ae < s; Ae++) for (var De = 0; De < a; De++) {
                  var b = Ae * a + De;
                  V[b] != fe[b] && (De < be && (be = De), De > de && (de = De), Ae < Se && (Se = Ae), Ae > ye && (ye = Ae));
                }
                var We = de == -1 ? 1 : (de - be + 1) * (ye - Se + 1);
                We < oe && (oe = We, U = re, de == -1 ? (_ = E = 0, M = z = 1) : (_ = be, E = Se, M = de - be + 1, z = ye - Se + 1));
              }
              var Ne = new Uint8Array(i[p - 1 - U]);
              U == 1 && (N[N.length - 1].dispose = 2);
              var ue = new Uint8Array(M * z * 4);
              new Uint32Array(ue.buffer), r._copyTile(Ne, a, s, ue, M, z, -_, -E, 0), r._copyTile(G, a, s, ue, M, z, -_, -E, 3) ? (r._copyTile(G, a, s, ue, M, z, -_, -E, 2), q = 1) : (r._copyTile(G, a, s, ue, M, z, -_, -E, 0), q = 0), G = ue, V = new Uint32Array(G.buffer);
            }
            var Fe = 4 * M;
            if (Q <= 256 && v == !1) {
              Fe = Math.ceil(f * M / 8);
              for (var ue = new Uint8Array(Fe * z), Ae = 0; Ae < z; Ae++) {
                var b = Ae * Fe, qe = Ae * M;
                if (f == 8) for (var De = 0; De < M; De++) ue[b + De] = A[V[qe + De]];
                else if (f == 4) for (var De = 0; De < M; De++) ue[b + (De >> 1)] |= A[V[qe + De]] << 4 - (De & 1) * 4;
                else if (f == 2) for (var De = 0; De < M; De++) ue[b + (De >> 2)] |= A[V[qe + De]] << 6 - (De & 3) * 2;
                else if (f == 1) for (var De = 0; De < M; De++) ue[b + (De >> 3)] |= A[V[qe + De]] << 7 - (De & 7) * 1;
              }
              G = ue, u = 3, m = 1;
            } else if (C == !1 && i.length == 1) {
              for (var ue = new Uint8Array(M * z * 3), Ze = M * z, b = 0; b < Ze; b++) {
                var Xe = b * 3, Ve = b * 4;
                ue[Xe] = G[Ve], ue[Xe + 1] = G[Ve + 1], ue[Xe + 2] = G[Ve + 2];
              }
              G = ue, u = 2, m = 3, Fe = 3 * M;
            }
            N.push({ rect: { x: _, y: E, width: M, height: z }, img: G, bpl: Fe, bpp: m, blend: q, dispose: H ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: I, gotAlpha: C, frames: N };
        }, r.encode._filterZero = function(i, a, s, l, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(a * l > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, s, u);
              if (v.push(o.deflate(h)), s == 1) break;
            }
          for (var m, c = 1e9, p = 0; p < v.length; p++) v[p].length < c && (m = p, c = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, s, l, h, v) {
          var u = s * l, f = u + s, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < l; c++) i[f + c] = a[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            for (var c = h; c < l; c++) i[f + c] = a[u + c] - a[u + c - h] + 256 & 255;
          } else if (s == 0) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            if (v == 2) for (var c = h; c < l; c++) i[f + c] = a[u + c];
            if (v == 3) for (var c = h; c < l; c++) i[f + c] = a[u + c] - (a[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < l; c++) i[f + c] = a[u + c] - m(a[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < l; c++) i[f + c] = a[u + c] + 256 - a[u + c - l] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] >> 1) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] + a[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - m(0, a[u + c - l], 0) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - m(a[u + c - h], a[u + c - l], a[u + c - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var s = a, l = 0; l < 8; l++)
                s & 1 ? s = 3988292384 ^ s >>> 1 : s = s >>> 1;
              i[a] = s;
            }
            return i;
          })(),
          update: function(i, a, s, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[s + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, s) {
            return r.crc.update(4294967295, i, a, s) ^ 4294967295;
          }
        }, r.quantize = function(i, a, s) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), s)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var c = l[v], p = c.length, x = 0; x < p; x++) u[m + x] = c[x];
            m += p;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var C = 0, A = 0, v = 0; v < b.length; v++) b[v].est.L > C && (C = b[v].est.L, A = v);
            if (C < 1e-3) break;
            var I = b[A], L = r.quantize.splitPixels(u, f, I.i0, I.i1, I.est.e, I.est.eMq255), T = { i0: I.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            T.bst = r.quantize.stats(u, T.i0, T.i1), T.est = r.quantize.estats(T.bst);
            var P = { i0: L, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            P.bst = { R: [], m: [], N: I.bst.N - T.bst.N };
            for (var v = 0; v < 16; v++) P.bst.R[v] = I.bst.R[v] - T.bst.R[v];
            for (var v = 0; v < 4; v++) P.bst.m[v] = I.bst.m[v] - T.bst.m[v];
            P.est = r.quantize.estats(P.bst), I.left = T, I.right = P, b[A] = T, b.push(P);
          }
          b.sort(function(X, U) {
            return U.bst.N - X.bst.N;
          });
          for (var H = 0; H < l.length; H++) {
            for (var Q = r.quantize.planeDst, N = new Uint8Array(l[H].buffer), G = new Uint32Array(l[H].buffer), V = N.length, v = 0; v < V; v += 4) {
              for (var _ = N[v] * 0.00392156862745098, E = N[v + 1] * (1 / 255), M = N[v + 2] * (1 / 255), z = N[v + 3] * (1 / 255), q = g; q.left; ) q = Q(q.est, _, E, M, z) <= 0 ? q.left : q.right;
              G[v >> 2] = q.est.rgba;
            }
            l[H] = G.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, s, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, s, l, h), i;
          var v = r.quantize.planeDst(i.est, a, s, l, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, a, s, l, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, a, s, l, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, a, s, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * s + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, s, l, h) {
          var v = a - i[0], u = s - i[1], f = l - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, s, l, h, v) {
          var u = r.quantize.vecDot;
          for (l -= 4; s < l; ) {
            for (; u(i, s, h) <= v; ) s += 4;
            for (; u(i, l, h) > v; ) l -= 4;
            if (s >= l) break;
            var f = a[s >> 2];
            a[s >> 2] = a[l >> 2], a[l >> 2] = f, s += 4, l -= 4;
          }
          for (; u(i, s, h) > v; ) s -= 4;
          return s + 4;
        }, r.quantize.vecDot = function(i, a, s) {
          return i[a] * s[0] + i[a + 1] * s[1] + i[a + 2] * s[2] + i[a + 3] * s[3];
        }, r.quantize.stats = function(i, a, s) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = s - a >> 2, u = a; u < s; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), p = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * c, l[3] += f * p, l[5] += m * m, l[6] += m * c, l[7] += m * p, l[10] += c * c, l[11] += c * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, s = i.m, l = i.N, h = s[0], v = s[1], u = s[2], f = s[3], m = l == 0 ? 0 : 1 / l, c = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * u * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * u * m,
            a[7] - v * f * m,
            a[8] - u * h * m,
            a[9] - u * v * m,
            a[10] - u * u * m,
            a[11] - u * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * u * m,
            a[15] - f * f * m
          ], p = c, x = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, C = 0;
          if (l != 0)
            for (var A = 0; A < 10 && (g = x.multVec(p, g), C = Math.sqrt(x.dot(g, g)), g = x.sml(1 / C, g), !(Math.abs(C - b) < 1e-9)); A++)
              b = C;
          var I = [h * m, v * m, u * m, f * m], L = x.dot(x.sml(255, I), g), T = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: c,
            q: I,
            e: g,
            L: b,
            eMq255: L,
            eMq: x.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * T) << 16 | Math.round(255 * I[1] * T) << 8 | Math.round(255 * I[0] * T) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var s = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, u = i[v + 3];
            a && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            s[v + 0] = i[v + 0] * f, s[v + 1] = i[v + 1] * f, s[v + 2] = i[v + 2] * f, s[v + 3] = u;
          }
          return s;
        };
      })(t, n);
    })();
  })(Tr)), Tr.exports;
}
var Bh = Ph();
const zh = /* @__PURE__ */ Th(Bh), Vh = () => pa() ? Na("NuxtImg") : "img", Hh = ["alt", "src"], l2 = /* @__PURE__ */ ke({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ft("wrapper"), i = Vh(), a = ge(!0), s = W(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = W(() => o.value?.clientHeight ?? 0), h = W(() => o.value?.clientWidth ?? 0), v = W(() => e.loading || a.value), u = W(() => {
      if (!e.blurHash) return;
      const m = Ch(e.blurHash, 32, 32), c = new Uint8Array(m), p = zh.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + yh(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, c) => ($(), Z("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Et({ "--image-aspect-ratio": s.value })
    }, [
      ($(), we(Nt(j(i)), Ce({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? ($(), we(xn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: _e(() => [
          Qt(ne("img", Ce({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, Hh), [
            [ci, v.value]
          ])
        ]),
        _: 1
      })) : se("", !0)
    ], 4));
  }
}), Uh = "medium", qh = "medium", o2 = ["center", "top"], s2 = ["medium", "small"], jh = {
  key: 1,
  class: "lc-info-text__content"
}, Zh = {
  key: 0,
  class: "lc-info-text__text"
}, c2 = /* @__PURE__ */ ke({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: () => Uh },
    size: { default: () => qh },
    text: {}
  },
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = W(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (o, i) => ($(), Z("article", {
      class: pe(n.value)
    }, [
      Re(j(et), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ne("section", null, [
        e.headline ? ($(), Z("span", {
          key: 0,
          class: pe(r.value)
        }, Oe(e.headline), 3)) : se("", !0),
        e.text || o.$slots.default ? ($(), Z("div", jh, [
          ve(o.$slots, "default", {}, () => [
            e.text ? ($(), Z("p", Zh, Oe(e.text), 1)) : se("", !0)
          ])
        ])) : se("", !0)
      ])
    ], 2));
  }
}), Wh = { class: "lc-link-list" }, u2 = /* @__PURE__ */ ke({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), Z("ul", Wh, [
      ve(t.$slots, "default")
    ]));
  }
}), Xh = { key: 0 }, Yh = { class: "lc-link-list-item__headline" }, Gh = {
  key: 0,
  class: "lc-link-list-item__text"
}, d2 = /* @__PURE__ */ ke({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), Z("li", {
      class: pe(t.value)
    }, [
      Re(j(di), Ce({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: _e(() => [
          n.$slots.default ? ($(), Z("div", Xh, [
            ve(n.$slots, "default")
          ])) : ($(), Z(at, { key: 1 }, [
            e.icon ? ($(), we(j(et), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : se("", !0),
            ne("div", null, [
              ne("span", Yh, Oe(e.headline), 1),
              e.text ? ($(), Z("p", Gh, Oe(e.text), 1)) : se("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Kh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", Jh = { class: "lc-lottery-cutoff-time__headline" }, Qh = ["src"], ev = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, tv = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, nv = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, av = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, rv = 1e3, jl = /* @__PURE__ */ ke({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => je.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => je.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => je.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => je.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = Uo(), o = ge(!1), i = ge(/* @__PURE__ */ new Date());
    xo(
      () => {
        i.value = /* @__PURE__ */ new Date();
      },
      rv,
      { immediate: !r }
    );
    const a = W(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": u.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), s = W(() => new Date(e.cutoffTime)), l = W(
      () => jo({
        date: f.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), h = W(
      () => Ua(s.value) && s.value.getTime() <= i.value.getTime()
    ), v = W(() => m("days") === 0), u = W(() => {
      const p = m("minutes");
      return v.value && p ? p < e.startAnimationTime : !1;
    }), f = W(
      () => h.value && e.nextCutoffTime ? new Date(e.nextCutoffTime) : s.value
    ), m = (p) => {
      if (!Ua(s.value)) return null;
      const { days: x = 0, hours: g = 0, minutes: b = 0 } = qo(i.value, s.value);
      switch (p) {
        case "days":
          return x;
        case "minutes":
          return x * 24 + g * 60 + b;
      }
    }, c = () => {
      r || o.value || (o.value = !0, n("cutoff-time-reached"));
    };
    return He(
      [() => e.cutoffTime, h],
      ([p], [x]) => {
        p !== x && (o.value = !1), h.value && c();
      },
      { immediate: !0 }
    ), (p, x) => ($(), Z("div", {
      class: pe(a.value)
    }, [
      ne("span", Jh, [
        u.value ? ($(), Z("img", {
          key: 0,
          alt: "",
          height: "16",
          src: j(Kh),
          width: "16"
        }, null, 8, Qh)) : ($(), we(j(et), {
          key: 1,
          name: v.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        ve(p.$slots, "title", {}, () => [
          ne("span", ev, Oe(v.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ne("span", tv, Oe(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), Z("span", nv, " : ")) : se("", !0),
      ne("div", av, [
        v.value ? ($(), we(j(pf), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": f.value,
          variant: e.countdownVariant,
          onExpired: c
        }, null, 8, ["expires-at", "variant"])) : ($(), we(j(Oo), Ce({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...j(yi).drawingShort }, { datetime: f.value }), {
          default: _e(() => [
            Tt(Oe(l.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), f2 = ["default", "expressive"], iv = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, lv = {
  key: 1,
  class: "lc-lottery-numbers__value"
}, ov = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, sv = "extra", cv = /* @__PURE__ */ ke({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = W(() => o.value.flat().length), r = W(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), o = W(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: s, ignored: l, matching: h, value: v }) => ({
          empty: !s && !l && (v === void 0 || v === ""),
          icon: s,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), Z("article", {
      class: pe(t.value),
      style: Et({ "--items-per-row": r.value })
    }, [
      ne("ol", {
        class: pe(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), Z(at, null, yt(o.value, (s, l) => ($(), Z(at, { key: l }, [
          ($(!0), Z(at, null, yt(s, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, p) => ($(), Z(at, {
            key: `${l}-${p}`
          }, [
            ne("li", {
              class: "lc-lottery-numbers__list-item",
              style: Et({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              ve(i.$slots, `highlight-${m}`),
              ne("div", {
                class: pe(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === sv,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? ($(), Z("div", iv, [
                  Re(j(et), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : se("", !0),
                ve(i.$slots, `number-${m}`, Ce({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? ($(), we(j(et), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), Z("span", lv, Oe(u ? "X" : c), 1))
                ])
              ], 2)
            ], 4),
            l < o.value.length - 1 && p === s.length - 1 && i.$slots["field-divider"] ? ($(), Z("li", ov, [
              ve(i.$slots, "field-divider")
            ])) : se("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), h2 = ["large", "medium", "small"], v2 = ["medium", "small"], m2 = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(Zt || {});
const uv = ["id"], dv = { class: "lc-lottery-number-selector__label" }, fv = ["for"], hv = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], g2 = /* @__PURE__ */ ke({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    highlightedNumbers: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    numberClass: { type: Function },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = vi(), o = ft("numberInputs"), i = It(e.id), a = ge(e.fixedColumns ?? 0), s = ge(0), l = W(() => A(s.value)), h = W(
      () => u.value ? c.value : f.value
    ), v = W(() => L(s.value)), u = W(() => e.value.length >= e.selectableMax), f = W(() => {
      const U = Array.from({ length: b.value }, () => []);
      return m.value.map((oe, re) => {
        U[L(re)].push(re);
      }), _(U);
    }), m = W(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (U, oe) => e.min + oe);
    }), c = W(
      () => f.value.map(
        (U) => U.map(
          (oe) => p.value.includes(oe) ? oe : -1
        )
      )
    ), p = W(() => e.value.map((U) => m.value.indexOf(U))), x = W(() => Math.min(g.value, a.value)), g = W(() => m.value.length), b = W(() => Math.ceil(g.value / x.value)), C = (U) => {
      const oe = h.value.length, re = h.value[0].length;
      let fe = v.value, be = l.value;
      do
        switch (U) {
          case "down":
            fe = (fe + 1) % oe, fe === 0 && (be = (be + 1) % re);
            break;
          case "left":
            be = (be - 1 + re) % re, be === re - 1 && (fe = (fe - 1 + oe) % oe);
            break;
          case "right":
            be = (be + 1) % re, be === 0 && (fe = (fe + 1) % oe);
            break;
          case "up":
            fe = (fe - 1 + oe) % oe, fe === oe - 1 && (be = (be - 1 + re) % re);
            break;
        }
      while (h.value[fe][be] === -1);
      return h.value[fe][be];
    }, A = (U) => U % x.value, I = (U) => [
      {
        "lc-lottery-number-selector__number": !0,
        "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
        "lc-lottery-number-selector__number--checked": E(U),
        "lc-lottery-number-selector__number--disabled": z(U),
        "lc-lottery-number-selector__number--highlighted": M(U)
      },
      e.numberClass?.(U) ?? ""
    ], L = (U) => Math.floor(U / x.value), T = () => {
      if (u.value) {
        const re = f.value[v.value].filter(
          (fe) => fe > s.value && p.value.includes(fe)
        ).reverse();
        if (!re.length) return;
        s.value = re[0];
        return;
      }
      const U = f.value[v.value];
      s.value = U.at(-1) ?? 0;
    }, P = () => {
      if (u.value) {
        const re = f.value[v.value].filter(
          (fe) => fe < s.value && p.value.includes(fe)
        );
        if (!re.length) return;
        s.value = re[0];
        return;
      }
      const U = f.value[v.value];
      s.value = U[0];
    }, H = () => {
      s.value = u.value ? p.value[0] : 0;
    }, Q = () => {
      const U = p.value.at(-1) ?? 0;
      s.value = u.value ? U : g.value - 1;
    }, N = (U) => {
      tn(U.key, Zt) && (U.preventDefault(), U.stopPropagation(), U.ctrlKey ? G(U.key) : V(U.key));
    }, G = (U) => {
      switch (U) {
        case Zt.End:
          Q();
          break;
        case Zt.Home:
          H();
          break;
      }
    }, V = (U) => {
      switch (U) {
        case Zt.ArrowDown:
          s.value = C("down");
          break;
        case Zt.ArrowLeft:
          s.value = C("left");
          break;
        case Zt.ArrowRight:
          s.value = C("right");
          break;
        case Zt.ArrowUp:
          s.value = C("up");
          break;
        case Zt.End:
          T();
          break;
        case Zt.Home:
          P();
          break;
      }
    }, _ = (U) => {
      const oe = Math.max(...U.map((re) => re.length));
      return U.map((re) => {
        const fe = [...re];
        for (; fe.length < oe; )
          fe.push(-1);
        return fe;
      });
    }, E = (U) => e.value.includes(U), M = (U) => !!e.highlightedNumbers?.includes(U), z = (U) => e.disabled || !E(U) && u.value || e.allNumbersToggled, q = (U) => {
      const oe = [...e.value], re = oe.indexOf(U);
      re > -1 ? oe.splice(re, 1) : u.value || (oe.push(U), oe.sort((fe, be) => m.value.indexOf(fe) - m.value.indexOf(be))), n("update:value", oe);
    };
    He(
      () => e.allNumbersToggled,
      () => {
        const U = e.allNumbersToggled ? m.value : [];
        n("update:value", U);
      }
    ), He(s, (U) => {
      o.value?.[U].focus();
    }), He(u, (U) => {
      U && n("complete");
    });
    const X = lc(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const U = o.value;
      if (!r || !U?.length) return;
      const oe = U[0].getBoundingClientRect().top;
      let re = 0;
      for (const fe of U) {
        if (fe.getBoundingClientRect().top !== oe) break;
        re++;
      }
      a.value = re;
    }, 100);
    return He(() => e.fixedColumns, X), kt(X), qt(window, "resize", X), (U, oe) => ($(), Z("fieldset", Ce(U.$attrs, {
      id: j(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ne("legend", dv, Oe(e.label), 1),
      ($(!0), Z(at, null, yt(m.value, (re, fe) => ($(), Z("label", {
        key: re,
        class: pe(I(re)),
        for: `gridcell-${A(fe)}-${L(fe)}-${j(i)}`
      }, [
        ne("input", {
          id: `gridcell-${A(fe)}-${L(fe)}-${j(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: E(re),
          class: "lc-lottery-number-selector__input",
          disabled: z(re),
          tabindex: s.value === fe || E(re) ? 0 : -1,
          type: "checkbox",
          onChange: () => q(re),
          onFocusin: (be) => s.value = fe,
          onKeydown: [
            N,
            si(() => q(re), ["enter"])
          ]
        }, null, 40, hv),
        ve(U.$slots, "cell", Ce({ ref_for: !0 }, {
          checked: E(re),
          disabled: z(re),
          number: re
        }), () => [
          Tt(Oe(re), 1)
        ])
      ], 10, fv))), 128))
    ], 16, uv));
  }
}), vv = { class: "w-full" }, mv = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, gv = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, bv = { class: "lc-lottery-teaser__button-container" }, pv = { class: "lc-lottery-teaser__button-wrap" }, yv = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, wv = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, xv = { class: "lc-lottery-teaser__draw-date-headline" }, b2 = /* @__PURE__ */ ke({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => je.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": o.value
      }
    ]), r = W(
      () => jo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), o = W(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = W(
      () => e.primaryButtonProps.to ? Xn(e.primaryButtonProps.to) : "div"
    );
    return (a, s) => ($(), we(j(ar), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Ga({
      header: _e(() => [
        ve(a.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        e.variant === "expressive" ? ($(), we(j(jl), Ce({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: s[0] || (s[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : se("", !0),
        ne("section", vv, [
          ($(), we(Nt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), Z("strong", mv, Oe(e.headline), 1)) : se("", !0),
              Re(j(Qo), Ce(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), Z("strong", gv, Oe(e.subline), 1)) : se("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", bv, [
          ne("div", pv, [
            ve(a.$slots, "primary-button", {}, () => [
              Re(j(Ct), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: o.value ? "primary-ghost" : "primary",
                onClick: s[1] || (s[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  Tt(Oe(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          o.value ? ($(), Z("div", yv, [
            ve(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), we(j(Ct), Ce({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: s[2] || (s[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: _e(() => [
                  Tt(Oe(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : se("", !0)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: _e(() => [
          ["default", "badge"].includes(e.variant) ? ($(), Z("div", wv, [
            ne("div", xv, [
              Re(j(et), {
                name: "calendar",
                size: "small"
              }),
              ne("span", null, Oe(e.drawDateHeadline), 1)
            ]),
            Re(j(Oo), Ce({ locale: e.locale, ...j(yi).drawingShort }, { datetime: e.drawDate }), {
              default: _e(() => [
                Tt(Oe(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : se("", !0),
          Re(j(jl), Ce({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: s[3] || (s[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), p2 = [...ts, "expressive"], kv = { class: "lc-masked-value-display" }, y2 = /* @__PURE__ */ ke({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), Z("span", kv, [
      ($(!0), Z(at, null, yt(e.parts, (r) => ($(), Z("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), Z(at, null, yt(e.masksPerPart, (o) => ($(), Z("span", {
          key: o,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      ve(t.$slots, "default")
    ]));
  }
}), Qr = Math.min, Bn = Math.max, ja = Math.round, Da = Math.floor, Jt = (e) => ({
  x: e,
  y: e
}), Sv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jn(e) {
  return e.split("-")[0];
}
function rr(e) {
  return e.split("-")[1];
}
function _v(e) {
  return e === "x" ? "y" : "x";
}
function ss(e) {
  return e === "y" ? "height" : "width";
}
function wn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function cs(e) {
  return _v(wn(e));
}
function Ev(e, t, n) {
  n === void 0 && (n = !1);
  const r = rr(e), o = cs(e), i = ss(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Za(a)), [a, Za(a)];
}
function Cv(e) {
  const t = Za(e);
  return [ei(e), t, ei(t)];
}
function ei(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Zl = ["left", "right"], Wl = ["right", "left"], Tv = ["top", "bottom"], Av = ["bottom", "top"];
function Lv(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Wl : Zl : t ? Zl : Wl;
    case "left":
    case "right":
      return t ? Tv : Av;
    default:
      return [];
  }
}
function $v(e, t, n, r) {
  const o = rr(e);
  let i = Lv(jn(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(ei)))), i;
}
function Za(e) {
  const t = jn(e);
  return Sv[t] + e.slice(t.length);
}
function Iv(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function Dv(e) {
  return typeof e != "number" ? Iv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Wa(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Xl(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = wn(t), a = cs(t), s = ss(a), l = jn(t), h = i === "y", v = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = rr(t);
  return c && (m[a] += f * (c === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function Ov(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = xi(t, e), c = Dv(m), x = s[f ? u === "floating" ? "reference" : "floating" : u], g = Wa(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), A = await (i.isElement == null ? void 0 : i.isElement(C)) && await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  }, I = Wa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: C,
    strategy: l
  }) : b);
  return {
    top: (g.top - I.top + c.top) / A.y,
    bottom: (I.bottom - g.bottom + c.bottom) / A.y,
    left: (g.left - I.left + c.left) / A.x,
    right: (I.right - g.right + c.right) / A.x
  };
}
const Mv = 50, Rv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = a.detectOverflow ? a : {
    ...a,
    detectOverflow: Ov
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: v,
    y: u
  } = Xl(h, r, l), f = r, m = 0;
  const c = {};
  for (let p = 0; p < i.length; p++) {
    const x = i[p];
    if (!x)
      continue;
    const {
      name: g,
      fn: b
    } = x, {
      x: C,
      y: A,
      data: I,
      reset: L
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: c,
      rects: h,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = C ?? v, u = A ?? u, c[g] = {
      ...c[g],
      ...I
    }, L && m < Mv && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : L.rects), {
      x: v,
      y: u
    } = Xl(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: o,
    middlewareData: c
  };
}, Fv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: p = !0,
        ...x
      } = xi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = jn(o), b = wn(s), C = jn(s) === s, A = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), I = f || (C || !p ? [Za(s)] : Cv(s)), L = c !== "none";
      !f && L && I.push(...$v(s, p, c, A));
      const T = [s, ...I], P = await l.detectOverflow(t, x), H = [];
      let Q = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && H.push(P[g]), u) {
        const _ = Ev(o, a, A);
        H.push(P[_[0]], P[_[1]]);
      }
      if (Q = [...Q, {
        placement: o,
        overflows: H
      }], !H.every((_) => _ <= 0)) {
        var N, G;
        const _ = (((N = i.flip) == null ? void 0 : N.index) || 0) + 1, E = T[_];
        if (E && (!(u === "alignment" ? b !== wn(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        Q.every((q) => wn(q.placement) === b ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: _,
              overflows: Q
            },
            reset: {
              placement: E
            }
          };
        let M = (G = Q.filter((z) => z.overflows[0] <= 0).sort((z, q) => z.overflows[1] - q.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!M)
          switch (m) {
            case "bestFit": {
              var V;
              const z = (V = Q.filter((q) => {
                if (L) {
                  const X = wn(q.placement);
                  return X === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((X) => X > 0).reduce((X, U) => X + U, 0)]).sort((q, X) => q[1] - X[1])[0]) == null ? void 0 : V[0];
              z && (M = z);
              break;
            }
            case "initialPlacement":
              M = s;
              break;
          }
        if (o !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
}, Nv = /* @__PURE__ */ new Set(["left", "top"]);
async function Pv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = jn(n), s = rr(n), l = wn(n) === "y", h = Nv.has(a) ? -1 : 1, v = i && l ? -1 : 1, u = xi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof c == "number" && (m = s === "end" ? c * -1 : c), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const Bv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await Pv(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function ir() {
  return typeof window < "u";
}
function In(e) {
  return ki(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Mt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (ki(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ki(e) {
  return ir() ? e instanceof Node || e instanceof Mt(e).Node : !1;
}
function Xt(e) {
  return ir() ? e instanceof Element || e instanceof Mt(e).Element : !1;
}
function fn(e) {
  return ir() ? e instanceof HTMLElement || e instanceof Mt(e).HTMLElement : !1;
}
function Yl(e) {
  return !ir() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Mt(e).ShadowRoot;
}
function lr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function zv(e) {
  return /^(table|td|th)$/.test(In(e));
}
function or(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Vv = /transform|translate|scale|rotate|perspective|filter/, Hv = /paint|layout|strict|content/, pn = (e) => !!e && e !== "none";
let Pr;
function Si(e) {
  const t = Xt(e) ? Yt(e) : e;
  return pn(t.transform) || pn(t.translate) || pn(t.scale) || pn(t.rotate) || pn(t.perspective) || !_i() && (pn(t.backdropFilter) || pn(t.filter)) || Vv.test(t.willChange || "") || Hv.test(t.contain || "");
}
function Uv(e) {
  let t = Tn(e);
  for (; fn(t) && !va(t); ) {
    if (Si(t))
      return t;
    if (or(t))
      return null;
    t = Tn(t);
  }
  return null;
}
function _i() {
  return Pr == null && (Pr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Pr;
}
function va(e) {
  return /^(html|body|#document)$/.test(In(e));
}
function Yt(e) {
  return Mt(e).getComputedStyle(e);
}
function sr(e) {
  return Xt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Tn(e) {
  if (In(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yl(e) && e.host || // Fallback.
    nn(e)
  );
  return Yl(t) ? t.host : t;
}
function us(e) {
  const t = Tn(e);
  return va(t) ? (e.ownerDocument || e).body : fn(t) && lr(t) ? t : us(t);
}
function ma(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = us(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Mt(o);
  if (i) {
    const s = ti(a);
    return t.concat(a, a.visualViewport || [], lr(o) ? o : [], s && n ? ma(s) : []);
  } else
    return t.concat(o, ma(o, [], n));
}
function ti(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ds(e) {
  const t = Yt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = fn(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = ja(n) !== i || ja(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Ei(e) {
  return Xt(e) ? e : e.contextElement;
}
function zn(e) {
  const t = Ei(e);
  if (!fn(t))
    return Jt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = ds(t);
  let a = (i ? ja(n.width) : n.width) / r, s = (i ? ja(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const qv = /* @__PURE__ */ Jt(0);
function fs(e) {
  const t = Mt(e);
  return !_i() || !t.visualViewport ? qv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function jv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Mt(e);
}
function An(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Ei(e);
  let a = Jt(1);
  t && (r ? Xt(r) && (a = zn(r)) : a = zn(e));
  const s = jv(i, n, r) ? fs(i) : Jt(0);
  let l = (o.left + s.x) / a.x, h = (o.top + s.y) / a.y, v = o.width / a.x, u = o.height / a.y;
  if (i && r) {
    const f = Mt(i), m = Xt(r) ? Mt(r) : r;
    let c = f, p = ti(c);
    for (; p && m !== c; ) {
      const x = zn(p), g = p.getBoundingClientRect(), b = Yt(p), C = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * x.x, A = g.top + (p.clientTop + parseFloat(b.paddingTop)) * x.y;
      l *= x.x, h *= x.y, v *= x.x, u *= x.y, l += C, h += A, c = Mt(p), p = ti(c);
    }
  }
  return Wa({
    width: v,
    height: u,
    x: l,
    y: h
  });
}
function cr(e, t) {
  const n = sr(e).scrollLeft;
  return t ? t.left + n : An(nn(e)).left + n;
}
function hs(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - cr(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Zv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = nn(r), s = t ? or(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Jt(1);
  const v = Jt(0), u = fn(r);
  if ((u || !i) && ((In(r) !== "body" || lr(a)) && (l = sr(r)), u)) {
    const m = An(r);
    h = zn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !u && !i ? hs(a, l) : Jt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function Wv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Xv(e) {
  const t = sr(e), n = e.ownerDocument.body, r = Bn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = Bn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + cr(e);
  const a = -t.scrollTop;
  return Yt(n).direction === "rtl" && (i += Bn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: a
  };
}
const Yv = 25;
function Gv(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = Mt(e), i = nn(e), a = o.visualViewport;
  let s = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !_i() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (s = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (cr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, x = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? x / 2 : x;
    g <= Yv && (s -= g);
  }
  return {
    width: s,
    height: l,
    x: h,
    y: v
  };
}
function Kv(e, t) {
  const n = An(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = zn(e), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, h = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: h
  };
}
function Gl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = Gv(e, n, t);
  else if (t === "document")
    r = Xv(nn(e));
  else if (Xt(t))
    r = Kv(t, n);
  else {
    const o = fs(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Wa(r);
}
function Jv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ma(e, [], !1).filter((s) => Xt(s) && In(s) !== "body"), o = null;
  const i = Yt(e).position === "fixed";
  let a = i ? Tn(e) : e;
  for (; Xt(a) && !va(a); ) {
    const s = Yt(a), l = Si(a), h = o ? o.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && s.position === "static") ? r = r.filter((u) => u !== a) : o = s, a = Tn(a);
  }
  return t.set(e, r), r;
}
function Qv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? or(t) ? [] : Jv(t, this._c) : [].concat(n), r], s = Gl(t, a[0], o);
  let l = s.top, h = s.right, v = s.bottom, u = s.left;
  for (let f = 1; f < a.length; f++) {
    const m = Gl(t, a[f], o);
    l = Bn(m.top, l), h = Qr(m.right, h), v = Qr(m.bottom, v), u = Bn(m.left, u);
  }
  return {
    width: h - u,
    height: v - l,
    x: u,
    y: l
  };
}
function em(e) {
  const {
    width: t,
    height: n
  } = ds(e);
  return {
    width: t,
    height: n
  };
}
function tm(e, t, n) {
  const r = fn(t), o = nn(t), i = n === "fixed", a = An(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if ((r || !i) && ((In(t) !== "body" || lr(o)) && (s = sr(t)), r)) {
    const f = An(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && o && (l.x = cr(o));
  const h = o && !r && !i ? hs(o, s) : Jt(0), v = a.left + s.scrollLeft - l.x - h.x, u = a.top + s.scrollTop - l.y - h.y;
  return {
    x: v,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Br(e) {
  return Yt(e).position === "static";
}
function Kl(e, t) {
  if (!fn(e) || Yt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return nn(e) === n && (n = n.ownerDocument.body), n;
}
function vs(e, t) {
  const n = Mt(e);
  if (or(e))
    return n;
  if (!fn(e)) {
    let o = Tn(e);
    for (; o && !va(o); ) {
      if (Xt(o) && !Br(o))
        return o;
      o = Tn(o);
    }
    return n;
  }
  let r = Kl(e, t);
  for (; r && zv(r) && Br(r); )
    r = Kl(r, t);
  return r && va(r) && Br(r) && !Si(r) ? n : r || Uv(e) || n;
}
const nm = async function(e) {
  const t = this.getOffsetParent || vs, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: tm(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function am(e) {
  return Yt(e).direction === "rtl";
}
const rm = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zv,
  getDocumentElement: nn,
  getClippingRect: Qv,
  getOffsetParent: vs,
  getElementRects: nm,
  getClientRects: Wv,
  getDimensions: em,
  getScale: zn,
  isElement: Xt,
  isRTL: am
};
function ms(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function im(e, t, n) {
  let r = null, o;
  const i = nn(e);
  function a() {
    var v;
    clearTimeout(o), (v = r) == null || v.disconnect(), r = null;
  }
  function s(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: p,
      height: x
    } = f;
    if (v || t(), !p || !x)
      return;
    const g = Da(c), b = Da(i.clientWidth - (m + p)), C = Da(i.clientHeight - (c + x)), A = Da(m), L = {
      rootMargin: -g + "px " + -b + "px " + -C + "px " + -A + "px",
      threshold: Bn(0, Qr(1, u)) || 1
    };
    let T = !0;
    function P(H) {
      const Q = H[0].intersectionRatio;
      if (!ms(f, e.getBoundingClientRect()))
        return s();
      if (Q !== u) {
        if (!T)
          return s();
        Q ? s(!1, Q) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      r = new IntersectionObserver(P, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(P, L);
    }
    r.observe(e);
  }
  const l = Mt(e), h = () => s(n);
  return l.addEventListener("resize", h), s(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function gs(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = Ei(e), v = o || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    o && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const u = h && s ? im(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = m) == null || C.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let c, p = l ? An(e) : null;
  l && x();
  function x() {
    const g = An(e);
    p && !ms(p, g) && n(), p = g, c = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(c);
  };
}
const bs = Bv, ps = Fv, lm = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, i = {
    ...rm,
    ...o.platform,
    _c: r
  };
  return Rv(e, t, {
    ...o,
    platform: i
  });
};
function om(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Jl(e) {
  if (om(e)) {
    const t = e.$el;
    return ki(t) && In(t) === "#comment" ? null : t;
  }
  return e;
}
function ys(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ql(e, t) {
  const n = ys(e);
  return Math.round(t * n) / n;
}
function ws(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, o = W(() => {
    var T;
    return (T = nt(n.open)) != null ? T : !0;
  }), i = W(() => nt(n.middleware)), a = W(() => {
    var T;
    return (T = nt(n.placement)) != null ? T : "bottom";
  }), s = W(() => {
    var T;
    return (T = nt(n.strategy)) != null ? T : "absolute";
  }), l = W(() => {
    var T;
    return (T = nt(n.transform)) != null ? T : !0;
  }), h = W(() => Jl(e.value)), v = W(() => Jl(t.value)), u = ge(0), f = ge(0), m = ge(s.value), c = ge(a.value), p = Sn({}), x = ge(!1), g = W(() => {
    const T = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return T;
    const P = Ql(v.value, u.value), H = Ql(v.value, f.value);
    return l.value ? {
      ...T,
      transform: "translate(" + P + "px, " + H + "px)",
      ...ys(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: P + "px",
      top: H + "px"
    };
  });
  let b;
  function C() {
    if (h.value == null || v.value == null)
      return;
    const T = o.value;
    lm(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: s.value
    }).then((P) => {
      u.value = P.x, f.value = P.y, m.value = P.strategy, c.value = P.placement, p.value = P.middlewareData, x.value = T !== !1;
    });
  }
  function A() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (A(), r === void 0) {
      C();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, C);
      return;
    }
  }
  function L() {
    o.value || (x.value = !1);
  }
  return He([i, a, s, o], C, {
    flush: "sync"
  }), He([h, v], I, {
    flush: "sync"
  }), He(o, L, {
    flush: "sync"
  }), Xs() && Ys(A), {
    x: On(u),
    y: On(f),
    strategy: On(m),
    placement: On(c),
    middlewareData: On(p),
    isPositioned: On(x),
    floatingStyles: g,
    update: C
  };
}
const Ra = ge(!1);
let Vn, Hn, Un, ni = 0;
const Ci = () => (kt(() => {
  ni += 1, sm();
}), Ln(() => {
  ni -= 1, cm();
}), Ra), sm = () => {
  typeof window > "u" || (Vn || (Vn = () => Ra.value = !0, window.addEventListener("keydown", Vn, !0)), Hn || (Hn = () => Ra.value = !1, window.addEventListener("mousedown", Hn, !0)), Un || (Un = () => Ra.value = !1, window.addEventListener("pointerdown", Un, !0)));
}, cm = () => {
  typeof window > "u" || ni || (Vn && (window.removeEventListener("keydown", Vn, !0), Vn = null), Hn && (window.removeEventListener("mousedown", Hn, !0), Hn = null), Un && (window.removeEventListener("pointerdown", Un, !0), Un = null));
}, xs = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, w2 = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ut = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ut || {});
const um = {
  ref: "container",
  class: "lc-menu-button"
}, dm = ["id", "aria-activedescendant"], fm = ["id", "aria-selected", "onClick"], x2 = /* @__PURE__ */ ke({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ft("button"), i = ft("menu"), a = ge(null), s = ge(!1), { floatingStyles: l } = ws(o, i, {
      middleware: [
        bs({
          alignmentAxis: 4
        }),
        ps(),
        xs
      ],
      placement: () => e.placement,
      whileElementsMounted: gs
    }), h = It(e.id), v = Ci(), u = W(() => {
      if (!(!s.value || !Lt(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = W(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      s.value && (a.value = null, s.value = !1);
    }, c = () => {
      if (s.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, x = (b) => {
      if (!tn(b.key, Ut)) return;
      b.key !== Ut.Tab && (b.preventDefault(), b.stopPropagation());
      const C = e.options.length - 1;
      switch (b.key) {
        case Ut.ArrowDown:
          if (s.value && Lt(a.value)) {
            a.value = Math.min(C, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.ArrowUp:
          if (s.value && Lt(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = C, g();
          break;
        case Ut.End:
          if (!s.value) return;
          a.value = C;
          break;
        case Ut.Enter:
        case Ut.Space:
          if (s.value && Lt(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.Escape:
        case Ut.Tab:
          m();
          break;
        case Ut.Home:
          if (!s.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      s.value || (s.value = !0, e.value && (a.value = f.value));
    };
    return Ka(i, m, {
      ignore: [o, ...nt(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), kt(() => {
      e.value && (a.value = f.value);
    }), (b, C) => ($(), Z("div", um, [
      Re(j(Ct), Ce({
        id: j(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${j(h)}-menu`,
        "aria-expanded": s.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: x
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), we(ba, { to: "body" }, [
        s.value ? ($(), we(j(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Et({ ...j(l), zIndex: e.zIndex })
        }, {
          default: _e(() => [
            ne("ul", {
              id: `${j(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), Z(at, null, yt(e.options, (A, I) => ($(), Z("li", {
                key: `${A.label}-${"value" in A ? A.value : "action"}`,
                class: pe(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && j(v),
                  "lc-menu-button__menu-item--selected": "value" in A && A.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${j(h)}-menuitem-${I}`,
                  "aria-selected": "value" in A && A.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(A)
                }, [
                  Re(j(et), {
                    name: A.icon
                  }, null, 8, ["name"]),
                  ne("span", null, Oe(A.label), 1),
                  "value" in A && A.value === e.value ? ($(), we(j(et), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 8, fm)
              ], 2))), 128))
            ], 8, dm)
          ]),
          _: 1
        }, 8, ["style"])) : se("", !0)
      ]))
    ], 512));
  }
}), hm = "medium", vm = "default", k2 = ["medium", "small"], S2 = ["default", "info", "warning"], mm = { class: "lc-message-box__headline" }, gm = {
  key: 0,
  class: "lc-message-box__text"
}, _2 = /* @__PURE__ */ ke({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ _n({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: () => hm },
    text: {},
    variant: { default: () => vm }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Xa(e, "modelValue"), r = W(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (o, i) => ($(), we(j(Xf), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: pe(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: _e(() => [
        ne("span", mm, [
          Re(j(et), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ne("span", null, Oe(e.headline), 1)
        ])
      ]),
      default: _e(() => [
        ve(o.$slots, "default", {}, () => [
          e.text ? ($(), Z("p", gm, Oe(e.text), 1)) : se("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
});
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var on;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(on || (on = {}));
const Fa = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ks = (e) => e.replace(/^0+(0$|[^0])/, "$1"), zr = (e, t) => (e.match(new RegExp(Fa(t), "g")) || []).length, bm = (e, t) => e.substring(0, e.indexOf(t)), Ss = [
  ",",
  ".",
  "٫",
  "。"
], eo = "(0|[1-9]\\d*)";
class pm {
  constructor(t) {
    var n, r, o, i, a, s;
    const { currency: l, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), p = c.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (o = p.find(({ type: b }) => b === "group")) === null || o === void 0 ? void 0 : o.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (a = u?.min) !== null && a !== void 0 ? a : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (s = u?.max) !== null && s !== void 0 ? s : c.resolvedOptions().maximumFractionDigits);
    const x = (b) => bm(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = x(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = x(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Fa(this.decimalSymbol)}(\\d*))?` : "", o = this.stripGroupingSeparator(t).match(new RegExp(`^${eo}${r}$`));
      if (o && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(o[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(o[1])}.${this.onlyDigits(o[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${eo}${Fa(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Fa(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return Ss.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class _s {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class ym extends _s {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), o = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (c) => {
      if (o(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const s = i(a);
    if (s != null)
      return this.currencyFormat.insertCurrency(s, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = ks(this.currencyFormat.onlyDigits(l)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || o(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class wm extends _s {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), o = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${ks(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: o,
      fractionDigits: o.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const xm = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class km {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...xm,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new pm(this.options), this.numberMask = this.options.autoDecimalDigits ? new wm(this.currencyFormat) : new ym(this.currencyFormat);
    const n = {
      [on.precision]: this.currencyFormat.maximumFractionDigits,
      [on.thousands]: 3,
      [on.tenThousands]: 4,
      [on.millions]: 6,
      [on.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== on.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let o;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: s, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(s, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = s = 0), o = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: s
        });
      } else
        o = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(o) && this.currencyFormat.parse(o) !== 0 && (o = o.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = o, this.numberValue = this.currencyFormat.parse(o);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, o = t;
      if (r && o.data && Ss.includes(o.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: s, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && zr(this.formattedValue, v) === zr(n, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, s.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const o = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(o);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: o, suffix: i, negativeSuffix: a, groupingSymbol: s, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? o : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < u)
        return u;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= u && l !== void 0 && v.includes(l) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && s !== void 0 && (f -= zr(t.substring(0, n), s)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const Sm = (e) => e?.matches("input") ? e : e?.querySelector("input");
function _m(e, t) {
  var n, r, o, i;
  let a;
  const s = ge(null), l = ge(null), h = ge(null), v = ii();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((o = v?.proxy) === null || o === void 0 ? void 0 : o.$props), f = Gs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = W(() => u?.[f ? "modelValue" : "value"]);
  return He(s, (c) => {
    var p;
    if (c) {
      const x = Sm((p = c?.$el) !== null && p !== void 0 ? p : c);
      x ? (a = new km({
        el: x,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: s,
    numberValue: h,
    formattedValue: l,
    setValue: (c) => a?.setValue(c),
    setOptions: (c) => a?.setOptions(c)
  };
}
const to = 2, E2 = /* @__PURE__ */ ke({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: o, inputRef: i, numberValue: a, setValue: s } = _m(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: to,
        valueRange: e.valueRange
      }
    ), l = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = W(
      () => Lt(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (u) => {
      s(Lt(u) ? parseFloat((u / 100).toFixed(to)) : null);
    };
    return kt(async () => {
      Lt(e.value) && (await Ya(), v(e.value));
    }), He(h, (u) => {
      n("update:value", u);
    }), He(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => ($(), we(j(nr), Ce({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: j(o)
    }), Ga({
      prefix: _e(() => [
        Tt(Oe(l.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: _e(() => [
          ve(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Em = ["aria-checked", "aria-label"], C2 = /* @__PURE__ */ ke({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => je.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), n = ge("password"), r = W(() => o.value ? "eye-off" : "eye"), o = W(() => n.value === "text"), i = () => {
      n.value = o.value ? "password" : "text";
    };
    return (a, s) => ($(), we(j(nr), Ce({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: _e(() => [
        ne("button", {
          "aria-checked": o.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Re(j(et), { name: r.value }, null, 8, ["name"])
        ], 40, Em),
        ve(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), T2 = ["password", "text"], Cm = 0, Tm = "medium", A2 = ["medium", "small"], L2 = ["info", "success"], Am = ["aria-valuenow"], $2 = /* @__PURE__ */ ke({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: () => Cm },
    size: { default: () => Tm },
    variant: { default: "info" }
  },
  setup(e) {
    const t = W(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), Z("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: pe([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Re(j(Fo), Ce({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Re(xn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: _e(() => [
          ($(), we(j(et), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, Am));
  }
}), Ti = /* @__PURE__ */ Symbol(), Lm = ["for"], $m = { class: "lc-radio__control" }, Im = ["id", "aria-labelledby", "data-click-name", "name"], Dm = ["id"], Om = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Wn(Ti), o = It(e.id), i = W(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!nt(r?.disabled) || e.disabled,
        "lc-radio--error": !!nt(r?.hasError)
      }
    ]), a = W(() => e.value === nt(r?.value) || e.checked), s = W({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = W(() => {
      if (nt(r?.value))
        return a.value ? 0 : -1;
    }), h = W(() => nt(r?.name) ?? e.name);
    return (v, u) => ($(), Z("label", {
      class: pe([i.value, v.$attrs.class]),
      for: j(o)
    }, [
      ne("div", $m, [
        Qt(ne("input", Ce({ id: j(o) }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => s.value = f),
          "aria-labelledby": e.label ? `${j(o)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, Im), [
          [Ks, s.value]
        ])
      ]),
      e.label ? ($(), Z("span", {
        key: 0,
        id: `${j(o)}-label`,
        class: pe(["lc-radio__label", e.labelClass])
      }, Oe(e.label), 11, Dm)) : se("", !0)
    ], 10, Lm));
  }
}), Mm = { class: "lc-radio-card__main" }, I2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = ft("radio"), n = Wn(Ti), r = W(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), o = W(() => e.value === nt(n?.value) || e.checked), i = W(() => e.disabled || nt(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const s = t.value?.$el?.querySelector("input");
      if (!s) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      s.dispatchEvent(l), s.dispatchEvent(h);
    };
    return (s, l) => ($(), we(j(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: pe([r.value, s.$attrs.class]),
      onClick: a
    }, {
      default: _e(() => [
        ne("div", Mm, [
          Re(j(Om), Ce({ ref: "radio" }, {
            ...en(s.$attrs, ["class"]),
            ...s.$props
          }), null, 16),
          ve(s.$slots, "default", {
            checked: o.value,
            disabled: i.value
          })
        ]),
        Qt(ne("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = sa(() => {
          }, ["stop"]))
        }, [
          ve(s.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ci, o.value && s.$slots.underneath]
        ]),
        ve(s.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), Rm = ["id", "aria-labelledby"], Fm = ["id"], D2 = /* @__PURE__ */ ke({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = It(e.id), o = W(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = W(() => !!e.errorMessage);
    return kt(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), oi(Ti, {
      disabled: () => e.disabled,
      hasError: vo(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, s) => ($(), Z("fieldset", Ce({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: j(r),
      "aria-labelledby": e.label ? `${j(r)}-label` : void 0,
      class: o.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), Z("legend", {
        key: 0,
        id: `${j(r)}-label`,
        class: "lc-radio-group__label"
      }, Oe(e.label), 9, Fm)) : se("", !0),
      ne("div", {
        class: pe(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        ve(a.$slots, "default")
      ], 2),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, Rm));
  }
}), O2 = ["horizontal", "vertical"], Nm = { class: "lc-rating" }, M2 = /* @__PURE__ */ ke({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), Z("div", Nm, [
      ($(!0), Z(at, null, yt(new Array(e.max), (r, o) => ($(), Z("svg", {
        key: o,
        class: pe(["lc-rating__star", o < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ne("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ne("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), Pm = /* @__PURE__ */ ke({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), Z("div", {
      "aria-hidden": "true",
      class: pe(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Et({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), R2 = ["full", "half", "large", "medium", "none", "small"], Bm = { class: "lc-remote-list__content" }, zm = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, F2 = /* @__PURE__ */ ke({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = W(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), o = W(() => e.count < e.total), i = () => {
      o.value && n("fetch-more");
    };
    return (a, s) => ($(), Z("section", {
      class: pe(r.value)
    }, [
      ne("ul", Bm, [
        ve(a.$slots, "default"),
        e.loading ? ve(a.$slots, "loading", {}, () => [
          ($(!0), Z(at, null, yt(e.numberOfSkeletons, (l) => ($(), we(j(Pm), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : se("", !0)
      ]),
      !e.loading && o.value ? ($(), Z("div", zm, [
        ve(a.$slots, "load-more", $t(Rt({ fetchMore: i })), () => [
          Re(j(Ct), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: _e(() => [
              Tt(Oe(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? se("", !0) : ($(), we(j(fi), { key: 0 }))
      ])) : se("", !0)
    ], 2));
  }
}), Vm = { class: "lc-scratchcard-teaser__button-wrap" }, N2 = /* @__PURE__ */ ke({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), we(j(ar), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: _e(() => [
        Re(j(di), Ce({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: _e(() => [
            ve(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ne("div", Vm, [
          Re(j(Ct), Ce({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: _e(() => [
              Tt(Oe(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), P2 = [...ts];
var Gt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Gt || {});
const Hm = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], Um = ["id"], qm = { class: "lc-select__input" }, jm = ["id", "aria-activedescendant", "aria-labelledby"], Zm = ["id", "aria-selected", "onClickPassive"], B2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ft("button"), o = ft("container"), i = ft("menu"), a = ft("options"), s = ge(null), l = ge(!1), h = ri({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = ws(r, i, {
      middleware: [ps(), xs, bs(2)],
      whileElementsMounted: gs
    }), { width: u } = qr(o), f = It(e.id), m = Ci(), c = W(() => {
      if (!(!l.value || !Lt(s.value)))
        return `${f}-option-${s.value}`;
    }), p = W(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--fixed-value": b.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), x = W(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = W(() => e.options.findIndex((E) => E.value === e.value)), b = W(() => e.notNullable && e.options.length === 1 && !!e.value), C = W(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), A = W(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = W(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), L = () => {
      l.value && (s.value = null, l.value = !1, e.onBlur?.(), T("focusout"));
    }, T = (E) => {
      const M = r.value;
      if (!M) return;
      h[E] = !0;
      const z = new Event(E, { bubbles: !0 });
      M.dispatchEvent(z);
    }, P = async () => {
      l.value || await V();
    }, H = (E) => {
      const M = E.type;
      if (!G(M)) return;
      h[M] ? h[M] = !1 : E.stopPropagation();
    }, Q = async (E) => {
      if (!tn(E.key, Gt)) return;
      E.key !== Gt.Tab && (E.preventDefault(), E.stopPropagation());
      const M = e.options.length - 1;
      switch (E.key) {
        case Gt.ArrowDown:
          if (l.value && Lt(s.value)) {
            s.value = Math.min(M, s.value + 1), _();
            break;
          }
          s.value = 0, await V();
          break;
        case Gt.ArrowUp:
          if (l.value && Lt(s.value)) {
            s.value = Math.max(0, s.value - 1), _();
            break;
          }
          s.value = M, await V();
          break;
        case Gt.Enter:
        case Gt.Space:
          if (l.value && Lt(s.value)) {
            N(e.options[s.value].value);
            break;
          }
          await V();
          break;
        case Gt.Escape:
          L();
          break;
        case Gt.Tab:
          if (!l.value || !Lt(s.value)) break;
          N(e.options[s.value].value);
          break;
      }
    }, N = (E) => {
      const M = e.value === E ? null : E;
      e.notNullable && M === null || (n("update:value", M), L());
    }, G = (E) => E === "focusin" || E === "focusout", V = async () => {
      l.value || (l.value = !0, e.value && (s.value = g.value), T("focusin"), await Ya(), _());
    }, _ = () => {
      if (!Lt(s.value)) return;
      a.value?.[s.value]?.scrollIntoView({ block: "center" });
    };
    return Ka(i, L, {
      ignore: [r, ...nt(e.ignoreOutsideClickOn)]
    }), kt(() => {
      e.autofocus && r.value?.focus(), e.value && (s.value = g.value);
    }), (E, M) => ($(), Z("div", {
      ref: "container",
      class: pe([p.value, E.$attrs.class])
    }, [
      ne("button", Ce({
        id: j(f),
        ref: "button"
      }, en(E.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${j(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${j(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: P,
        onFocusin: H,
        onFocusout: H,
        onKeydown: Q
      }), [
        !b.value && e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(f)}-label`,
          class: pe(C.value)
        }, Oe(e.label), 11, Um)) : se("", !0),
        ne("div", qm, Oe(x.value), 1),
        b.value ? se("", !0) : ($(), we(j(et), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, Hm),
      b.value ? se("", !0) : ($(), we(j(Au), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: _e(() => [
          l.value ? ($(), Z("div", {
            key: 0,
            ref: "menu",
            class: pe(A.value),
            style: Et(I.value)
          }, [
            ne("ul", {
              id: `${j(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${j(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), Z(at, null, yt(e.options, (z, q) => ($(), Z("li", {
                key: `${z.label}-${z.value}`,
                class: pe(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": s.value === q && j(m),
                  "lc-select__menu-item--selected": z.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${j(f)}-option-${q}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": z.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (X) => N(z.value)
                }, [
                  ne("span", null, Oe(z.label), 1),
                  z.value === e.value ? ($(), we(j(et), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 40, Zm)
              ], 2))), 128))
            ], 8, jm)
          ], 6)) : se("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), z2 = ["default", "discreet"];
var Wt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Wt || {});
const Wm = ["id", "aria-activedescendant"], V2 = /* @__PURE__ */ ke({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ft("list"), o = ge(null), i = It(e.id), a = Ci(), s = W(() => {
      if (Lt(o.value))
        return `${i}-option-${o.value}`;
    }), l = W(() => !r.value || !Lt(o.value) ? null : r.value.querySelectorAll('[role="option"]')[o.value]), h = W(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = W(
      () => e.options.findIndex((A) => A.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (A) => e.optionComponent ? g(A) ? "span" : e.optionComponent : x(A) ? g(A) ? "span" : Xn(A.to) : "button", f = () => {
      a.value && (o.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (o.value = null);
    }, c = (A) => {
      if (!tn(A.key, Wt) || !Lt(o.value))
        return;
      A.preventDefault(), A.stopPropagation();
      const I = e.options.length - 1;
      switch (A.key) {
        case Wt.ArrowDown:
        case Wt.ArrowRight:
          o.value = Math.min(I, o.value + 1);
          break;
        case Wt.ArrowLeft:
        case Wt.ArrowUp:
          o.value = Math.max(0, o.value - 1);
          break;
        case Wt.End:
          o.value = I;
          break;
        case Wt.Enter:
        case Wt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Wt.Home:
          o.value = 0;
          break;
      }
    }, p = (A) => {
      let I;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        I = L.includes(A) ? L.filter((T) => T !== A) : C([...L, A]);
      } else
        I = e.value === A ? void 0 : A;
      n("update:value", I);
    }, x = ({ href: A, to: I }) => !!(A || I), g = (A) => Array.isArray(e.value) ? e.value.includes(A.value) : e.value === A.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, C = (A) => {
      const I = new Map(e.options.map((L, T) => [L.value, T]));
      return [...A].sort(
        (L, T) => (I.get(L) ?? 1 / 0) - (I.get(T) ?? 1 / 0)
      );
    };
    return kt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), He(o, (A) => {
      A !== null && b();
    }), (A, I) => ($(), Z("div", {
      class: pe(h.value)
    }, [
      ne("ul", {
        id: j(i),
        ref: "list",
        "aria-activedescendant": s.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        ($(!0), Z(at, null, yt(e.options, (L, T) => ($(), Z("li", {
          key: `${L.label}-${L.value}`,
          class: pe(["lc-select-list__item", {
            "lc-select-list__item--focused": o.value === T && j(a),
            "lc-select-list__item--selected": g(L)
          }]),
          role: "presentation"
        }, [
          ($(), we(Nt(u(L)), Ce({
            id: `${j(i)}-option-${T}`
          }, { ref_for: !0 }, {
            ...pu(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText || void 0,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: x(L) && !g(L) ? void 0 : "button",
            onClickPassive: (P) => p(L.value)
          }), {
            default: _e(() => [
              ne("span", null, Oe(L.label), 1),
              g(L) ? ($(), we(j(et), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : se("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, Wm)
    ], 2));
  }
});
function Oa(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function Xm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Es(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var no = Es((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function o(c, p) {
      return c.substring(0, p.length) === p;
    }
    function i(c, p) {
      return c.slice(-1 * p.length) === p;
    }
    function a(c, p, x) {
      if ((c[p] || c[x]) && c[p] === c[x]) throw new Error(p);
    }
    function s(c) {
      return typeof c == "number" && isFinite(c);
    }
    function l(c, p) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + p : p)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - p : -p))).toFixed(p);
    }
    function h(c, p, x, g, b, C, A, I, L, T, P, H) {
      var Q, N, G, V = H, _ = "", E = "";
      return C && (H = C(H)), !!s(H) && (c !== !1 && parseFloat(H.toFixed(c)) === 0 && (H = 0), H < 0 && (Q = !0, H = Math.abs(H)), c !== !1 && (H = l(H, c)), (H = H.toString()).indexOf(".") !== -1 ? (G = (N = H.split("."))[0], x && (_ = x + N[1])) : G = H, p && (G = r(G).match(/.{1,3}/g), G = r(G.join(r(p)))), Q && I && (E += I), g && (E += g), Q && L && (E += L), E += G, E += _, b && (E += b), T && (E = T(E, V)), E);
    }
    function v(c, p, x, g, b, C, A, I, L, T, P, H) {
      var Q, N = "";
      return P && (H = P(H)), !(!H || typeof H != "string") && (I && o(H, I) && (H = H.replace(I, ""), Q = !0), g && o(H, g) && (H = H.replace(g, "")), L && o(H, L) && (H = H.replace(L, ""), Q = !0), b && i(H, b) && (H = H.slice(0, -1 * b.length)), p && (H = H.split(p).join("")), x && (H = H.replace(x, ".")), Q && (N += "-"), (N = (N += H).replace(/[^0-9\.\-.]/g, "")) !== "" && (N = Number(N), A && (N = A(N)), !!s(N) && N));
    }
    function u(c) {
      var p, x, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), p = 0; p < n.length; p += 1) if ((g = c[x = n[p]]) === void 0) x !== "negative" || b.negativeBefore ? x === "mark" && b.thousand !== "." ? b[x] = "." : b[x] = !1 : b[x] = "-";
      else if (x === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(x);
        b[x] = g;
      } else if (x === "encoder" || x === "decoder" || x === "edit" || x === "undo") {
        if (typeof g != "function") throw new Error(x);
        b[x] = g;
      } else {
        if (typeof g != "string") throw new Error(x);
        b[x] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(c, p, x) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(c[n[g]]);
      return b.push(x), p.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(p) {
        return f(c, h, p);
      }, this.from = function(p) {
        return f(c, v, p);
      });
    }
    return m;
  })();
})), Ym = Xm(Es((function(e, t) {
  (function(n) {
    function r(R) {
      return o(R) && typeof R.from == "function";
    }
    function o(R) {
      return typeof R == "object" && typeof R.to == "function";
    }
    function i(R) {
      R.parentElement.removeChild(R);
    }
    function a(R) {
      return R != null;
    }
    function s(R) {
      R.preventDefault();
    }
    function l(R) {
      return R.filter((function(S) {
        return !this[S] && (this[S] = !0);
      }), {});
    }
    function h(R, S) {
      return Math.round(R / S) * S;
    }
    function v(R, S) {
      var w = R.getBoundingClientRect(), K = R.ownerDocument, O = K.documentElement, ie = C(K);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (ie.x = 0), S ? w.top + ie.y - O.clientTop : w.left + ie.x - O.clientLeft;
    }
    function u(R) {
      return typeof R == "number" && !isNaN(R) && isFinite(R);
    }
    function f(R, S, w) {
      w > 0 && (x(R, S), setTimeout((function() {
        g(R, S);
      }), w));
    }
    function m(R) {
      return Math.max(Math.min(R, 100), 0);
    }
    function c(R) {
      return Array.isArray(R) ? R : [R];
    }
    function p(R) {
      var S = (R = String(R)).split(".");
      return S.length > 1 ? S[1].length : 0;
    }
    function x(R, S) {
      R.classList && !/\s/.test(S) ? R.classList.add(S) : R.className += " " + S;
    }
    function g(R, S) {
      R.classList && !/\s/.test(S) ? R.classList.remove(S) : R.className = R.className.replace(new RegExp("(^|\\b)" + S.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(R, S) {
      return R.classList ? R.classList.contains(S) : new RegExp("\\b" + S + "\\b").test(R.className);
    }
    function C(R) {
      var S = window.pageXOffset !== void 0, w = (R.compatMode || "") === "CSS1Compat";
      return { x: S ? window.pageXOffset : w ? R.documentElement.scrollLeft : R.body.scrollLeft, y: S ? window.pageYOffset : w ? R.documentElement.scrollTop : R.body.scrollTop };
    }
    function A() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var R = !1;
      try {
        var S = Object.defineProperty({}, "passive", { get: function() {
          R = !0;
        } });
        window.addEventListener("test", null, S);
      } catch {
      }
      return R;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function T(R, S) {
      return 100 / (S - R);
    }
    function P(R, S, w) {
      return 100 * S / (R[w + 1] - R[w]);
    }
    function H(R, S) {
      return P(R, R[0] < 0 ? S + Math.abs(R[0]) : S - R[0], 0);
    }
    function Q(R, S) {
      return S * (R[1] - R[0]) / 100 + R[0];
    }
    function N(R, S) {
      for (var w = 1; R >= S[w]; ) w += 1;
      return w;
    }
    function G(R, S, w) {
      if (w >= R.slice(-1)[0]) return 100;
      var K = N(w, R), O = R[K - 1], ie = R[K], D = S[K - 1], J = S[K];
      return D + H([O, ie], w) / T(D, J);
    }
    function V(R, S, w) {
      if (w >= 100) return R.slice(-1)[0];
      var K = N(w, S), O = R[K - 1], ie = R[K], D = S[K - 1];
      return Q([O, ie], (w - D) * T(D, S[K]));
    }
    function _(R, S, w, K) {
      if (K === 100) return K;
      var O = N(K, R), ie = R[O - 1], D = R[O];
      return w ? K - ie > (D - ie) / 2 ? D : ie : S[O - 1] ? R[O - 1] + h(K - R[O - 1], S[O - 1]) : K;
    }
    var E, M;
    n.PipsMode = void 0, (M = n.PipsMode || (n.PipsMode = {})).Range = "range", M.Steps = "steps", M.Positions = "positions", M.Count = "count", M.Values = "values", n.PipsType = void 0, (E = n.PipsType || (n.PipsType = {}))[E.None = -1] = "None", E[E.NoValue = 0] = "NoValue", E[E.LargeValue = 1] = "LargeValue", E[E.SmallValue = 2] = "SmallValue";
    var z = (function() {
      function R(S, w, K) {
        var O;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [K || !1], this.xNumSteps = [!1], this.snap = w;
        var ie = [];
        for (Object.keys(S).forEach((function(D) {
          ie.push([c(S[D]), D]);
        })), ie.sort((function(D, J) {
          return D[0][0] - J[0][0];
        })), O = 0; O < ie.length; O++) this.handleEntryPoint(ie[O][1], ie[O][0]);
        for (this.xNumSteps = this.xSteps.slice(0), O = 0; O < this.xNumSteps.length; O++) this.handleStepPoint(O, this.xNumSteps[O]);
      }
      return R.prototype.getDistance = function(S) {
        for (var w = [], K = 0; K < this.xNumSteps.length - 1; K++) w[K] = P(this.xVal, S, K);
        return w;
      }, R.prototype.getAbsoluteDistance = function(S, w, K) {
        var O, ie = 0;
        if (S < this.xPct[this.xPct.length - 1]) for (; S > this.xPct[ie + 1]; ) ie++;
        else S === this.xPct[this.xPct.length - 1] && (ie = this.xPct.length - 2);
        K || S !== this.xPct[ie + 1] || ie++, w === null && (w = []);
        var D = 1, J = w[ie], y = 0, ce = 0, Te = 0, d = 0;
        for (O = K ? (S - this.xPct[ie]) / (this.xPct[ie + 1] - this.xPct[ie]) : (this.xPct[ie + 1] - S) / (this.xPct[ie + 1] - this.xPct[ie]); J > 0; ) y = this.xPct[ie + 1 + d] - this.xPct[ie + d], w[ie + d] * D + 100 - 100 * O > 100 ? (ce = y * O, D = (J - 100 * O) / w[ie + d], O = 1) : (ce = w[ie + d] * y / 100 * D, D = 0), K ? (Te -= ce, this.xPct.length + d >= 1 && d--) : (Te += ce, this.xPct.length - d >= 1 && d++), J = w[ie + d] * D;
        return S + Te;
      }, R.prototype.toStepping = function(S) {
        return S = G(this.xVal, this.xPct, S);
      }, R.prototype.fromStepping = function(S) {
        return V(this.xVal, this.xPct, S);
      }, R.prototype.getStep = function(S) {
        return S = _(this.xPct, this.xSteps, this.snap, S);
      }, R.prototype.getDefaultStep = function(S, w, K) {
        var O = N(S, this.xPct);
        return (S === 100 || w && S === this.xPct[O - 1]) && (O = Math.max(O - 1, 1)), (this.xVal[O] - this.xVal[O - 1]) / K;
      }, R.prototype.getNearbySteps = function(S) {
        var w = N(S, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, R.prototype.countStepDecimals = function() {
        var S = this.xNumSteps.map(p);
        return Math.max.apply(null, S);
      }, R.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, R.prototype.convert = function(S) {
        return this.getStep(this.toStepping(S));
      }, R.prototype.handleEntryPoint = function(S, w) {
        var K;
        if (!u(K = S === "min" ? 0 : S === "max" ? 100 : parseFloat(S)) || !u(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(K), this.xVal.push(w[0]);
        var O = Number(w[1]);
        K ? this.xSteps.push(!isNaN(O) && O) : isNaN(O) || (this.xSteps[0] = O), this.xHighestCompleteStep.push(0);
      }, R.prototype.handleStepPoint = function(S, w) {
        if (w) if (this.xVal[S] !== this.xVal[S + 1]) {
          this.xSteps[S] = P([this.xVal[S], this.xVal[S + 1]], w, 0) / T(this.xPct[S], this.xPct[S + 1]);
          var K = (this.xVal[S + 1] - this.xVal[S]) / this.xNumSteps[S], O = Math.ceil(Number(K.toFixed(3)) - 1), ie = this.xVal[S] + this.xNumSteps[S] * O;
          this.xHighestCompleteStep[S] = ie;
        } else this.xSteps[S] = this.xHighestCompleteStep[S] = this.xVal[S];
      }, R;
    })(), q = { to: function(R) {
      return R === void 0 ? "" : R.toFixed(2);
    }, from: Number }, X = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, U = { tooltips: ".__tooltips", aria: ".__aria" };
    function oe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'step' is not numeric.");
      R.singleStep = S;
    }
    function re(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      R.keyboardPageMultiplier = S;
    }
    function fe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      R.keyboardMultiplier = S;
    }
    function be(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      R.keyboardDefaultStep = S;
    }
    function Se(R, S) {
      if (typeof S != "object" || Array.isArray(S)) throw new Error("noUiSlider: 'range' is not an object.");
      if (S.min === void 0 || S.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      R.spectrum = new z(S, R.snap || !1, R.singleStep);
    }
    function de(R, S) {
      if (S = c(S), !Array.isArray(S) || !S.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      R.handles = S.length, R.start = S;
    }
    function ye(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      R.snap = S;
    }
    function Ae(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      R.animate = S;
    }
    function De(R, S) {
      if (typeof S != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      R.animationDuration = S;
    }
    function We(R, S) {
      var w, K = [!1];
      if (S === "lower" ? S = [!0, !1] : S === "upper" && (S = [!1, !0]), S === !0 || S === !1) {
        for (w = 1; w < R.handles; w++) K.push(S);
        K.push(!1);
      } else {
        if (!Array.isArray(S) || !S.length || S.length !== R.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        K = S;
      }
      R.connect = K;
    }
    function Ne(R, S) {
      switch (S) {
        case "horizontal":
          R.ort = 0;
          break;
        case "vertical":
          R.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function ue(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      S !== 0 && (R.margin = R.spectrum.getDistance(S));
    }
    function Fe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (R.limit = R.spectrum.getDistance(S), !R.limit || R.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function qe(R, S) {
      var w;
      if (!u(S) && !Array.isArray(S)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(S) && S.length !== 2 && !u(S[0]) && !u(S[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (S !== 0) {
        for (Array.isArray(S) || (S = [S, S]), R.padding = [R.spectrum.getDistance(S[0]), R.spectrum.getDistance(S[1])], w = 0; w < R.spectrum.xNumSteps.length - 1; w++) if (R.padding[0][w] < 0 || R.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var K = S[0] + S[1], O = R.spectrum.xVal[0];
        if (K / (R.spectrum.xVal[R.spectrum.xVal.length - 1] - O) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function Ze(R, S) {
      switch (S) {
        case "ltr":
          R.dir = 0;
          break;
        case "rtl":
          R.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function Xe(R, S) {
      if (typeof S != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = S.indexOf("tap") >= 0, K = S.indexOf("drag") >= 0, O = S.indexOf("fixed") >= 0, ie = S.indexOf("snap") >= 0, D = S.indexOf("hover") >= 0, J = S.indexOf("unconstrained") >= 0, y = S.indexOf("drag-all") >= 0, ce = S.indexOf("smooth-steps") >= 0;
      if (O) {
        if (R.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        ue(R, R.start[1] - R.start[0]);
      }
      if (J && (R.margin || R.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      R.events = { tap: w || ie, drag: K, dragAll: y, smoothSteps: ce, fixed: O, snap: ie, hover: D, unconstrained: J };
    }
    function Ve(R, S) {
      if (S !== !1) if (S === !0 || o(S)) {
        R.tooltips = [];
        for (var w = 0; w < R.handles; w++) R.tooltips.push(S);
      } else {
        if ((S = c(S)).length !== R.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        S.forEach((function(K) {
          if (typeof K != "boolean" && !o(K)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), R.tooltips = S;
      }
    }
    function Pe(R, S) {
      if (S.length !== R.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      R.handleAttributes = S;
    }
    function rt(R, S) {
      if (!o(S)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      R.ariaFormat = S;
    }
    function ct(R, S) {
      if (!r(S)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      R.format = S;
    }
    function me(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      R.keyboardSupport = S;
    }
    function Be(R, S) {
      R.documentElement = S;
    }
    function ze(R, S) {
      if (typeof S != "string" && S !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      R.cssPrefix = S;
    }
    function Ke(R, S) {
      if (typeof S != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof R.cssPrefix == "string" ? (R.cssClasses = {}, Object.keys(S).forEach((function(w) {
        R.cssClasses[w] = R.cssPrefix + S[w];
      }))) : R.cssClasses = S;
    }
    function Je(R) {
      var S = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: q, format: q }, w = { step: { r: !1, t: oe }, keyboardPageMultiplier: { r: !1, t: re }, keyboardMultiplier: { r: !1, t: fe }, keyboardDefaultStep: { r: !1, t: be }, start: { r: !0, t: de }, connect: { r: !0, t: We }, direction: { r: !0, t: Ze }, snap: { r: !1, t: ye }, animate: { r: !1, t: Ae }, animationDuration: { r: !1, t: De }, range: { r: !0, t: Se }, orientation: { r: !1, t: Ne }, margin: { r: !1, t: ue }, limit: { r: !1, t: Fe }, padding: { r: !1, t: qe }, behaviour: { r: !0, t: Xe }, ariaFormat: { r: !1, t: rt }, format: { r: !1, t: ct }, tooltips: { r: !1, t: Ve }, keyboardSupport: { r: !0, t: me }, documentElement: { r: !1, t: Be }, cssPrefix: { r: !0, t: ze }, cssClasses: { r: !0, t: Ke }, handleAttributes: { r: !1, t: Pe } }, K = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: X, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      R.format && !R.ariaFormat && (R.ariaFormat = R.format), Object.keys(w).forEach((function(y) {
        if (a(R[y]) || K[y] !== void 0) w[y].t(S, a(R[y]) ? R[y] : K[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), S.pips = R.pips;
      var O = document.createElement("div"), ie = O.style.msTransform !== void 0, D = O.style.transform !== void 0;
      S.transformRule = D ? "transform" : ie ? "msTransform" : "webkitTransform";
      var J = [["left", "top"], ["right", "bottom"]];
      return S.style = J[S.dir][S.ort], S;
    }
    function ht(R, S, w) {
      var K, O, ie, D, J, y = A(), ce = L() && I(), Te = R, d = S.spectrum, ae = [], te = [], k = [], F = 0, ee = {}, $e = R.ownerDocument, xe = S.documentElement || $e.documentElement, Le = $e.body, Ye = $e.dir === "rtl" || S.ort === 1 ? 0 : 100;
      function wt(B, Y) {
        var le = $e.createElement("div");
        return Y && x(le, Y), B.appendChild(le), le;
      }
      function lt(B, Y) {
        var le = wt(B, S.cssClasses.origin), he = wt(le, S.cssClasses.handle);
        if (wt(he, S.cssClasses.touchArea), he.setAttribute("data-handle", String(Y)), S.keyboardSupport && (he.setAttribute("tabindex", "0"), he.addEventListener("keydown", (function(Ee) {
          return Ms(Ee, Y);
        }))), S.handleAttributes !== void 0) {
          var Ie = S.handleAttributes[Y];
          Object.keys(Ie).forEach((function(Ee) {
            he.setAttribute(Ee, Ie[Ee]);
          }));
        }
        return he.setAttribute("role", "slider"), he.setAttribute("aria-orientation", S.ort ? "vertical" : "horizontal"), Y === 0 ? x(he, S.cssClasses.handleLower) : Y === S.handles - 1 && x(he, S.cssClasses.handleUpper), le;
      }
      function Ge(B, Y) {
        return !!Y && wt(B, S.cssClasses.connect);
      }
      function mt(B, Y) {
        var le = wt(Y, S.cssClasses.connects);
        O = [], (ie = []).push(Ge(le, B[0]));
        for (var he = 0; he < S.handles; he++) O.push(lt(Y, he)), k[he] = he, ie.push(Ge(le, B[he + 1]));
      }
      function St(B) {
        return x(B, S.cssClasses.target), S.dir === 0 ? x(B, S.cssClasses.ltr) : x(B, S.cssClasses.rtl), S.ort === 0 ? x(B, S.cssClasses.horizontal) : x(B, S.cssClasses.vertical), x(B, getComputedStyle(B).direction === "rtl" ? S.cssClasses.textDirectionRtl : S.cssClasses.textDirectionLtr), wt(B, S.cssClasses.base);
      }
      function At(B, Y) {
        return !(!S.tooltips || !S.tooltips[Y]) && wt(B.firstChild, S.cssClasses.tooltip);
      }
      function hn() {
        return Te.hasAttribute("disabled");
      }
      function an(B) {
        return O[B].hasAttribute("disabled");
      }
      function ot() {
        J && (Yn("update" + U.tooltips), J.forEach((function(B) {
          B && i(B);
        })), J = null);
      }
      function Dt() {
        ot(), J = O.map(At), vr("update" + U.tooltips, (function(B, Y, le) {
          if (J && S.tooltips && J[Y] !== !1) {
            var he = B[Y];
            S.tooltips[Y] !== !0 && (he = S.tooltips[Y].to(le[Y])), J[Y].innerHTML = he;
          }
        }));
      }
      function xt() {
        Yn("update" + U.aria), vr("update" + U.aria, (function(B, Y, le, he, Ie) {
          k.forEach((function(Ee) {
            var Ue = O[Ee], Me = ka(te, Ee, 0, !0, !0, !0), bt = ka(te, Ee, 100, !0, !0, !0), dt = Ie[Ee], it = String(S.ariaFormat.to(le[Ee]));
            Me = d.fromStepping(Me).toFixed(1), bt = d.fromStepping(bt).toFixed(1), dt = d.fromStepping(dt).toFixed(1), Ue.children[0].setAttribute("aria-valuemin", Me), Ue.children[0].setAttribute("aria-valuemax", bt), Ue.children[0].setAttribute("aria-valuenow", dt), Ue.children[0].setAttribute("aria-valuetext", it);
          }));
        }));
      }
      function Vt(B) {
        if (B.mode === n.PipsMode.Range || B.mode === n.PipsMode.Steps) return d.xVal;
        if (B.mode === n.PipsMode.Count) {
          if (B.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Y = B.values - 1, le = 100 / Y, he = []; Y--; ) he[Y] = Y * le;
          return he.push(100), Pt(he, B.stepped);
        }
        return B.mode === n.PipsMode.Positions ? Pt(B.values, B.stepped) : B.mode === n.PipsMode.Values ? B.stepped ? B.values.map((function(Ie) {
          return d.fromStepping(d.getStep(d.toStepping(Ie)));
        })) : B.values : [];
      }
      function Pt(B, Y) {
        return B.map((function(le) {
          return d.fromStepping(Y ? d.getStep(le) : le);
        }));
      }
      function xa(B) {
        function Y(dt, it) {
          return Number((dt + it).toFixed(7));
        }
        var le = Vt(B), he = {}, Ie = d.xVal[0], Ee = d.xVal[d.xVal.length - 1], Ue = !1, Me = !1, bt = 0;
        return (le = l(le.slice().sort((function(dt, it) {
          return dt - it;
        }))))[0] !== Ie && (le.unshift(Ie), Ue = !0), le[le.length - 1] !== Ee && (le.push(Ee), Me = !0), le.forEach((function(dt, it) {
          var st, Qe, _t, Ot, pt, Ni, br, Pi, Bi, zi, pr = dt, Dn = le[it + 1], Vi = B.mode === n.PipsMode.Steps;
          for (Vi && (st = d.xNumSteps[it]), st || (st = Dn - pr), Dn === void 0 && (Dn = pr), st = Math.max(st, 1e-7), Qe = pr; Qe <= Dn; Qe = Y(Qe, st)) {
            for (Pi = (pt = (Ot = d.toStepping(Qe)) - bt) / (B.density || 1), zi = pt / (Bi = Math.round(Pi)), _t = 1; _t <= Bi; _t += 1) he[(Ni = bt + _t * zi).toFixed(5)] = [d.fromStepping(Ni), 0];
            br = le.indexOf(Qe) > -1 ? n.PipsType.LargeValue : Vi ? n.PipsType.SmallValue : n.PipsType.NoValue, !it && Ue && Qe !== Dn && (br = 0), Qe === Dn && Me || (he[Ot.toFixed(5)] = [Qe, br]), bt = Ot;
          }
        })), he;
      }
      function Ts(B, Y, le) {
        var he, Ie, Ee = $e.createElement("div"), Ue = ((he = {})[n.PipsType.None] = "", he[n.PipsType.NoValue] = S.cssClasses.valueNormal, he[n.PipsType.LargeValue] = S.cssClasses.valueLarge, he[n.PipsType.SmallValue] = S.cssClasses.valueSub, he), Me = ((Ie = {})[n.PipsType.None] = "", Ie[n.PipsType.NoValue] = S.cssClasses.markerNormal, Ie[n.PipsType.LargeValue] = S.cssClasses.markerLarge, Ie[n.PipsType.SmallValue] = S.cssClasses.markerSub, Ie), bt = [S.cssClasses.valueHorizontal, S.cssClasses.valueVertical], dt = [S.cssClasses.markerHorizontal, S.cssClasses.markerVertical];
        function it(Qe, _t) {
          var Ot = _t === S.cssClasses.value, pt = Ot ? Ue : Me;
          return _t + " " + (Ot ? bt : dt)[S.ort] + " " + pt[Qe];
        }
        function st(Qe, _t, Ot) {
          if ((Ot = Y ? Y(_t, Ot) : Ot) !== n.PipsType.None) {
            var pt = wt(Ee, !1);
            pt.className = it(Ot, S.cssClasses.marker), pt.style[S.style] = Qe + "%", Ot > n.PipsType.NoValue && ((pt = wt(Ee, !1)).className = it(Ot, S.cssClasses.value), pt.setAttribute("data-value", String(_t)), pt.style[S.style] = Qe + "%", pt.innerHTML = String(le.to(_t)));
          }
        }
        return x(Ee, S.cssClasses.pips), x(Ee, S.ort === 0 ? S.cssClasses.pipsHorizontal : S.cssClasses.pipsVertical), Object.keys(B).forEach((function(Qe) {
          st(Qe, B[Qe][0], B[Qe][1]);
        })), Ee;
      }
      function ur() {
        D && (i(D), D = null);
      }
      function dr(B) {
        ur();
        var Y = xa(B), le = B.filter, he = B.format || { to: function(Ie) {
          return String(Math.round(Ie));
        } };
        return D = Te.appendChild(Ts(Y, le, he));
      }
      function Li() {
        var B = K.getBoundingClientRect(), Y = "offset" + ["Width", "Height"][S.ort];
        return S.ort === 0 ? B.width || K[Y] : B.height || K[Y];
      }
      function vn(B, Y, le, he) {
        var Ie = function(Ue) {
          var Me = As(Ue, he.pageOffset, he.target || Y);
          return !!Me && !(hn() && !he.doNotReject) && !(b(Te, S.cssClasses.tap) && !he.doNotReject) && !(B === y.start && Me.buttons !== void 0 && Me.buttons > 1) && (!he.hover || !Me.buttons) && (ce || Me.preventDefault(), Me.calcPoint = Me.points[S.ort], void le(Me, he));
        }, Ee = [];
        return B.split(" ").forEach((function(Ue) {
          Y.addEventListener(Ue, Ie, !!ce && { passive: !0 }), Ee.push([Ue, Ie]);
        })), Ee;
      }
      function As(B, Y, le) {
        var he = B.type.indexOf("touch") === 0, Ie = B.type.indexOf("mouse") === 0, Ee = B.type.indexOf("pointer") === 0, Ue = 0, Me = 0;
        if (B.type.indexOf("MSPointer") === 0 && (Ee = !0), B.type === "mousedown" && !B.buttons && !B.touches) return !1;
        if (he) {
          var bt = function(st) {
            var Qe = st.target;
            return Qe === le || le.contains(Qe) || B.composed && B.composedPath().shift() === le;
          };
          if (B.type === "touchstart") {
            var dt = Array.prototype.filter.call(B.touches, bt);
            if (dt.length > 1) return !1;
            Ue = dt[0].pageX, Me = dt[0].pageY;
          } else {
            var it = Array.prototype.find.call(B.changedTouches, bt);
            if (!it) return !1;
            Ue = it.pageX, Me = it.pageY;
          }
        }
        return Y = Y || C($e), (Ie || Ee) && (Ue = B.clientX + Y.x, Me = B.clientY + Y.y), B.pageOffset = Y, B.points = [Ue, Me], B.cursor = Ie || Ee, B;
      }
      function $i(B) {
        var Y = 100 * (B - v(K, S.ort)) / Li();
        return Y = m(Y), S.dir ? 100 - Y : Y;
      }
      function Ls(B) {
        var Y = 100, le = !1;
        return O.forEach((function(he, Ie) {
          if (!an(Ie)) {
            var Ee = te[Ie], Ue = Math.abs(Ee - B);
            (Ue < Y || Ue <= Y && B > Ee || Ue === 100 && Y === 100) && (le = Ie, Y = Ue);
          }
        })), le;
      }
      function $s(B, Y) {
        B.type === "mouseout" && B.target.nodeName === "HTML" && B.relatedTarget === null && fr(B, Y);
      }
      function Is(B, Y) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && B.buttons === 0 && Y.buttonsProperty !== 0) return fr(B, Y);
        var le = (S.dir ? -1 : 1) * (B.calcPoint - Y.startCalcPoint);
        Ii(le > 0, 100 * le / Y.baseSize, Y.locations, Y.handleNumbers, Y.connect);
      }
      function fr(B, Y) {
        Y.handle && (g(Y.handle, S.cssClasses.active), F -= 1), Y.listeners.forEach((function(le) {
          xe.removeEventListener(le[0], le[1]);
        })), F === 0 && (g(Te, S.cssClasses.drag), gr(), B.cursor && (Le.style.cursor = "", Le.removeEventListener("selectstart", s))), S.events.smoothSteps && (Y.handleNumbers.forEach((function(le) {
          mn(le, te[le], !0, !0, !1, !1);
        })), Y.handleNumbers.forEach((function(le) {
          gt("update", le);
        }))), Y.handleNumbers.forEach((function(le) {
          gt("change", le), gt("set", le), gt("end", le);
        }));
      }
      function hr(B, Y) {
        if (!Y.handleNumbers.some(an)) {
          var le;
          Y.handleNumbers.length === 1 && (le = O[Y.handleNumbers[0]].children[0], F += 1, x(le, S.cssClasses.active)), B.stopPropagation();
          var he = [], Ie = vn(y.move, xe, Is, { target: B.target, handle: le, connect: Y.connect, listeners: he, startCalcPoint: B.calcPoint, baseSize: Li(), pageOffset: B.pageOffset, handleNumbers: Y.handleNumbers, buttonsProperty: B.buttons, locations: te.slice() }), Ee = vn(y.end, xe, fr, { target: B.target, handle: le, listeners: he, doNotReject: !0, handleNumbers: Y.handleNumbers }), Ue = vn("mouseout", xe, $s, { target: B.target, handle: le, listeners: he, doNotReject: !0, handleNumbers: Y.handleNumbers });
          he.push.apply(he, Ie.concat(Ee, Ue)), B.cursor && (Le.style.cursor = getComputedStyle(B.target).cursor, O.length > 1 && x(Te, S.cssClasses.drag), Le.addEventListener("selectstart", s, !1)), Y.handleNumbers.forEach((function(Me) {
            gt("start", Me);
          }));
        }
      }
      function Ds(B) {
        B.stopPropagation();
        var Y = $i(B.calcPoint), le = Ls(Y);
        le !== !1 && (S.events.snap || f(Te, S.cssClasses.tap, S.animationDuration), mn(le, Y, !0, !0), gr(), gt("slide", le, !0), gt("update", le, !0), S.events.snap ? hr(B, { handleNumbers: [le] }) : (gt("change", le, !0), gt("set", le, !0)));
      }
      function Os(B) {
        var Y = $i(B.calcPoint), le = d.getStep(Y), he = d.fromStepping(le);
        Object.keys(ee).forEach((function(Ie) {
          Ie.split(".")[0] === "hover" && ee[Ie].forEach((function(Ee) {
            Ee.call(_a, he);
          }));
        }));
      }
      function Ms(B, Y) {
        if (hn() || an(Y)) return !1;
        var le = ["Left", "Right"], he = ["Down", "Up"], Ie = ["PageDown", "PageUp"], Ee = ["Home", "End"];
        S.dir && !S.ort ? le.reverse() : S.ort && !S.dir && (he.reverse(), Ie.reverse());
        var Ue, Me = B.key.replace("Arrow", ""), bt = Me === Ie[0], dt = Me === Ie[1], it = Me === he[0] || Me === le[0] || bt, st = Me === he[1] || Me === le[1] || dt, Qe = Me === Ee[0], _t = Me === Ee[1];
        if (!(it || st || Qe || _t)) return !0;
        if (B.preventDefault(), st || it) {
          var Ot = it ? 0 : 1, pt = Fi(Y)[Ot];
          if (pt === null) return !1;
          pt === !1 && (pt = d.getDefaultStep(te[Y], it, S.keyboardDefaultStep)), pt *= dt || bt ? S.keyboardPageMultiplier : S.keyboardMultiplier, pt = Math.max(pt, 1e-7), pt *= it ? -1 : 1, Ue = ae[Y] + pt;
        } else Ue = _t ? S.spectrum.xVal[S.spectrum.xVal.length - 1] : S.spectrum.xVal[0];
        return mn(Y, d.toStepping(Ue), !0, !0), gt("slide", Y), gt("update", Y), gt("change", Y), gt("set", Y), !1;
      }
      function Rs(B) {
        B.fixed || O.forEach((function(Y, le) {
          vn(y.start, Y.children[0], hr, { handleNumbers: [le] });
        })), B.tap && vn(y.start, K, Ds, {}), B.hover && vn(y.move, K, Os, { hover: !0 }), B.drag && ie.forEach((function(Y, le) {
          if (Y !== !1 && le !== 0 && le !== ie.length - 1) {
            var he = O[le - 1], Ie = O[le], Ee = [Y], Ue = [he, Ie], Me = [le - 1, le];
            x(Y, S.cssClasses.draggable), B.fixed && (Ee.push(he.children[0]), Ee.push(Ie.children[0])), B.dragAll && (Ue = O, Me = k), Ee.forEach((function(bt) {
              vn(y.start, bt, hr, { handles: Ue, handleNumbers: Me, connect: Y });
            }));
          }
        }));
      }
      function vr(B, Y) {
        ee[B] = ee[B] || [], ee[B].push(Y), B.split(".")[0] === "update" && O.forEach((function(le, he) {
          gt("update", he);
        }));
      }
      function Fs(B) {
        return B === U.aria || B === U.tooltips;
      }
      function Yn(B) {
        var Y = B && B.split(".")[0], le = Y ? B.substring(Y.length) : B;
        Object.keys(ee).forEach((function(he) {
          var Ie = he.split(".")[0], Ee = he.substring(Ie.length);
          Y && Y !== Ie || le && le !== Ee || Fs(Ee) && le !== Ee || delete ee[he];
        }));
      }
      function gt(B, Y, le) {
        Object.keys(ee).forEach((function(he) {
          var Ie = he.split(".")[0];
          B === Ie && ee[he].forEach((function(Ee) {
            Ee.call(_a, ae.map(S.format.to), Y, ae.slice(), le || !1, te.slice(), _a);
          }));
        }));
      }
      function ka(B, Y, le, he, Ie, Ee, Ue) {
        var Me;
        return O.length > 1 && !S.events.unconstrained && (he && Y > 0 && (Me = d.getAbsoluteDistance(B[Y - 1], S.margin, !1), le = Math.max(le, Me)), Ie && Y < O.length - 1 && (Me = d.getAbsoluteDistance(B[Y + 1], S.margin, !0), le = Math.min(le, Me))), O.length > 1 && S.limit && (he && Y > 0 && (Me = d.getAbsoluteDistance(B[Y - 1], S.limit, !1), le = Math.min(le, Me)), Ie && Y < O.length - 1 && (Me = d.getAbsoluteDistance(B[Y + 1], S.limit, !0), le = Math.max(le, Me))), S.padding && (Y === 0 && (Me = d.getAbsoluteDistance(0, S.padding[0], !1), le = Math.max(le, Me)), Y === O.length - 1 && (Me = d.getAbsoluteDistance(100, S.padding[1], !0), le = Math.min(le, Me))), Ue || (le = d.getStep(le)), !((le = m(le)) === B[Y] && !Ee) && le;
      }
      function mr(B, Y) {
        var le = S.ort;
        return (le ? Y : B) + ", " + (le ? B : Y);
      }
      function Ii(B, Y, le, he, Ie) {
        var Ee = le.slice(), Ue = he[0], Me = S.events.smoothSteps, bt = [!B, B], dt = [B, !B];
        he = he.slice(), B && he.reverse(), he.length > 1 ? he.forEach((function(st, Qe) {
          var _t = ka(Ee, st, Ee[st] + Y, bt[Qe], dt[Qe], !1, Me);
          _t === !1 ? Y = 0 : (Y = _t - Ee[st], Ee[st] = _t);
        })) : bt = dt = [!0];
        var it = !1;
        he.forEach((function(st, Qe) {
          it = mn(st, le[st] + Y, bt[Qe], dt[Qe], !1, Me) || it;
        })), it && (he.forEach((function(st) {
          gt("update", st), gt("slide", st);
        })), Ie != null && gt("drag", Ue));
      }
      function Di(B, Y) {
        return S.dir ? 100 - B - Y : B;
      }
      function Ns(B, Y) {
        te[B] = Y, ae[B] = d.fromStepping(Y);
        var le = "translate(" + mr(Di(Y, 0) - Ye + "%", "0") + ")";
        O[B].style[S.transformRule] = le, Oi(B), Oi(B + 1);
      }
      function gr() {
        k.forEach((function(B) {
          var Y = te[B] > 50 ? -1 : 1, le = 3 + (O.length + Y * B);
          O[B].style.zIndex = String(le);
        }));
      }
      function mn(B, Y, le, he, Ie, Ee) {
        return Ie || (Y = ka(te, B, Y, le, he, !1, Ee)), Y !== !1 && (Ns(B, Y), !0);
      }
      function Oi(B) {
        if (ie[B]) {
          var Y = 0, le = 100;
          B !== 0 && (Y = te[B - 1]), B !== ie.length - 1 && (le = te[B]);
          var he = le - Y, Ie = "translate(" + mr(Di(Y, he) + "%", "0") + ")", Ee = "scale(" + mr(he / 100, "1") + ")";
          ie[B].style[S.transformRule] = Ie + " " + Ee;
        }
      }
      function Mi(B, Y) {
        return B === null || B === !1 || B === void 0 ? te[Y] : (typeof B == "number" && (B = String(B)), (B = S.format.from(B)) !== !1 && (B = d.toStepping(B)), B === !1 || isNaN(B) ? te[Y] : B);
      }
      function Sa(B, Y, le) {
        var he = c(B), Ie = te[0] === void 0;
        Y = Y === void 0 || Y, S.animate && !Ie && f(Te, S.cssClasses.tap, S.animationDuration), k.forEach((function(Me) {
          mn(Me, Mi(he[Me], Me), !0, !1, le);
        }));
        var Ee = k.length === 1 ? 0 : 1;
        if (Ie && d.hasNoSize() && (le = !0, te[0] = 0, k.length > 1)) {
          var Ue = 100 / (k.length - 1);
          k.forEach((function(Me) {
            te[Me] = Me * Ue;
          }));
        }
        for (; Ee < k.length; ++Ee) k.forEach((function(Me) {
          mn(Me, te[Me], !0, !0, le);
        }));
        gr(), k.forEach((function(Me) {
          gt("update", Me), he[Me] !== null && Y && gt("set", Me);
        }));
      }
      function Ps(B) {
        Sa(S.start, B);
      }
      function Bs(B, Y, le, he) {
        if (!((B = Number(B)) >= 0 && B < k.length)) throw new Error("noUiSlider: invalid handle number, got: " + B);
        mn(B, Mi(Y, B), !0, !0, he), gt("update", B), le && gt("set", B);
      }
      function Ri(B) {
        if (B === void 0 && (B = !1), B) return ae.length === 1 ? ae[0] : ae.slice(0);
        var Y = ae.map(S.format.to);
        return Y.length === 1 ? Y[0] : Y;
      }
      function zs() {
        for (Yn(U.aria), Yn(U.tooltips), Object.keys(S.cssClasses).forEach((function(B) {
          g(Te, S.cssClasses[B]);
        })); Te.firstChild; ) Te.removeChild(Te.firstChild);
        delete Te.noUiSlider;
      }
      function Fi(B) {
        var Y = te[B], le = d.getNearbySteps(Y), he = ae[B], Ie = le.thisStep.step, Ee = null;
        if (S.snap) return [he - le.stepBefore.startValue || null, le.stepAfter.startValue - he || null];
        Ie !== !1 && he + Ie > le.stepAfter.startValue && (Ie = le.stepAfter.startValue - he), Ee = he > le.thisStep.startValue ? le.thisStep.step : le.stepBefore.step !== !1 && he - le.stepBefore.highestStep, Y === 100 ? Ie = null : Y === 0 && (Ee = null);
        var Ue = d.countStepDecimals();
        return Ie !== null && Ie !== !1 && (Ie = Number(Ie.toFixed(Ue))), Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(Ue))), [Ee, Ie];
      }
      function Vs() {
        return k.map(Fi);
      }
      function Hs(B, Y) {
        var le = Ri(), he = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        he.forEach((function(Ee) {
          B[Ee] !== void 0 && (w[Ee] = B[Ee]);
        }));
        var Ie = Je(w);
        he.forEach((function(Ee) {
          B[Ee] !== void 0 && (S[Ee] = Ie[Ee]);
        })), d = Ie.spectrum, S.margin = Ie.margin, S.limit = Ie.limit, S.padding = Ie.padding, S.pips ? dr(S.pips) : ur(), S.tooltips ? Dt() : ot(), te = [], Sa(a(B.start) ? B.start : le, Y);
      }
      function Us() {
        K = St(Te), mt(S.connect, K), Rs(S.events), Sa(S.start), S.pips && dr(S.pips), S.tooltips && Dt(), xt();
      }
      Us();
      var _a = { destroy: zs, steps: Vs, on: vr, off: Yn, get: Ri, set: Sa, setHandle: Bs, reset: Ps, __moveHandles: function(B, Y, le) {
        Ii(B, Y, te, le);
      }, options: w, updateOptions: Hs, target: Te, removePips: ur, removeTooltips: ot, getPositions: function() {
        return te.slice();
      }, getTooltips: function() {
        return J;
      }, getOrigins: function() {
        return O;
      }, pips: dr };
      return _a;
    }
    function vt(R, S) {
      if (!R || !R.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + R);
      if (R.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = ht(R, Je(S), S);
      return R.noUiSlider = w, w;
    }
    var tt = { __spectrum: z, cssClasses: X, create: vt };
    n.create = vt, n.cssClasses = X, n.default = tt, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function ao(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, o) {
    return r === n[o];
  }));
}
var ai = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, s, l) {
    const { value: h, modelValue: v, min: u } = Ea(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = ge(f.value);
    if (Oa(f.value) && (f = ge(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, s, l) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ea(a), m = W((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: W((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((p) => {
        c[p] = Array.isArray(c[p]) ? c[p].filter(((x) => x !== null)).join(" ") : c[p];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), o = (function(a, s, l) {
    const { format: h, step: v } = Ea(a), u = l.value, f = l.classList, m = W((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : no({ ...h.value }) : no({ decimals: v.value >= 0 ? 0 : 2 }))), c = W((() => Array.isArray(u.value) ? u.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (p, x, g) => {
      var b = getComputedStyle(p).direction === "rtl", C = p.noUiSlider.options.direction === "rtl", A = p.noUiSlider.options.orientation === "vertical", I = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      I.forEach((function(T, P) {
        T && L[P].appendChild(T);
      })), p.noUiSlider.on("update", (function(T, P, H, Q, N) {
        var G = [[]], V = [[]], _ = [[]], E = 0;
        I[0] && (G[0][0] = 0, V[0][0] = N[0], _[0][0] = m.value.to(parseFloat(T[0])));
        for (var M = 1; M < T.length; M++) (!I[M] || T[M] - T[M - 1] > x) && (G[++E] = [], _[E] = [], V[E] = []), I[M] && (G[E].push(M), _[E].push(m.value.to(parseFloat(T[M]))), V[E].push(N[M]));
        G.forEach((function(z, q) {
          for (var X = z.length, U = 0; U < X; U++) {
            var oe = z[U];
            if (U === X - 1) {
              var re = 0;
              V[q].forEach((function(de) {
                re += 1e3 - de;
              }));
              var fe = A ? "bottom" : "right", be = C ? 0 : X - 1, Se = 1e3 - V[q][be];
              re = (b && !A ? 100 : 0) + re / X - Se, I[oe].innerHTML = _[q].join(g), I[oe].style.display = "block", I[oe].style[fe] = re + "%", f.value.tooltipHidden.split(" ").forEach(((de) => {
                I[oe].classList.contains(de) && I[oe].classList.remove(de);
              }));
            } else I[oe].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((de) => {
              I[oe].classList.add(de);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, s, l) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: p, id: x, disabled: g, options: b, classes: C, format: A, lazy: I, ariaLabelledby: L, aria: T } = Ea(a), P = l.value, H = l.initialValue, Q = l.tooltipsFormat, N = l.tooltipsMerge, G = l.tooltipFormat, V = l.classList, _ = ge(null), E = ge(null), M = ge(!1), z = W((() => {
      let de = { cssPrefix: "", cssClasses: V.value, orientation: h.value, direction: v.value, tooltips: !!u.value && Q.value, connect: "lower", start: Oa(P.value) ? m.value : P.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (de.step = f.value), Array.isArray(P.value) && (de.connect = !0), L && L.value || T && Object.keys(T.value).length) {
        let ye = Array.isArray(P.value) ? P.value : [P.value];
        de.handleAttributes = ye.map(((Ae) => Object.assign({}, T.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return A.value && (de.ariaFormat = G.value), de;
    })), q = W((() => {
      let de = { id: x && x.value ? x.value : void 0 };
      return g.value && (de.disabled = !0), de;
    })), X = W((() => Array.isArray(P.value))), U = () => {
      let de = E.value.get();
      return Array.isArray(de) ? de.map(((ye) => parseFloat(ye))) : parseFloat(de);
    }, oe = function(de) {
      let ye = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      E.value.set(de, ye);
    }, re = (de) => {
      s.emit("input", de), s.emit("update:modelValue", de), s.emit("update", de);
    }, fe = () => {
      E.value = Ym.create(_.value, Object.assign({}, z.value, b.value)), u.value && X.value && p.value >= 0 && N(_.value, p.value, " - "), E.value.on("set", (() => {
        const de = U();
        s.emit("change", de), s.emit("set", de), I.value && re(de);
      })), E.value.on("update", (() => {
        if (!M.value) return;
        const de = U();
        X.value && ao(P.value, de) || !X.value && P.value == de ? s.emit("update", de) : I.value || re(de);
      })), E.value.on("start", (() => {
        s.emit("start", U());
      })), E.value.on("end", (() => {
        s.emit("end", U());
      })), E.value.on("slide", (() => {
        s.emit("slide", U());
      })), E.value.on("drag", (() => {
        s.emit("drag", U());
      })), _.value.querySelectorAll("[data-handle]").forEach(((de) => {
        de.onblur = () => {
          _.value && V.value.focused.split(" ").forEach(((ye) => {
            _.value.classList.remove(ye);
          }));
        }, de.onfocus = () => {
          V.value.focused.split(" ").forEach(((ye) => {
            _.value.classList.add(ye);
          }));
        };
      })), M.value = !0;
    }, be = () => {
      E.value.off(), E.value.destroy(), E.value = null;
    }, Se = (de, ye) => {
      M.value = !1, be(), fe();
    };
    return kt(fe), Ln(be), He(X, Se, { immediate: !1 }), He(m, Se, { immediate: !1 }), He(c, Se, { immediate: !1 }), He(f, Se, { immediate: !1 }), He(h, Se, { immediate: !1 }), He(v, Se, { immediate: !1 }), He(u, Se, { immediate: !1 }), He(p, Se, { immediate: !1 }), He(A, Se, { immediate: !1, deep: !0 }), He(b, Se, { immediate: !1, deep: !0 }), He(C, Se, { immediate: !1, deep: !0 }), He(P, ((de, ye) => {
      ye && (typeof ye == "object" && typeof de == "object" && de && Object.keys(ye) > Object.keys(de) || typeof ye == "object" && typeof de != "object" || Oa(de)) && Se();
    }), { immediate: !1 }), He(P, ((de) => {
      if (Oa(de)) return void oe(m.value, !1);
      let ye = U();
      X.value && !Array.isArray(ye) && (ye = [ye]), (X.value && !ao(de, ye) || !X.value && de != ye) && oe(de, !1);
    }), { deep: !0 }), { slider: _, slider$: E, isRange: X, sliderProps: q, init: fe, destroy: be, refresh: Se, update: oe, reset: () => {
      re(H.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: o.tooltipFormat, tooltipsFormat: o.tooltipsFormat, tooltipsMerge: o.tooltipsMerge, classList: r.classList });
  return { ...r, ...o, ...i };
} };
ai.render = function(e, t, n, r, o, i) {
  return $(), Z("div", Ce(e.sliderProps, { ref: "slider" }), null, 16);
}, ai.__file = "src/Slider.vue";
const Gm = ["data-click-name"], Km = { class: "lc-slider__wrap" }, Jm = {
  key: 0,
  class: "lc-slider__min"
}, Qm = {
  key: 0,
  class: "lc-slider__slider-marks"
}, e1 = ["data-testid"], t1 = {
  key: 1,
  class: "lc-slider__max"
}, n1 = 1, H2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = ge(!1), r = ft("slider"), o = t, i = W({
      get: () => e.value,
      set: (f) => o("update:value", f)
    }), a = W(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), s = W(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + n1;
      return Array.from({ length: f }, (m, c) => c);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), Z("div", {
      ref: "slider",
      class: pe(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ne("div", Km, [
        e.hideMin ? se("", !0) : ($(), Z("span", Jm, [
          ve(f.$slots, "min", $t(Rt({ min: e.min })), () => [
            Tt(Oe(e.format(e.min)), 1)
          ])
        ])),
        ne("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = sa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = sa(() => v("focusout"), ["stop"]))
        }, [
          Re(j(ai), Ce({
            ...en(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? se("", !0) : ($(), Z("div", Qm, [
            ($(!0), Z(at, null, yt(s.value, (c) => ($(), Z("span", {
              key: c,
              class: pe(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: Et(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, e1))), 128))
          ]))
        ], 32),
        e.hideMax ? se("", !0) : ($(), Z("span", t1, [
          ve(f.$slots, "max", $t(Rt({ max: e.max })), () => [
            Tt(Oe(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, Gm));
  }
});
function kn() {
  return kn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(this, arguments);
}
var a1 = 0.996, r1 = function(t, n) {
  return n === void 0 && (n = a1), t * n / (1 - n);
};
function i1(e) {
  return e[e.length - 1];
}
function l1(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var o1 = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Vr(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function ro(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Zn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Zn(t);
  }), e;
}
function s1() {
  var e = {};
  function t(o, i) {
    return e[o] = (e[o] || []).concat(i), function() {
      return n(o, i);
    };
  }
  function n(o, i) {
    e[o] = (e[o] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(o, i) {
    o in e && e[o].forEach(function(a) {
      return a(i);
    });
  }
  return Zn({
    on: t,
    off: n,
    dispatch: r
  });
}
function c1(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(s) {
      return s !== a;
    });
  }, o = function() {
    t.forEach(r);
  };
  return Zn({
    observe: n,
    unobserve: r,
    disconnect: o
  });
}
var u1 = 16 * 1.125, d1 = typeof window < "u" && window.innerHeight || 800, Hr = [1, u1, d1];
function f1(e) {
  var t = e.deltaX * Hr[e.deltaMode], n = e.deltaY * Hr[e.deltaMode], r = (e.deltaZ || 0) * Hr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var h1 = [-1, -1, -1];
function v1(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? h1 : t.map(function(r) {
    return r ? -1 : 1;
  });
  return kn({}, e, {
    axisDelta: e.axisDelta.map(function(r, o) {
      return r * n[o];
    })
  });
}
var io = 700, m1 = function(t) {
  return kn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return o1(n, -io, io);
    })
  });
}, Ur = process.env.NODE_ENV !== "production", g1 = 0.6, b1 = 0.96, p1 = 2, lo = 5, oo = /* @__PURE__ */ Zn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), y1 = 400;
function so() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: y1
  };
}
function w1(e) {
  e === void 0 && (e = {});
  var t = s1(), n = t.on, r = t.off, o = t.dispatch, i = oo, a = so(), s, l = !1, h, v = function(_) {
    Array.isArray(_) ? _.forEach(function(E) {
      return c(E);
    }) : c(_);
  }, u = function(_) {
    return _ === void 0 && (_ = {}), Object.values(_).some(function(E) {
      return E == null;
    }) ? (Ur && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Zn(kn({}, oo, i, _));
  }, f = function(_) {
    var E = kn({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Vr(E.axisMovement, E.axisVelocity.map(function(M) {
          return r1(M);
        }));
      }
    }, _);
    o("wheel", kn({}, E, {
      previous: h
    })), h = E;
  }, m = function(_, E) {
    var M = i, z = M.preventWheelAction, q = E[0], X = E[1], U = E[2];
    if (typeof z == "boolean") return z;
    switch (z) {
      case "x":
        return Math.abs(q) >= _;
      case "y":
        return Math.abs(X) >= _;
      case "z":
        return Math.abs(U) >= _;
      default:
        return Ur && console.warn("unsupported preventWheelAction value: " + z, "warn"), !1;
    }
  }, c = function(_) {
    var E = m1(v1(f1(_), i.reverseSign)), M = E.axisDelta, z = E.timeStamp, q = ro(M);
    if (_.preventDefault && m(q, M) && _.preventDefault(), a.isStarted ? a.isMomentum && q > Math.max(2, a.lastAbsDelta * 2) && (P(!0), L()) : L(), q === 0 && Object.is && Object.is(_.deltaX, -0)) {
      l = !0;
      return;
    }
    s = _, a.axisMovement = Vr(a.axisMovement, M), a.lastAbsDelta = q, a.scrollPointsToMerge.push({
      axisDelta: M,
      timeStamp: z
    }), p(), f({
      axisDelta: M,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, T();
  }, p = function() {
    a.scrollPointsToMerge.length === p1 ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(_) {
        return _.axisDelta;
      }).reduce(Vr),
      timeStamp: l1(a.scrollPointsToMerge.map(function(_) {
        return _.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || A()) : a.isStartPublished || x();
  }, x = function() {
    a.axisVelocity = i1(a.scrollPointsToMerge).axisDelta.map(function(_) {
      return _ / a.willEndTimeout;
    });
  }, g = function() {
    var _ = a.scrollPoints, E = _[0], M = _[1];
    if (!(!M || !E)) {
      var z = E.timeStamp - M.timeStamp;
      if (z <= 0) {
        Ur && console.warn("invalid deltaTime");
        return;
      }
      var q = E.axisDeltaSum.map(function(U) {
        return U / z;
      }), X = q.map(function(U, oe) {
        return U / (a.axisVelocity[oe] || 1);
      });
      a.axisVelocity = q, a.accelerationFactors.push(X), b(z);
    }
  }, b = function(_) {
    var E = Math.ceil(_ / 10) * 10 * 1.2;
    a.isMomentum || (E = Math.max(100, E * 2)), a.willEndTimeout = Math.min(1e3, Math.round(E));
  }, C = function(_) {
    return _ === 0 ? !0 : _ <= b1 && _ >= g1;
  }, A = function() {
    if (a.accelerationFactors.length >= lo) {
      if (l && (l = !1, ro(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var _ = a.accelerationFactors.slice(lo * -1), E = _.every(function(M) {
        var z = !!M.reduce(function(X, U) {
          return X && X < 1 && X === U ? 1 : 0;
        }), q = M.filter(C).length === M.length;
        return z || q;
      });
      E && I(), a.accelerationFactors = _;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = so(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, T = /* @__PURE__ */ (function() {
    var V;
    return function() {
      clearTimeout(V), V = setTimeout(P, a.willEndTimeout);
    };
  })(), P = function(_) {
    _ === void 0 && (_ = !1), a.isStarted && (a.isMomentum && _ ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, H = c1(v), Q = H.observe, N = H.unobserve, G = H.disconnect;
  return u(e), Zn({
    on: n,
    off: r,
    observe: Q,
    unobserve: N,
    disconnect: G,
    feedWheel: v,
    updateOptions: u
  });
}
var x1 = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Ai.globalOptions = void 0;
var k1 = process.env.NODE_ENV !== "production";
function Ai(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var s, l, h = a.mergeOptions, v = a.optionsAtMedia, u = h(x1, Ai.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (s = t.target) != null ? s : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, x = w1({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      T = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = x.observe(c), C = x.on("wheel", q), A = !1, I, L = 0, T = 0, P = !1;
    g(), i.on("resize", g);
    function H(X) {
      try {
        I = new MouseEvent("mousedown", X.event), E(I);
      } catch {
        return k1 && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      A = !0, L = 0, N(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function Q(X) {
      A = !1, E(_("mouseup", X)), G(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function N() {
      document.documentElement.addEventListener("mousemove", V, !0), document.documentElement.addEventListener("mouseup", V, !0), document.documentElement.addEventListener("mousedown", V, !0);
    }
    function G() {
      document.documentElement.removeEventListener("mousemove", V, !0), document.documentElement.removeEventListener("mouseup", V, !0), document.documentElement.removeEventListener("mousedown", V, !0);
    }
    function V(X) {
      A && X.isTrusted && X.stopImmediatePropagation();
    }
    function _(X, U) {
      var oe, re;
      if (p === m.options.axis) {
        var fe = U.axisMovement;
        oe = fe[0], re = fe[1];
      } else {
        var be = U.axisMovement;
        re = be[0], oe = be[1];
      }
      var Se = M(U), de = Se.isAtBoundary;
      if (de) {
        var ye = Math.min(L / T, 1), Ae = 0.25 + ye * 0.5, De = oe > 0 ? -1 : 1, We = L * De, Ne = We * Ae;
        oe += Ne, re += Ne;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var ue = m.containerRect.width, Fe = m.containerRect.height;
        oe = oe < 0 ? Math.max(oe, -ue) : Math.min(oe, ue), re = re < 0 ? Math.max(re, -Fe) : Math.min(re, Fe);
      }
      return new MouseEvent(X, {
        clientX: I.clientX + oe,
        clientY: I.clientY + re,
        screenX: I.screenX + oe,
        screenY: I.screenY + re,
        movementX: oe,
        movementY: re,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function E(X) {
      i.containerNode().dispatchEvent(X);
    }
    function M(X) {
      var U = X.axisDelta, oe = U[0], re = U[1], fe = i.scrollProgress(), be = fe < 1, Se = fe > 0, de = p === "x" ? oe : re, ye = de < 0, Ae = de > 0, De = ye && !be || Ae && !Se;
      return {
        isAtBoundary: De,
        primaryAxisDelta: de
      };
    }
    function z(X) {
      var U = M(X), oe = U.isAtBoundary, re = U.primaryAxisDelta;
      if (oe && !X.isMomentum) {
        if (L += Math.abs(re), L > T)
          return P = !0, Q(X), !0;
      } else
        L = 0;
      return !1;
    }
    function q(X) {
      var U = X.axisDelta, oe = U[0], re = U[1], fe = p === "x" ? oe : re, be = p === "x" ? re : oe, Se = X.isMomentum && X.previous && !X.previous.isMomentum, de = X.isEnding && !X.isMomentum || Se, ye = Math.abs(fe) > Math.abs(be);
      ye && !A && !X.isMomentum && !P && H(X), P && X.isEnding && (P = !1), A && (z(X) || (de ? Q(X) : E(_("mousemove", X))));
    }
    n = function() {
      b(), C(), i.off("resize", g), G();
    };
  }
  var o = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return o;
}
const S1 = { class: "lc-slot-wheel__wrap" }, U2 = /* @__PURE__ */ ke({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Qa({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      Ai()
    ], [a, s] = tr(
      {
        ...o,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = Wn(Jr, () => null, !0), h = yo(), v = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !1
      });
    }, u = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((T) => T.value === L)
    ), m = (L) => !L || h.value === "reduce", c = (L, T = !0) => {
      s.value?.scrollTo(f(L), m(T));
    }, p = () => {
      I(), r("ready");
    }, x = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      I(), r("reInit");
    }, C = () => {
      const L = s.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, A = () => {
      r("optionsChanged");
    }, I = () => {
      if (!s.value) return;
      const { rootNode: L, slideNodes: T } = s.value, H = L().getBoundingClientRect(), Q = H.top + H.height / 2;
      T().forEach((N) => {
        const G = N.getBoundingClientRect(), E = (G.top + G.height / 2 - Q) / (H.height / 2), M = Math.max(-1, Math.min(1, E)), z = 1 - Math.abs(M) * 0.3, q = N.style.transform.split(" ").filter((X) => !X.startsWith("scale("));
        q.push(`scale(${z})`), N.style.transform = q.join(" ");
      });
    };
    return kt(() => {
      s.value && s.value.on("init", p).on("pointerDown", x).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", C).on("slidesChanged", A);
    }), He(
      () => e.value,
      (L) => c(L)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), (L, T) => ($(), Z("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ne("div", S1, [
        ($(!0), Z(at, null, yt(e.options, (P, H) => ($(), Z("div", {
          key: `${P.label}-${P.value}`,
          className: "lc-slot-wheel__option"
        }, [
          ve(L.$slots, "option", Ce({ ref_for: !0 }, { index: H, option: P }), () => [
            Tt(Oe(P.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), _1 = "checkmark", q2 = ["info", "success"], E1 = ["for"], C1 = ["id", "aria-label", "data-click-name"], T1 = { class: "lc-switch__toggle" }, j2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: () => _1 },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = It(e.id), { vibrate: o } = wo(), i = W(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), Z("label", {
      class: pe([i.value, s.$attrs.class]),
      for: j(r)
    }, [
      Qt(ne("input", Ce({
        ...en(s.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: j(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = si((h) => a.value = !a.value, ["enter"]))
      }), null, 16, C1), [
        [ho, a.value]
      ]),
      l[2] || (l[2] = ne("div", { class: "lc-switch__track" }, null, -1)),
      ne("div", T1, [
        Re(j(et), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, E1));
  }
}), Z2 = /* @__PURE__ */ ke({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), Z("table", {
      class: pe(t.value)
    }, [
      ve(n.$slots, "default")
    ], 2));
  }
}), W2 = ["medium", "small", "none"], X2 = ["column", "row"], Y2 = ["bottom", "top"], G2 = ["automatic", "manual"], K2 = ["default", "divider"], J2 = /* @__PURE__ */ Symbol();
var Nn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Nn || {});
const A1 = ["id"], L1 = { class: "lc-tabs__tablist-inner" }, $1 = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], I1 = {
  key: 1,
  class: "lc-tabs__header"
}, D1 = ["aria-labelledby"], O1 = ["id", "aria-labelledby"], Q2 = /* @__PURE__ */ ke({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ft("carousel"), i = ft("container"), a = ft("tabs"), s = It(e.id), l = ge(0), h = ge(0), v = ge(null), u = ge(null), f = ge(!1), m = ge(!1);
    let c = null;
    const p = W(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), x = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const N = a.value?.[l.value];
      N && (v.value = `${N.offsetWidth}px`, u.value = `${N.offsetLeft}px`);
    };
    qt(window, "resize", [g, x]), oc(i, g);
    const b = W(() => e.tabs.length <= 1), C = (N, G) => {
      N !== l.value && (l.value = N, G?.skipCarousel || o.value?.moveToIndex(N), G?.skipUpdateEvent || r("update:value", e.tabs[N].name));
    }, A = (N) => {
      a.value?.[N].focus();
    }, I = (N) => {
      if (N !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, T = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, P = (N) => e.tabs.findIndex((G) => G.name === N), H = (N) => {
      if (!tn(N.key, Nn)) return;
      N.preventDefault(), N.stopPropagation();
      let G;
      switch (N.key) {
        case Nn.ArrowLeft:
          G = T();
          break;
        case Nn.ArrowRight:
          G = L();
          break;
        case Nn.End:
          G = e.tabs.length - 1;
          break;
        case Nn.Home:
          G = 0;
          break;
      }
      h.value = G, e.trigger === "automatic" && C(G);
    }, Q = () => {
      const N = P(e.value);
      N !== -1 && (l.value = N, h.value = N);
    };
    return Js(Q), Qs(Q), kt(() => {
      g(), b.value || (f.value = !0);
    }), He(l, g), He(h, A), He(
      () => e.value,
      (N) => {
        if (!N) return;
        const G = P(N);
        G !== -1 && C(G, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (N, G) => ($(), Z("section", {
      id: j(s),
      class: pe(p.value)
    }, [
      ve(N.$slots, "top"),
      b.value ? se("", !0) : ($(), Z("div", {
        key: 0,
        ref: "container",
        class: pe(["lc-tabs__nav_container", e.containerClass])
      }, [
        ne("nav", {
          class: pe(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Et({
            "--active-tab-index": l.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ne("div", L1, [
            ($(!0), Z(at, null, yt(e.tabs, (V, _) => ($(), Z("button", {
              id: `${j(s)}-tab-${_}`,
              key: V.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${j(s)}-tabpanel-${_}`,
              "aria-selected": l.value === _,
              class: pe(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== _ ? -1 : void 0,
              type: "button",
              onClickPassive: (E) => C(_),
              onKeydown: H
            }, [
              N.$slots.tab ? ve(N.$slots, "tab", Ce({ ref_for: !0 }, { tab: V, index: _ }), void 0, void 0, 0) : ($(), Z(at, { key: 1 }, [
                V.icon ? ($(), we(j(et), {
                  key: 0,
                  name: V.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : se("", !0),
                Tt(" " + Oe(V.title ?? V.name), 1)
              ], 64))
            ], 42, $1))), 128))
          ])
        ], 6),
        ve(N.$slots, "subnav")
      ], 2)),
      N.$slots.header ? ($(), Z("header", I1, [
        ve(N.$slots, "header")
      ])) : se("", !0),
      !f.value && e.tabs.length > 0 ? ($(), Z("div", {
        key: 2,
        "aria-labelledby": `${j(s)}-tab-${l.value}`,
        class: pe(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        ve(N.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, D1)) : se("", !0),
      b.value ? se("", !0) : ($(), we(j(df), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: pe(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: G[0] || (G[0] = (V) => C(V, { skipCarousel: !0 })),
        onReady: G[1] || (G[1] = (V) => f.value = !0)
      }, {
        slide: _e(({ index: V, isVisible: _, slide: E }) => [
          ne("div", Ce({
            id: `${j(s)}-tabpanel-${V}`
          }, I(V), {
            "aria-labelledby": `${j(s)}-tab-${V}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || _ || V === l.value ? ve(N.$slots, "tab-panel", $t(Rt({ tab: E, index: V })), void 0, void 0, 0) : se("", !0)
          ], 16, O1)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, A1));
  }
}), M1 = ["for"], R1 = ["id"], F1 = ["id", "aria-labelledby", "data-click-error", "data-click-name"], N1 = { class: "lc-textarea__feedback-wrap" }, P1 = { class: "lc-textarea__counter" }, eb = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ft("textarea"), o = It(e.id), i = ge(!1), a = W(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), s = W(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = W(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = W({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return kt(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => ($(), Z("div", {
      class: pe([a.value, v.$attrs.class])
    }, [
      ne("label", {
        class: "lc-textarea__wrap",
        for: j(o)
      }, [
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(o)}-label`,
          class: pe(l.value)
        }, Oe(e.label), 11, R1)) : se("", !0),
        Qt(ne("textarea", Ce({
          id: j(o),
          ref: "textarea"
        }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${j(o)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, F1), [
          [ec, h.value]
        ])
      ], 8, M1),
      ne("div", N1, [
        e.noFeedback ? se("", !0) : ($(), we(j($n), Ce({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ne("span", P1, [
          ne("span", null, Oe(s.value) + "/" + Oe(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), B1 = "info", tb = ["danger", "info", "success", "warning", "win"], z1 = { class: "lc-toast__indicator" }, V1 = { class: "lc-toast__content" }, H1 = {
  key: 0,
  class: "lc-toast__title"
}, U1 = {
  key: 0,
  class: "lc-toast__text"
}, nb = /* @__PURE__ */ ke({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: () => B1 }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), Z("article", {
      class: pe(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ne("aside", z1, [
        Re(j(et), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ne("section", V1, [
        e.headline ? ($(), Z("span", H1, Oe(e.headline), 1)) : se("", !0),
        ve(n.$slots, "default", {}, () => [
          e.text ? ($(), Z("p", U1, Oe(e.text), 1)) : se("", !0)
        ])
      ]),
      e.closable ? ($(), we(j(Ct), {
        key: 0,
        "aria-label": j(je).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (o) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : se("", !0)
    ], 2));
  }
}), q1 = ["left", "right"], Cs = 0.4, j1 = 0.75, co = 0.85, Z1 = 0.2, uo = 150, W1 = 8, X1 = Cs, Y1 = 400, G1 = 1800, K1 = 300, J1 = "cubic-bezier(0.22, 1, 0.36, 1)", Q1 = "cubic-bezier(0.4, 0, 0.2, 1)", eg = {
  key: 1,
  class: "lc-swipeable__action-label"
}, ab = /* @__PURE__ */ ke({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ft("lcSwipeableRef"), i = cn(), a = ge(null), s = ge(0), l = ge(0), h = ge(0), v = ge(!1), u = ge(!1), f = ge(!1), m = ge(!1), c = ge(!1), p = ge(null), x = ge(!1), g = ge(null);
    let b = 0, C = null, A = null, I = 0;
    const { direction: L, distanceX: T } = sc(o, {
      onSwipe: () => {
        if (g.value === null || e.disabled || c.value || !o.value)
          return;
        v.value || re();
        const me = o.value.clientWidth, Be = l.value - T.value, ze = X(Be);
        if (ze && !_(ze)) {
          s.value = 0;
          return;
        }
        const Ke = M(ze), Je = q(Be, me, E(ze));
        m.value = U(me, Ke), h.value = Math.min(1, Math.abs(T.value) / (me * Ke));
        const ht = !!(ze && V(ze)?.fullSwipe && m.value);
        fe(ht), be(ze), s.value = ht && ze ? oe(ze, me) : Je, ze && ze !== a.value && Se(ze);
      },
      onSwipeEnd: (me, Be) => qe(Be),
      pointerTypes: e.pointerTypes,
      threshold: W1
    }), P = W(() => q1.map((me) => ({ action: V(me), side: me }))), H = W(() => v.value && !u.value), Q = W(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": H.value }
    ]), N = W(() => ({
      transform: `translateX(${s.value}px)`,
      ...p.value === null ? {} : { transition: p.value }
    })), G = W(() => co + (1 - co) * h.value), V = (me) => me === "left" ? e.leftAction : me === "right" ? e.rightAction : void 0, _ = (me) => !!(V(me) || i[`${me}-action`]), E = (me) => V(me)?.resistanceThreshold ?? j1, M = (me) => {
      const Be = V(me);
      return Be?.fullSwipe ? E(me) : Be?.activationThreshold ?? Cs;
    }, z = () => {
      if (!o.value) return 0;
      const me = o.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!me) return 0;
      const Be = getComputedStyle(me).transform;
      if (!Be || Be === "none") return 0;
      const ze = new DOMMatrix(Be).m41;
      return Number.isFinite(ze) ? ze : 0;
    }, q = (me, Be, ze) => {
      const Ke = Be * ze, Je = Math.abs(me);
      if (Je <= Ke) return me;
      const ht = Be * Z1, tt = (1 - 1 / ((Je - Ke) / ht + 1)) * ht;
      return Math.sign(me) * (Ke + tt);
    }, X = (me) => me < 0 ? "left" : me > 0 ? "right" : null, U = (me, Be) => Math.abs(T.value) >= me * Be, oe = (me, Be) => me === "left" ? -Be : Be, re = () => {
      l.value = z(), v.value = !0, g.value !== null && De(g.value);
    }, fe = (me) => {
      me !== f.value && (f.value = me, u.value = !0, b = performance.now());
    }, be = (me) => {
      !u.value || f.value || !(performance.now() - b >= uo) && me === a.value || (u.value = !1);
    }, Se = (me) => {
      a.value = me, x.value = !0, r("swipe-start", me);
    }, de = () => {
      !x.value || !a.value || (x.value = !1, r("swipe-end", a.value));
    }, ye = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, Ae = (me) => !e.pointerTypes || e.pointerTypes.includes(me.pointerType), De = (me) => {
      o.value?.setPointerCapture?.(me);
    }, We = (me) => {
      o.value?.hasPointerCapture?.(me) && o.value.releasePointerCapture(me);
    }, Ne = () => {
      C !== null && (clearTimeout(C), C = null);
    }, ue = () => {
      Ne(), g.value === null && (a.value = null);
    }, Fe = () => {
      Ne(), C = setTimeout(ue, uo);
    }, qe = (me) => {
      if (g.value === null) return;
      We(g.value), g.value = null, de();
      const Be = f.value;
      ye(), m.value = !1;
      const ze = !e.disabled && (me === "left" || me === "right") && _(me) && o.value !== null && U(o.value.clientWidth, M(me));
      (!ze || !Be) && (s.value = 0), (!ze || !Be) && Fe(), ze && r("trigger", me);
    }, Ze = () => {
      u.value = !1, g.value === null && s.value === 0 && ue();
    }, Xe = () => {
      A !== null && (clearTimeout(A), A = null);
    }, Ve = () => {
      I += 1, Xe(), c.value = !1, p.value = null;
    }, Pe = (me) => new Promise((Be) => {
      A = setTimeout(() => {
        A = null, Be();
      }, me);
    }), rt = async (me, Be = {}) => {
      const ze = o.value;
      if (!ze || !_(me)) return;
      const {
        distance: Ke = ze.clientWidth * X1,
        hold: Je = G1,
        slideBack: ht = K1,
        slideOut: vt = Y1
      } = Be;
      Ve();
      const tt = ++I;
      Ne(), c.value = !0, a.value = me, p.value = `transform ${vt}ms ${J1}`, s.value = (me === "left" ? -1 : 1) * Ke, await Pe(vt + Je), tt === I && (p.value = `transform ${ht}ms ${Q1}`, s.value = 0, await Pe(ht), tt === I && (c.value = !1, p.value = null, ue()));
    }, ct = () => {
      Ve();
      const me = a.value, Be = x.value;
      g.value !== null && (We(g.value), g.value = null), ye(), s.value = 0, m.value = !1, x.value = !1, Be && me && r("swipe-end", me), Fe();
    };
    return qt(o, "pointerdown", (me) => {
      Ae(me) && (Ne(), Ve(), g.value = me.pointerId);
    }), qt(window, ["pointerup", "pointercancel"], (me) => {
      me.pointerId === g.value && qe(L.value);
    }), qt(window, "pointermove", (me) => {
      g.value !== null && (me.pointerType !== "mouse" || me.buttons !== 0 || qe(L.value));
    }), qt(o, "pointercancel", ct), He(
      () => e.disabled,
      (me) => {
        me && ct();
      }
    ), li(() => {
      Ne(), Ve();
    }), t({ close: ct, preview: rt }), (me, Be) => ($(), Z("div", {
      ref_key: "lcSwipeableRef",
      ref: o,
      class: pe([
        "lc-swipeable",
        {
          "lc-swipeable--disabled": e.disabled,
          "lc-swipeable--dragging": H.value
        }
      ])
    }, [
      ($(!0), Z(at, null, yt(P.value, ({ side: ze, action: Ke }) => ($(), Z(at, { key: ze }, [
        Ke || me.$slots[`${ze}-action`] ? ($(), Z("div", {
          key: 0,
          class: pe([
            "lc-swipeable__action",
            `lc-swipeable__action--${ze}`,
            {
              "lc-swipeable__action--hidden": a.value !== ze,
              "lc-swipeable__action--dragging": H.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ze
            }
          ])
        }, [
          ve(me.$slots, `${ze}-action`, {}, () => [
            Ke ? ($(), Z("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Et(a.value === ze ? { transform: `scale(${G.value})` } : void 0)
            }, [
              Re(j(et), {
                name: Ke.icon
              }, null, 8, ["name"])
            ], 4)) : se("", !0),
            Ke?.label ? ($(), Z("span", eg, Oe(Ke.label), 1)) : se("", !0)
          ])
        ], 2)) : se("", !0)
      ], 64))), 128)),
      ne("div", {
        class: pe(Q.value),
        style: Et(N.value),
        onTransitionend: sa(Ze, ["self"])
      }, [
        ve(me.$slots, "default")
      ], 38)
    ], 2));
  }
}), tg = { class: "lc-lottery-remaining-picks__headline" }, ng = { class: "lc-lottery-remaining-picks__done" }, ag = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, rg = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, ig = /* @__PURE__ */ ke({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => je.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = ge(!1);
    He(
      () => e.complete,
      (r, o) => {
        r && !o ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const o = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === o && (t.value = !1);
    };
    return (r, o) => ($(), Z("div", {
      class: pe([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ne("div", tg, [
        ve(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ne("div", ng, [
        ne("span", ag, [
          Re(j(et), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), Z("span", rg, Oe(e.doneLabel), 1)) : se("", !0)
      ])
    ], 34));
  }
}), lg = ["aria-hidden"], og = ["aria-hidden"], sg = {
  key: 0,
  class: "lc-lottery-editor-card__labels"
}, cg = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, ug = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, dg = { class: "lc-lottery-editor-card__footer" }, fg = "medium", rb = /* @__PURE__ */ ke({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ _n({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => je.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    numberClass: { type: Function },
    quickPickLabel: { default: () => je.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    removable: { type: Boolean, default: !1 },
    removeAriaLabel: { default: () => je.lcLotteryEditorCard.removeAriaLabel },
    toggleAriaLabel: { default: () => je.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "remove", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Xa(e, "expanded"), o = () => {
      e.removable && n("remove");
    }, i = ft("summary"), a = ft("numbers"), s = (m) => a.value?.$el?.querySelector(m) ?? void 0, l = W(() => s(".lc-lottery-numbers__number")), { width: h } = qr(i), { width: v } = qr(l), u = W(
      () => e.fields?.reduce((m, { numbers: c }) => m + c.length, 0) ?? 0
    ), f = W(() => {
      if (!h.value || !v.value || !u.value) return;
      const m = s(".lc-lottery-numbers__list"), c = m && parseFloat(getComputedStyle(m).columnGap) || 0, p = Math.max(
        1,
        Math.floor((h.value + c) / (v.value + c))
      ), x = Math.ceil(u.value / p);
      return x > 1 ? x : void 0;
    });
    return (m, c) => ($(), we(j(ya), Ce({
      modelValue: r.value,
      "onUpdate:modelValue": c[2] || (c[2] = (p) => r.value = p),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: [
        "lc-lottery-editor-card",
        {
          "lc-lottery-editor-card--removable": e.removable,
          "lc-lottery-editor-card--separated": e.separated
        }
      ],
      expandable: !e.removable,
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }, {
      onCollapse: c[3] || (c[3] = (p) => n("collapse")),
      onCollapsed: c[4] || (c[4] = (p) => n("collapsed")),
      onExpand: c[5] || (c[5] = (p) => n("expand")),
      onExpanded: c[6] || (c[6] = (p) => n("expanded"))
    }), {
      header: _e(() => [
        ($(), we(Nt(e.removable ? "button" : "div"), {
          "aria-label": e.removable ? e.removeAriaLabel : void 0,
          class: pe([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ]),
          type: e.removable ? "button" : void 0,
          onClick: o
        }, {
          default: _e(() => [
            ne("div", {
              "aria-hidden": !r.value,
              class: "lc-lottery-editor-card__expanded"
            }, [
              Re(j(ig), $t(Rt({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
                default: _e(({ countClass: p }) => [
                  ve(m.$slots, "headline", $t(Rt({ countClass: p })))
                ]),
                _: 3
              }, 16)
            ], 8, lg),
            ne("div", {
              ref: "summary",
              "aria-hidden": r.value,
              class: "lc-lottery-editor-card__summary"
            }, [
              ve(m.$slots, "summary", {}, () => [
                e.fields ? ($(), we(j(cv), Ce({
                  key: 0,
                  ref: "numbers"
                }, { fields: e.fields, numberClass: e.numberClass }, {
                  rows: f.value,
                  size: fg
                }), null, 16, ["rows"])) : se("", !0)
              ]),
              e.wager || e.betType ? ($(), Z("div", sg, [
                e.wager ? ($(), Z("span", cg, Oe(e.wager), 1)) : se("", !0),
                e.betType ? ($(), Z("span", ug, Oe(e.betType), 1)) : se("", !0)
              ])) : se("", !0)
            ], 8, og)
          ]),
          _: 3
        }, 8, ["aria-label", "class", "type"])),
        e.removable ? ($(), we(j(et), {
          key: 0,
          class: "lc-lottery-editor-card__remove",
          name: "trash-full"
        })) : se("", !0)
      ]),
      footer: _e(() => [
        ne("div", dg, [
          Re(j(Ct), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "clear",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: c[0] || (c[0] = (p) => n("clear"))
          }, {
            default: _e(() => [
              Tt(Oe(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Re(j(Ct), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: c[1] || (c[1] = (p) => n("quick-pick"))
          }, {
            default: _e(() => [
              Tt(Oe(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _e(() => [
        e.separated ? ($(), we(j(fi), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : se("", !0),
        ve(m.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "expandable", "header-class"]));
  }
});
export {
  Ko as AmplitudeEvents,
  Bt as FORM_FIELD_EVENTS,
  Dg as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  Nu as LC_BUTTON_DEFAULT_ICON_POSITION,
  Pu as LC_BUTTON_DEFAULT_SIZE,
  Bu as LC_BUTTON_DEFAULT_VARIANT,
  wg as LC_BUTTON_ICON_POSITIONS,
  xg as LC_BUTTON_SIZES,
  Sg as LC_BUTTON_TRIGGERS,
  kg as LC_BUTTON_TYPES,
  _g as LC_BUTTON_VARIANTS,
  Cg as LC_CARD_RADII,
  Tg as LC_CARD_SHADOWS,
  Ag as LC_CARD_VARIANTS,
  Mg as LC_CAROUSEL_MOVE_TRIGGERS,
  Og as LC_CAROUSEL_VARIANTS,
  Fg as LC_COUNTDOWN_VARIANTS,
  Yg as LC_FORM_FIELD_INTERACTION_MODES,
  vc as LC_ICON_DEFAULT_SIZE,
  bg as LC_ICON_NAMES,
  gg as LC_ICON_SIZES,
  Qg as LC_INFO_BUTTON_VARIANTS,
  Uh as LC_INFO_TEXT_DEFAULT_ICON_SIZE,
  qh as LC_INFO_TEXT_DEFAULT_SIZE,
  o2 as LC_INFO_TEXT_ICON_ALIGNMENTS,
  s2 as LC_INFO_TEXT_SIZES,
  zg as LC_INPUT_MODES,
  Vg as LC_INPUT_TYPES,
  f2 as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  Jg as LC_LOTTERY_JACPOT_SIZES,
  m2 as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  h2 as LC_LOTTERY_NUMBER_SIZES,
  v2 as LC_LOTTERY_NUMBER_SPACINGS,
  p2 as LC_LOTTERY_TEASER_VARIANTS,
  w2 as LC_MENU_BUTTON_PLACEMENTS,
  hm as LC_MESSAGE_BOX_DEFAULT_SIZE,
  vm as LC_MESSAGE_BOX_DEFAULT_VARIANT,
  k2 as LC_MESSAGE_BOX_SIZES,
  S2 as LC_MESSAGE_BOX_VARIANTS,
  Lg as LC_MODAL_CLOSE_TRIGGERS,
  $g as LC_MODAL_SPACINGS,
  T2 as LC_PASSWORD_INPUT_TYPES,
  Cm as LC_PROGRESS_INDICATOR_DEFAULT_PROGRESS,
  Tm as LC_PROGRESS_INDICATOR_DEFAULT_SIZE,
  A2 as LC_PROGRESS_INDICATOR_SIZES,
  L2 as LC_PROGRESS_INDICATOR_VARIANTS,
  O2 as LC_RADIO_GROUP_LAYOUTS,
  P2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  z2 as LC_SELECT_LIST_VARIANTS,
  Wu as LC_SEPARATOR_DEFAULT_VARIANT,
  Eg as LC_SEPARATOR_VARIANTS,
  R2 as LC_SKELETON_RADII,
  _1 as LC_SWITCH_DEFAULT_ICON,
  q2 as LC_SWITCH_VARIANTS,
  W2 as LC_TABLE_PADDINGS,
  X2 as LC_TABS_FLEX_DIRECTIONS,
  Y2 as LC_TABS_NAVIGATION_POSITIONS,
  G2 as LC_TABS_TRIGGERS,
  K2 as LC_TABS_VARIANTS,
  e2 as LC_TEASER_BACKGROUND_PATTERNS,
  t2 as LC_TEASER_BADGE_VARIANTS,
  n2 as LC_TEASER_HERO_BADGE_VARIANTS,
  ts as LC_TEASER_VARIANTS,
  B1 as LC_TOAST_DEFAULT_VARIANT,
  tb as LC_TOAST_VARIANTS,
  pg as LcBadge,
  Ig as LcBottomSheet,
  Ct as LcButton,
  Xr as LcButtonActiveKeys,
  ya as LcCard,
  df as LcCarousel,
  Ma as LcCarouselActiveKeys,
  Rg as LcCheckbox,
  jr as LcCountBubble,
  pf as LcCountdown,
  Ng as LcDataList,
  Pg as LcDataListItem,
  Hg as LcDateInput,
  Ug as LcDescriptionList,
  qg as LcDigitInput,
  ln as LcDigitInputActiveKeys,
  jg as LcDigitInputGroup,
  Xf as LcExpandable,
  Zg as LcExpandableList,
  Wg as LcFlyOut,
  Xg as LcForm,
  Gg as LcFormField,
  Kg as LcHeader,
  v0 as LcHighFrequencyBall,
  Jo as LcHighFrequencyBallBackground,
  a2 as LcHighFrequencyTeaser,
  r2 as LcHighFrequencyTeaserWatch,
  et as LcIcon,
  l2 as LcImage,
  es as LcInfoButton,
  c2 as LcInfoText,
  nr as LcInput,
  u2 as LcLinkList,
  d2 as LcLinkListItem,
  jl as LcLotteryCutoffTime,
  rb as LcLotteryEditorCard,
  Qo as LcLotteryJackpot,
  g2 as LcLotteryNumberSelector,
  Zt as LcLotteryNumberSelectorActiveKeys,
  cv as LcLotteryNumbers,
  ig as LcLotteryRemainingPicks,
  b2 as LcLotteryTeaser,
  y2 as LcMaskedValueDisplay,
  x2 as LcMenuButton,
  Ut as LcMenuButtonActiveKeys,
  _2 as LcMessageBox,
  No as LcModal,
  E2 as LcMoneyInput,
  C2 as LcPasswordInput,
  $2 as LcProgressIndicator,
  Om as LcRadio,
  I2 as LcRadioCard,
  D2 as LcRadioGroup,
  M2 as LcRating,
  F2 as LcRemoteList,
  N2 as LcScratchcardTeaser,
  B2 as LcSelect,
  Gt as LcSelectActiveKeys,
  V2 as LcSelectList,
  Wt as LcSelectListActiveKeys,
  fi as LcSeparator,
  Pm as LcSkeleton,
  H2 as LcSlider,
  U2 as LcSlotWheel,
  ab as LcSwipeable,
  j2 as LcSwitch,
  Z2 as LcTable,
  Q2 as LcTabs,
  Nn as LcTabsActiveKeys,
  ar as LcTeaser,
  F0 as LcTeaserBadge,
  P0 as LcTeaserHeroBadge,
  ns as LcTeaserHeroBadgeColor,
  eb as LcTextarea,
  nb as LcToast,
  Jr as carouselContext,
  je as globalConfig,
  B0 as isHeroBadge,
  wu as nuxtAppContext,
  yg as setGlobalConfig,
  J2 as tabContext
};
